<!-- In Progress start -->
<ng-container
  *ngIf="rfqItem?.status == RFQStatus.QUOTE_IN_PROGRESS && !Sendarchive"
>
  <div class="rfqHeader">
    <div class="flex align-items-center">
      <h3 matTooltip="{{ rfqItem?.projectName }}">
        {{ rfqItem?.projectName }}
      </h3>
      <span class="info_bar">{{
        getRFQTemplateLabel(rfqItem?.rfqTemplate)
      }}</span>
      <span
        class="rfqOthersText"
        *ngIf="
          rfqItem?.othersText && rfqItem?.rfqTemplate == templateType.Others
        "
        >({{ rfqItem.othersText }})</span
      >
    </div>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_1"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>

      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>

          <div class="rfqInfo col-lg-4 col-md-4">
            <h4>Category</h4>
            <div class="category-chips-and-more">
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>

              <span
                (click)="isMoreExpanded = true"
                *ngIf="!isMoreExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>
        <div *ngIf="isMoreExpanded" class="mt-10">
          <h4>Sub-Category</h4>
          <div class="category-chips-and-more">
            <mat-chip
              *ngFor="
                let cat of (
                  (rfqItem?.createdByShop
                    ? rfqItem?.mroSubCategory
                    : rfqItem?.subCategory
                  ) | categoryFormatter : 2
                ).display
              "
            >
              <span
                class="capability"
                [matTooltip]="
                  (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroSubCategory
                      : rfqItem?.subCategory
                    ) | categoryFormatter : 2
                  ).tooltip
                "
              >
                {{ cat }}
              </span>
            </mat-chip>
          </div>
          <h4 *ngIf="rfqItem?.materials.length != 0">Materials</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let material of (rfqItem?.materials | categoryFormatter : 10)
                    .display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (rfqItem?.materials | categoryFormatter : 10).tooltip
                  "
                >
                  {{ material }}
                </span>
              </mat-chip>
            </div>
            <span (click)="isMoreExpanded = false" class="more-less-button">
              <mat-icon>expand_less</mat-icon></span
            >
          </div>
        </div>
        <div
          class="col-lg-12 col-md-12 col-sm-12"
          *ngIf="!rfqItem?.createdByShop"
        >
          <div class="step-2">
            <div class="step_heading">
              <h4 class="step-title pb-5">
                New Attachments:
                <span class="attach" *ngIf="files.length > 0">
                  <span class="icon"> </span>
                  {{ files.length || 0 }}
                  file(s)
                </span>
              </h4>
              <div class="icon">
                <span
                  ><svg
                    (click)="navExpantion()"
                    *ngIf="isExpanded"
                    xmlns="http://www.w3.org/2000/svg"
                    class="badge-notfication"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path
                      d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                    /></svg
                ></span>

                <svg
                  (click)="closeNavExpantion()"
                  *ngIf="!isExpanded"
                  xmlns="http://www.w3.org/2000/svg"
                  class=""
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path
                    d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                  />
                </svg>
              </div>
            </div>

            <div
              class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
              appDnd
              #fileDropRef
              id="fileDropRef"
              *ngIf="isExpanded"
              (fileDropped)="onFileDropped($event)"
            >
              <input
                id="modules_rfq_rfqquote_2"
                type="file"
                #fileSelector
                multiple
                (change)="fileBrowseHandler($event)"
                accept=".xlsx"
                style="display: none"
              />
              <h4 class="file-uploader-label">Upload New Files</h4>
              <p class="file-uploader-size-label">(Max file size: 100MB)</p>
              <p class="file-uploader-drag-drop-label">
                Drag & Drop .xlsx File Or
              </p>

              <p class="choose-file-button" (click)="chooseFiles()">
                Choose File
              </p>
            </div>
            <div class="files-list" *ngIf="files.length > 0">
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of files; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="iocn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4 matTooltip="{{ getFileName(file?.name) }}" class="name">
                    {{ getFileName(file?.name) }}
                  </h4>
                </div>

                <div>
                  <p>{{ getFileExt(file?.name) }}</p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(file?.size) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="deleteFile(i)"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="files-list">
              <h3 class="pb-3">
                Last Uploaded: {{ rfqItem.attachments?.length || 0 }} Files
              </h3>

              <div *ngFor="let files of getFileTypes(); let i = index">
                <h3 class="font-12 medium">
                  {{ getFileTypeLabel(files.key) }}
                </h3>
                <div *ngIf="files.value">
                  <div
                    class="single-file flex justify-content-between"
                    *ngFor="let file of files.value"
                  >
                    <div class="rfq-item rfq-icon">
                      <span class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5589_19343"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5589_19343)">
                            <path
                              d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                              fill="#333333"
                            />
                          </g>
                        </svg>
                      </span>

                      <h4
                        title="{{ getFileName(file?.name || file?.fileName) }}"
                        class="name"
                      >
                        {{ getFileName(file?.name || file?.fileName) }}
                      </h4>
                    </div>

                    <div>
                      <p
                        class="type"
                        title="{{ getFileExt(file?.name || file?.fileName) }}"
                      >
                        {{ getFileExt(file?.name || file?.fileName) }}
                      </p>
                    </div>

                    <div>
                      <p class="size">{{ file.size }}</p>
                    </div>

                    <div>
                      <p class="size">
                        {{ file.createdOn | date : "MMM d, y" }}
                      </p>
                    </div>
                    <div class="delete-icon" (click)="saveFile(file)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                          fill="#666666"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="swiftQuote"
          *ngIf="
            rfqItem.status == 'QUOTE_READY' &&
            rfqItem?.rfqTemplate != templateType.InDirectMRO
          "
        >
          <div class="swiftIco">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="76"
              height="84"
              viewBox="0 0 76 84"
              fill="none"
            >
              <g opacity="0.7">
                <mask id="path-1-inside-1_8603_34903" fill="white">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  />
                </mask>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  fill="#999999"
                />
                <path
                  d="M67.2 68.6H67.05V68.75H67.2V68.6ZM67.2 67.7988H67.35V67.6184L67.1727 67.6513L67.2 67.7988ZM75.6 68.6H75.75V68.45H75.6V68.6ZM67.2 78.4V78.25H67.05V78.4H67.2ZM67.2 44.2012L67.1727 44.3487L67.35 44.3816V44.2012H67.2ZM64.4 44.0147H64.25V44.1723L64.4074 44.1646L64.4 44.0147ZM11.2 68.6V68.45H11.05V68.6H11.2ZM64.4 68.6V68.75H64.55V68.6H64.4ZM64.4 67.9853L64.4074 67.8354L64.25 67.8277V67.9853H64.4ZM56.4303 64.4V64.55H56.7874L56.5374 64.295L56.4303 64.4ZM54.3841 61.6L54.5167 61.5299L54.4745 61.45H54.3841V61.6ZM44.8 64.4H44.65V64.55H44.8V64.4ZM44.8 61.6V61.45H44.65V61.6H44.8ZM53 56H53.15V55.85H53V56ZM37.7999 56V55.85H37.6499V56H37.7999ZM37.7999 58.8H37.6499V58.95H37.7999V58.8ZM53.3284 58.8V58.95H53.5185L53.4743 58.7652L53.3284 58.8ZM60.2 44.9985L60.2601 45.1359L60.35 45.0966V44.9985H60.2ZM60.2 19.6H60.35V19.45H60.2V19.6ZM7.00004 19.6V19.45H6.85004V19.6H7.00004ZM7.00004 53.2H6.85004V53.35H7.00004V53.2ZM53.3284 53.2V53.35H53.4468L53.4743 53.2349L53.3284 53.2ZM54.3841 50.4L54.5167 50.4701L54.633 50.25H54.3841V50.4ZM47.6 50.4H47.45V50.55H47.6V50.4ZM47.6 29.4V29.25H47.45V29.4H47.6ZM57.4 29.4H57.55V29.25H57.4V29.4ZM57.4 46.713H57.25V47.0298L57.4951 46.829L57.4 46.713ZM64.4 78.4H64.55V78.25H64.4V78.4ZM2.8 77L2.89028 76.8802L2.65 76.6991V77H2.8ZM12.6 75.6L12.4802 75.5097L12.2991 75.75H12.6V75.6ZM72.8 71.4H72.95V71.25H72.8V71.4ZM14 71.4V71.25H13.85V71.4H14ZM30.8 50.4V50.55H30.95V50.4H30.8ZM9.80005 50.4H9.65005V50.55H9.80005V50.4ZM30.8 29.4H30.95V29.25H30.8V29.4ZM9.80005 29.4V29.25H9.65005V29.4H9.80005ZM30.8 26.6V26.75H30.95V26.6H30.8ZM9.80005 26.6H9.65005V26.75H9.80005V26.6ZM30.8 22.4H30.95V22.25H30.8V22.4ZM9.80005 22.4V22.25H9.65005V22.4H9.80005ZM44.8 50.4V50.55H44.95V50.4H44.8ZM33.6 50.4H33.45V50.55H33.6V50.4ZM44.8 29.4H44.95V29.25H44.8V29.4ZM33.6 29.4V29.25H33.45V29.4H33.6ZM44.8 26.6V26.75H44.95V26.6H44.8ZM33.6 26.6H33.45V26.75H33.6V26.6ZM44.8 22.4H44.95V22.25H44.8V22.4ZM33.6 22.4V22.25H33.45V22.4H33.6ZM57.4 26.6V26.75H57.55V26.6H57.4ZM47.6 26.6H47.45V26.75H47.6V26.6ZM57.4 22.4H57.55V22.25H57.4V22.4ZM47.6 22.4V22.25H47.45V22.4H47.6ZM46.2001 6.99998V6.84998H46.05V6.99998H46.2001ZM49 6.99998H49.1501V6.84998H49V6.99998ZM46.2001 9.79998H46.05V9.94998H46.2001V9.79998ZM49 9.79998V9.94998H49.1501V9.79998H49ZM60.2 6.99998H60.35V6.84998H60.2V6.99998ZM51.8 6.99998V6.84998H51.65V6.99998H51.8ZM60.2 9.79998V9.94998H60.35V9.79998H60.2ZM51.8 9.79998H51.65V9.94998H51.8V9.79998ZM46.2001 12.6V12.45H46.05V12.6H46.2001ZM60.2001 12.6H60.3501V12.45H60.2001V12.6ZM46.2001 15.4H46.05V15.55H46.2001V15.4ZM60.2001 15.4V15.55H60.3501V15.4H60.2001ZM18.2 6.99998H18.35V6.84998H18.2V6.99998ZM7.00004 6.99998V6.84998H6.85004V6.99998H7.00004ZM18.2 9.79998V9.94998H18.35V9.79998H18.2ZM7.00004 9.79998H6.85004V9.94998H7.00004V9.79998ZM7.00004 12.6V12.45H6.85004V12.6H7.00004ZM21 12.6H21.15V12.45H21V12.6ZM7.00004 15.4H6.85004V15.55H7.00004V15.4ZM21 15.4V15.55H21.15V15.4H21ZM7.00004 56V55.85H6.85004V56H7.00004ZM21 56H21.15V55.85H21V56ZM7.00004 58.8H6.85004V58.95H7.00004V58.8ZM21 58.8V58.95H21.15V58.8H21ZM12.6 32.2V32.05H12.45V32.2H12.6ZM25.2 32.2H25.35V32.05H25.2V32.2ZM12.6 35H12.45V35.15H12.6V35ZM25.2 35V35.15H25.35V35H25.2ZM21 37.8H21.15V37.65H21V37.8ZM12.6 37.8V37.65H12.45V37.8H12.6ZM21 40.6V40.75H21.15V40.6H21ZM12.6 40.6H12.45V40.75H12.6V40.6ZM12.6 43.4V43.25H12.45V43.4H12.6ZM21 43.4H21.15V43.25H21V43.4ZM12.6 46.2H12.45V46.35H12.6V46.2ZM21 46.2V46.35H21.15V46.2H21ZM42 32.2H42.15V32.05H42V32.2ZM36.4 32.2V32.05H36.25V32.2H36.4ZM42 35V35.15H42.15V35H42ZM36.4 35H36.25V35.15H36.4V35ZM36.4 37.8V37.65H36.25V37.8H36.4ZM42 37.8H42.15V37.65H42V37.8ZM36.4 40.6H36.25V40.75H36.4V40.6ZM42 40.6V40.75H42.15V40.6H42ZM42 43.4H42.15V43.25H42V43.4ZM36.4 43.4V43.25H36.25V43.4H36.4ZM42 46.2V46.35H42.15V46.2H42ZM36.4 46.2H36.25V46.35H36.4V46.2ZM50.4 32.2V32.05H50.25V32.2H50.4ZM54.6 32.2H54.75V32.05H54.6V32.2ZM50.4 35H50.25V35.15H50.4V35ZM54.6 35V35.15H54.75V35H54.6ZM54.6 37.8H54.75V37.65H54.6V37.8ZM50.4 37.8V37.65H50.25V37.8H50.4ZM54.6 40.6V40.75H54.75V40.6H54.6ZM50.4 40.6H50.25V40.75H50.4V40.6ZM50.4 43.4V43.25H50.25V43.4H50.4ZM54.6 43.4H54.75V43.25H54.6V43.4ZM50.4 46.2H50.25V46.35H50.4V46.2ZM54.6 46.2V46.35H54.75V46.2H54.6ZM67.35 68.6V67.7988H67.05V68.6H67.35ZM75.6 68.45H67.2V68.75H75.6V68.45ZM75.75 71.4V68.6H75.45V71.4H75.75ZM68.6 78.55C72.5503 78.55 75.75 75.3503 75.75 71.4H75.45C75.45 75.1847 72.3847 78.25 68.6 78.25V78.55ZM67.2 78.55H68.6V78.25H67.2V78.55ZM67.35 79.8V78.4H67.05V79.8H67.35ZM63 84.15C65.3928 84.15 67.35 82.1928 67.35 79.8H67.05C67.05 82.0272 65.2272 83.85 63 83.85V84.15ZM4.2 84.15H63V83.85H4.2V84.15ZM-0.15 79.8C-0.15 82.1928 1.80716 84.15 4.2 84.15V83.85C1.97284 83.85 0.15 82.0272 0.15 79.8H-0.15ZM-0.15 4.2V79.8H0.15V4.2H-0.15ZM4.2 -0.15C1.80716 -0.15 -0.15 1.80716 -0.15 4.2H0.15C0.15 1.97284 1.97284 0.15 4.2 0.15V-0.15ZM63 -0.15H4.2V0.15H63V-0.15ZM67.35 4.2C67.35 1.80716 65.3928 -0.15 63 -0.15V0.15C65.2272 0.15 67.05 1.97284 67.05 4.2H67.35ZM67.35 44.2012V4.2H67.05V44.2012H67.35ZM65 44.15C65.7423 44.15 66.4684 44.2182 67.1727 44.3487L67.2273 44.0537C66.5052 43.9199 65.7607 43.85 65 43.85V44.15ZM64.4074 44.1646C64.6037 44.1549 64.8013 44.15 65 44.15V43.85C64.7963 43.85 64.5938 43.855 64.3926 43.8649L64.4074 44.1646ZM64.25 4.2V44.0147H64.55V4.2H64.25ZM63 2.95C63.6872 2.95 64.25 3.51284 64.25 4.2H64.55C64.55 3.34716 63.8528 2.65 63 2.65V2.95ZM4.2 2.95H63V2.65H4.2V2.95ZM2.95 4.2C2.95 3.51284 3.51284 2.95 4.2 2.95V2.65C3.34716 2.65 2.65 3.34716 2.65 4.2H2.95ZM2.95 71.4V4.2H2.65V71.4H2.95ZM7 75.45C4.75534 75.45 2.95 73.6447 2.95 71.4H2.65C2.65 73.8103 4.58966 75.75 7 75.75V75.45ZM11.05 71.4C11.05 73.6447 9.24466 75.45 7 75.45V75.75C9.41034 75.75 11.35 73.8103 11.35 71.4H11.05ZM11.05 68.6V71.4H11.35V68.6H11.05ZM64.4 68.45H11.2V68.75H64.4V68.45ZM64.25 67.9853V68.6H64.55V67.9853H64.25ZM65 67.85C64.8013 67.85 64.6037 67.8451 64.4074 67.8354L64.3926 68.1351C64.5938 68.145 64.7963 68.15 65 68.15V67.85ZM67.1727 67.6513C66.4684 67.7818 65.7423 67.85 65 67.85V68.15C65.7607 68.15 66.5052 68.0801 67.2273 67.9463L67.1727 67.6513ZM56.5374 64.295C55.7378 63.4793 55.0551 62.5485 54.5167 61.5299L54.2515 61.6701C54.8036 62.7146 55.5034 63.6688 56.3232 64.505L56.5374 64.295ZM44.8 64.55H56.4303V64.25H44.8V64.55ZM44.65 61.6V64.4H44.95V61.6H44.65ZM54.3841 61.45H44.8V61.75H54.3841V61.45ZM53 55.85L37.7999 55.85V56.15L53 56.15V55.85ZM37.6499 56V58.8H37.9499V56H37.6499ZM37.7999 58.95H53.3284V58.65H37.7999V58.95ZM53.4743 58.7652C53.2623 57.8782 53.15 56.9523 53.15 56H52.85C52.85 56.976 52.9651 57.9252 53.1825 58.8349L53.4743 58.7652ZM60.35 44.9985V19.6H60.05V44.9985H60.35ZM60.2 19.45H7.00004V19.75H60.2V19.45ZM6.85004 19.6V53.2H7.15004V19.6H6.85004ZM7.00004 53.35H53.3284V53.05H7.00004V53.35ZM53.4743 53.2349C53.7071 52.2611 54.06 51.334 54.5167 50.4701L54.2515 50.3299C53.7832 51.2157 53.4212 52.1665 53.1825 53.1651L53.4743 53.2349ZM54.3841 50.25H47.6V50.55H54.3841V50.25ZM47.75 50.4V29.4H47.45V50.4H47.75ZM47.6 29.55H57.4V29.25H47.6V29.55ZM57.25 29.4V46.713H57.55V29.4H57.25ZM57.4951 46.829C58.3295 46.1454 59.2587 45.5734 60.2601 45.1359L60.14 44.861C59.1131 45.3097 58.1603 45.8961 57.305 46.5969L57.4951 46.829ZM64.25 79.8C64.25 80.4872 63.6872 81.05 63 81.05V81.35C63.8528 81.35 64.55 80.6528 64.55 79.8H64.25ZM64.25 78.4V79.8H64.55V78.4H64.25ZM7 78.55H64.4V78.25H7V78.55ZM2.70972 77.1198C3.94343 78.0495 5.44517 78.55 7 78.55V78.25C5.50983 78.25 4.07157 77.7705 2.89028 76.8802L2.70972 77.1198ZM2.95 79.8V77H2.65V79.8H2.95ZM4.2 81.05C3.51284 81.05 2.95 80.4872 2.95 79.8H2.65C2.65 80.6528 3.34716 81.35 4.2 81.35V81.05ZM63 81.05H4.2V81.35H63V81.05ZM68.6 75.45H12.6V75.75H68.6V75.45ZM72.65 71.4C72.65 73.6272 70.8272 75.45 68.6 75.45V75.75C70.9928 75.75 72.95 73.7928 72.95 71.4H72.65ZM14 71.55H72.8V71.25H14V71.55ZM12.7198 75.6903C13.6495 74.4566 14.15 72.9548 14.15 71.4H13.85C13.85 72.8902 13.3705 74.3284 12.4802 75.5097L12.7198 75.6903ZM30.8 50.25H9.80005V50.55H30.8V50.25ZM30.65 29.4V50.4H30.95V29.4H30.65ZM9.80005 29.55H30.8V29.25H9.80005V29.55ZM9.95004 50.4V29.4H9.65005V50.4H9.95004ZM30.8 26.45H9.80005V26.75H30.8V26.45ZM30.65 22.4V26.6H30.95V22.4H30.65ZM9.80005 22.55H30.8V22.25H9.80005V22.55ZM9.95004 26.6V22.4H9.65005V26.6H9.95004ZM44.8 50.25H33.6V50.55H44.8V50.25ZM44.65 29.4V50.4H44.95V29.4H44.65ZM33.6 29.55H44.8V29.25H33.6V29.55ZM33.75 50.4V29.4H33.45V50.4H33.75ZM44.8 26.45H33.6V26.75H44.8V26.45ZM44.65 22.4V26.6H44.95V22.4H44.65ZM33.6 22.55H44.8V22.25H33.6V22.55ZM33.75 26.6V22.4H33.45V26.6H33.75ZM57.4 26.45H47.6V26.75H57.4V26.45ZM57.25 22.4V26.6H57.55V22.4H57.25ZM47.6 22.55H57.4V22.25H47.6V22.55ZM47.75 26.6V22.4H47.45V26.6H47.75ZM46.2001 7.14998H49V6.84998H46.2001V7.14998ZM46.3501 9.79998V6.99998H46.05V9.79998H46.3501ZM49 9.64998H46.2001V9.94998H49V9.64998ZM48.85 6.99998V9.79998H49.1501V6.99998H48.85ZM60.2 6.84998H51.8V7.14998H60.2V6.84998ZM60.35 9.79998V6.99998H60.05V9.79998H60.35ZM51.8 9.94998H60.2V9.64998H51.8V9.94998ZM51.65 6.99998V9.79998H51.95V6.99998H51.65ZM46.2001 12.75H60.2001V12.45H46.2001V12.75ZM46.3501 15.4V12.6H46.05V15.4H46.3501ZM60.2001 15.25H46.2001V15.55H60.2001V15.25ZM60.05 12.6V15.4H60.3501V12.6H60.05ZM18.2 6.84998H7.00004V7.14998H18.2V6.84998ZM18.35 9.79998V6.99998H18.05V9.79998H18.35ZM7.00004 9.94998H18.2V9.64998H7.00004V9.94998ZM6.85004 6.99998V9.79998H7.15004V6.99998H6.85004ZM7.00004 12.75H21V12.45H7.00004V12.75ZM7.15004 15.4V12.6H6.85004V15.4H7.15004ZM21 15.25H7.00004V15.55H21V15.25ZM20.85 12.6V15.4H21.15V12.6H20.85ZM7.00004 56.15H21V55.85H7.00004V56.15ZM7.15004 58.8V56H6.85004V58.8H7.15004ZM21 58.65H7.00004V58.95H21V58.65ZM20.85 56V58.8H21.15V56H20.85ZM12.6 32.35H25.2V32.05H12.6V32.35ZM12.75 35V32.2H12.45V35H12.75ZM25.2 34.85H12.6V35.15H25.2V34.85ZM25.05 32.2V35H25.35V32.2H25.05ZM21 37.65H12.6V37.95H21V37.65ZM21.15 40.6V37.8H20.85V40.6H21.15ZM12.6 40.75H21V40.45H12.6V40.75ZM12.45 37.8V40.6H12.75V37.8H12.45ZM12.6 43.55H21V43.25H12.6V43.55ZM12.75 46.2V43.4H12.45V46.2H12.75ZM21 46.05H12.6V46.35H21V46.05ZM20.85 43.4V46.2H21.15V43.4H20.85ZM42 32.05H36.4V32.35H42V32.05ZM42.15 35V32.2H41.85V35H42.15ZM36.4 35.15H42V34.85H36.4V35.15ZM36.25 32.2V35H36.55V32.2H36.25ZM36.4 37.95H42V37.65H36.4V37.95ZM36.55 40.6V37.8H36.25V40.6H36.55ZM42 40.45H36.4V40.75H42V40.45ZM41.85 37.8V40.6H42.15V37.8H41.85ZM42 43.25H36.4V43.55H42V43.25ZM42.15 46.2V43.4H41.85V46.2H42.15ZM36.4 46.35H42V46.05H36.4V46.35ZM36.25 43.4V46.2H36.55V43.4H36.25ZM50.4 32.35H54.6V32.05H50.4V32.35ZM50.55 35V32.2H50.25V35H50.55ZM54.6 34.85H50.4V35.15H54.6V34.85ZM54.45 32.2V35H54.75V32.2H54.45ZM54.6 37.65H50.4V37.95H54.6V37.65ZM54.75 40.6V37.8H54.45V40.6H54.75ZM50.4 40.75H54.6V40.45H50.4V40.75ZM50.25 37.8V40.6H50.55V37.8H50.25ZM50.4 43.55H54.6V43.25H50.4V43.55ZM50.55 46.2V43.4H50.25V46.2H50.55ZM54.6 46.05H50.4V46.35H54.6V46.05ZM54.45 43.4V46.2H54.75V43.4H54.45Z"
                  fill="white"
                  mask="url(#path-1-inside-1_8603_34903)"
                />
              </g>
              <path
                d="M63.6006 60.6386L70.7561 53.483L69.6345 52.3614L63.6006 58.3953L60.5672 55.362L59.4456 56.4836L63.6006 60.6386ZM65.1129 66.2222C63.7144 66.2222 62.4 65.9568 61.1694 65.4261C59.9389 64.8954 58.8685 64.1751 57.9583 63.2652C57.0481 62.3554 56.3274 61.2855 55.7965 60.0555C55.2655 58.8256 55 57.5114 55 56.1129C55 54.7144 55.2654 53.4 55.7961 52.1694C56.3269 50.9389 57.0472 49.8685 57.957 48.9583C58.8668 48.0481 59.9367 47.3274 61.1667 46.7965C62.3967 46.2655 63.7109 46 65.1093 46C66.5078 46 67.8223 46.2654 69.0528 46.7961C70.2833 47.3269 71.3537 48.0472 72.2639 48.957C73.1742 49.8668 73.8948 50.9367 74.4258 52.1667C74.9567 53.3967 75.2222 54.7109 75.2222 56.1093C75.2222 57.5078 74.9568 58.8223 74.4261 60.0528C73.8954 61.2833 73.1751 62.3537 72.2652 63.2639C71.3554 64.1742 70.2855 64.8948 69.0555 65.4258C67.8256 65.9567 66.5114 66.2222 65.1129 66.2222ZM65.1111 64.6258C67.4881 64.6258 69.5015 63.8009 71.1512 62.1512C72.8009 60.5015 73.6258 58.4881 73.6258 56.1111C73.6258 53.7341 72.8009 51.7207 71.1512 50.071C69.5015 48.4213 67.4881 47.5965 65.1111 47.5965C62.7341 47.5965 60.7207 48.4213 59.071 50.071C57.4213 51.7207 56.5965 53.7341 56.5965 56.1111C56.5965 58.4881 57.4213 60.5015 59.071 62.1512C60.7207 63.8009 62.7341 64.6258 65.1111 64.6258Z"
                fill="#35A543"
              />
            </svg>
          </div>
          <div class="swiftContent">
            <h3 class="medium font-16">Your Swift Quote is Ready!</h3>
            <p>
              Our quote engine brings you the best price. Download, review and
              confirm to accept.
            </p>

            <button
              id="modules_rfq_rfqquote_3"
              mat-button
              color="primary"
              type="button"
              class="btnCustom btn-outline-primary"
            >
              Download Quote
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter" *ngIf="!rfqItem?.createdByShop">
    <button
      id="modules_rfq_rfqquote_4"
      mat-button
      class="drafts-button"
      (click)="closeRfqQuote()"
    >
      Cancel
    </button>

    <button
      id="modules_rfq_rfqquote_5"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-primary"
      [ngClass]="{ disable: saveButtonEnable }"
      (click)="updateRFQFile()"
    >
      Save
    </button>
  </div>
</ng-container>
<!-- In Progress end -->
<!-- Draft start -->
<ng-container *ngIf="rfqItem?.status === RFQStatus.DRAFT && !Sendarchive">
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>
          <div class="rfqInfo col-lg-4 col-md-4">
            <h4>Category</h4>
            <div class="category-chips-and-more">
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
              <span
                (click)="isExpanded = true"
                *ngIf="!isExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>
        <div *ngIf="isExpanded" class="mt-10">
          <h4>Materials</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let material of (rfqItem?.materials | categoryFormatter : 10)
                    .display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (rfqItem?.materials | categoryFormatter : 10).tooltip
                  "
                >
                  {{ material }}
                </span>
              </mat-chip>
            </div>
            <span (click)="isExpanded = false" class="more-less-button">
              <mat-icon>expand_less</mat-icon></span
            >
          </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="step-2">
            <div class="step_heading">
              <h4 class="step-title pb-5">
                New attachments:
                <span class="attach" *ngIf="files.length > 0">
                  <span class="icon"> </span>
                  {{ files.length }}
                  file(s)
                </span>
              </h4>
              <div class="icon">
                <span
                  ><svg
                    (click)="navExpantion()"
                    *ngIf="isExpanded"
                    xmlns="http://www.w3.org/2000/svg"
                    class="badge-notfication"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path
                      d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                    /></svg
                ></span>

                <svg
                  (click)="closeNavExpantion()"
                  *ngIf="!isExpanded"
                  xmlns="http://www.w3.org/2000/svg"
                  class=""
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path
                    d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                  />
                </svg>
              </div>
            </div>

            <div
              class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
              appDnd
              #fileDropRef
              id="fileDropRef"
              *ngIf="fileUpload"
              (fileDropped)="onFileDropped($event)"
            >
              <input
                id="modules_rfq_rfqquote_6"
                type="file"
                #fileSelector
                multiple
                (change)="fileBrowseHandler($event)"
                accept=".xlsx"
                style="display: none"
              />
              <h4 class="file-uploader-label">Upload New Files</h4>
              <p class="file-uploader-size-label">(Max file size: 100MB)</p>
              <p class="file-uploader-drag-drop-label">
                Drag & Drop .xlsx File Or
              </p>

              <p class="choose-file-button" (click)="chooseFiles()">
                Choose File
              </p>
            </div>
            <div class="files-list" *ngIf="files.length > 0">
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of files; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4 class="name" matTooltip="{{ getFileName(file?.name) }}">
                    {{ getFileName(file?.name) }}
                  </h4>
                </div>

                <div>
                  <p class="type" matTooltip="{{ getFileExt(file?.name) }}">
                    {{ getFileExt(file?.name) }}
                  </p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(file?.size) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="deleteFile(i)"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="files-list">
              <h3 class="pb-3">
                Last Uploaded: {{ rfqItem.attachments?.length || 0 }} Files
              </h3>
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of rfqItem.attachments; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4
                    matTooltip="{{ getFileName(file?.name || file?.fileName) }}"
                    class="name"
                  >
                    {{ getFileName(file?.name || file?.fileName) }}
                  </h4>
                </div>

                <div>
                  <p
                    class="type"
                    matTooltip="{{ getFileExt(file?.name || file?.fileName) }}"
                  >
                    {{ getFileExt(file?.name || file?.fileName) }}
                  </p>
                </div>

                <div>
                  <p class="size">{{ file.size }}</p>
                </div>

                <div class="delete-icon" (click)="saveFile(file)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="swiftQuote" *ngIf="rfqItem.status == 'QUOTE_READY'">
          <div class="swiftIco">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="76"
              height="84"
              viewBox="0 0 76 84"
              fill="none"
            >
              <g opacity="0.7">
                <mask id="path-1-inside-1_8603_34903" fill="white">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  />
                </mask>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  fill="#999999"
                />
                <path
                  d="M67.2 68.6H67.05V68.75H67.2V68.6ZM67.2 67.7988H67.35V67.6184L67.1727 67.6513L67.2 67.7988ZM75.6 68.6H75.75V68.45H75.6V68.6ZM67.2 78.4V78.25H67.05V78.4H67.2ZM67.2 44.2012L67.1727 44.3487L67.35 44.3816V44.2012H67.2ZM64.4 44.0147H64.25V44.1723L64.4074 44.1646L64.4 44.0147ZM11.2 68.6V68.45H11.05V68.6H11.2ZM64.4 68.6V68.75H64.55V68.6H64.4ZM64.4 67.9853L64.4074 67.8354L64.25 67.8277V67.9853H64.4ZM56.4303 64.4V64.55H56.7874L56.5374 64.295L56.4303 64.4ZM54.3841 61.6L54.5167 61.5299L54.4745 61.45H54.3841V61.6ZM44.8 64.4H44.65V64.55H44.8V64.4ZM44.8 61.6V61.45H44.65V61.6H44.8ZM53 56H53.15V55.85H53V56ZM37.7999 56V55.85H37.6499V56H37.7999ZM37.7999 58.8H37.6499V58.95H37.7999V58.8ZM53.3284 58.8V58.95H53.5185L53.4743 58.7652L53.3284 58.8ZM60.2 44.9985L60.2601 45.1359L60.35 45.0966V44.9985H60.2ZM60.2 19.6H60.35V19.45H60.2V19.6ZM7.00004 19.6V19.45H6.85004V19.6H7.00004ZM7.00004 53.2H6.85004V53.35H7.00004V53.2ZM53.3284 53.2V53.35H53.4468L53.4743 53.2349L53.3284 53.2ZM54.3841 50.4L54.5167 50.4701L54.633 50.25H54.3841V50.4ZM47.6 50.4H47.45V50.55H47.6V50.4ZM47.6 29.4V29.25H47.45V29.4H47.6ZM57.4 29.4H57.55V29.25H57.4V29.4ZM57.4 46.713H57.25V47.0298L57.4951 46.829L57.4 46.713ZM64.4 78.4H64.55V78.25H64.4V78.4ZM2.8 77L2.89028 76.8802L2.65 76.6991V77H2.8ZM12.6 75.6L12.4802 75.5097L12.2991 75.75H12.6V75.6ZM72.8 71.4H72.95V71.25H72.8V71.4ZM14 71.4V71.25H13.85V71.4H14ZM30.8 50.4V50.55H30.95V50.4H30.8ZM9.80005 50.4H9.65005V50.55H9.80005V50.4ZM30.8 29.4H30.95V29.25H30.8V29.4ZM9.80005 29.4V29.25H9.65005V29.4H9.80005ZM30.8 26.6V26.75H30.95V26.6H30.8ZM9.80005 26.6H9.65005V26.75H9.80005V26.6ZM30.8 22.4H30.95V22.25H30.8V22.4ZM9.80005 22.4V22.25H9.65005V22.4H9.80005ZM44.8 50.4V50.55H44.95V50.4H44.8ZM33.6 50.4H33.45V50.55H33.6V50.4ZM44.8 29.4H44.95V29.25H44.8V29.4ZM33.6 29.4V29.25H33.45V29.4H33.6ZM44.8 26.6V26.75H44.95V26.6H44.8ZM33.6 26.6H33.45V26.75H33.6V26.6ZM44.8 22.4H44.95V22.25H44.8V22.4ZM33.6 22.4V22.25H33.45V22.4H33.6ZM57.4 26.6V26.75H57.55V26.6H57.4ZM47.6 26.6H47.45V26.75H47.6V26.6ZM57.4 22.4H57.55V22.25H57.4V22.4ZM47.6 22.4V22.25H47.45V22.4H47.6ZM46.2001 6.99998V6.84998H46.05V6.99998H46.2001ZM49 6.99998H49.1501V6.84998H49V6.99998ZM46.2001 9.79998H46.05V9.94998H46.2001V9.79998ZM49 9.79998V9.94998H49.1501V9.79998H49ZM60.2 6.99998H60.35V6.84998H60.2V6.99998ZM51.8 6.99998V6.84998H51.65V6.99998H51.8ZM60.2 9.79998V9.94998H60.35V9.79998H60.2ZM51.8 9.79998H51.65V9.94998H51.8V9.79998ZM46.2001 12.6V12.45H46.05V12.6H46.2001ZM60.2001 12.6H60.3501V12.45H60.2001V12.6ZM46.2001 15.4H46.05V15.55H46.2001V15.4ZM60.2001 15.4V15.55H60.3501V15.4H60.2001ZM18.2 6.99998H18.35V6.84998H18.2V6.99998ZM7.00004 6.99998V6.84998H6.85004V6.99998H7.00004ZM18.2 9.79998V9.94998H18.35V9.79998H18.2ZM7.00004 9.79998H6.85004V9.94998H7.00004V9.79998ZM7.00004 12.6V12.45H6.85004V12.6H7.00004ZM21 12.6H21.15V12.45H21V12.6ZM7.00004 15.4H6.85004V15.55H7.00004V15.4ZM21 15.4V15.55H21.15V15.4H21ZM7.00004 56V55.85H6.85004V56H7.00004ZM21 56H21.15V55.85H21V56ZM7.00004 58.8H6.85004V58.95H7.00004V58.8ZM21 58.8V58.95H21.15V58.8H21ZM12.6 32.2V32.05H12.45V32.2H12.6ZM25.2 32.2H25.35V32.05H25.2V32.2ZM12.6 35H12.45V35.15H12.6V35ZM25.2 35V35.15H25.35V35H25.2ZM21 37.8H21.15V37.65H21V37.8ZM12.6 37.8V37.65H12.45V37.8H12.6ZM21 40.6V40.75H21.15V40.6H21ZM12.6 40.6H12.45V40.75H12.6V40.6ZM12.6 43.4V43.25H12.45V43.4H12.6ZM21 43.4H21.15V43.25H21V43.4ZM12.6 46.2H12.45V46.35H12.6V46.2ZM21 46.2V46.35H21.15V46.2H21ZM42 32.2H42.15V32.05H42V32.2ZM36.4 32.2V32.05H36.25V32.2H36.4ZM42 35V35.15H42.15V35H42ZM36.4 35H36.25V35.15H36.4V35ZM36.4 37.8V37.65H36.25V37.8H36.4ZM42 37.8H42.15V37.65H42V37.8ZM36.4 40.6H36.25V40.75H36.4V40.6ZM42 40.6V40.75H42.15V40.6H42ZM42 43.4H42.15V43.25H42V43.4ZM36.4 43.4V43.25H36.25V43.4H36.4ZM42 46.2V46.35H42.15V46.2H42ZM36.4 46.2H36.25V46.35H36.4V46.2ZM50.4 32.2V32.05H50.25V32.2H50.4ZM54.6 32.2H54.75V32.05H54.6V32.2ZM50.4 35H50.25V35.15H50.4V35ZM54.6 35V35.15H54.75V35H54.6ZM54.6 37.8H54.75V37.65H54.6V37.8ZM50.4 37.8V37.65H50.25V37.8H50.4ZM54.6 40.6V40.75H54.75V40.6H54.6ZM50.4 40.6H50.25V40.75H50.4V40.6ZM50.4 43.4V43.25H50.25V43.4H50.4ZM54.6 43.4H54.75V43.25H54.6V43.4ZM50.4 46.2H50.25V46.35H50.4V46.2ZM54.6 46.2V46.35H54.75V46.2H54.6ZM67.35 68.6V67.7988H67.05V68.6H67.35ZM75.6 68.45H67.2V68.75H75.6V68.45ZM75.75 71.4V68.6H75.45V71.4H75.75ZM68.6 78.55C72.5503 78.55 75.75 75.3503 75.75 71.4H75.45C75.45 75.1847 72.3847 78.25 68.6 78.25V78.55ZM67.2 78.55H68.6V78.25H67.2V78.55ZM67.35 79.8V78.4H67.05V79.8H67.35ZM63 84.15C65.3928 84.15 67.35 82.1928 67.35 79.8H67.05C67.05 82.0272 65.2272 83.85 63 83.85V84.15ZM4.2 84.15H63V83.85H4.2V84.15ZM-0.15 79.8C-0.15 82.1928 1.80716 84.15 4.2 84.15V83.85C1.97284 83.85 0.15 82.0272 0.15 79.8H-0.15ZM-0.15 4.2V79.8H0.15V4.2H-0.15ZM4.2 -0.15C1.80716 -0.15 -0.15 1.80716 -0.15 4.2H0.15C0.15 1.97284 1.97284 0.15 4.2 0.15V-0.15ZM63 -0.15H4.2V0.15H63V-0.15ZM67.35 4.2C67.35 1.80716 65.3928 -0.15 63 -0.15V0.15C65.2272 0.15 67.05 1.97284 67.05 4.2H67.35ZM67.35 44.2012V4.2H67.05V44.2012H67.35ZM65 44.15C65.7423 44.15 66.4684 44.2182 67.1727 44.3487L67.2273 44.0537C66.5052 43.9199 65.7607 43.85 65 43.85V44.15ZM64.4074 44.1646C64.6037 44.1549 64.8013 44.15 65 44.15V43.85C64.7963 43.85 64.5938 43.855 64.3926 43.8649L64.4074 44.1646ZM64.25 4.2V44.0147H64.55V4.2H64.25ZM63 2.95C63.6872 2.95 64.25 3.51284 64.25 4.2H64.55C64.55 3.34716 63.8528 2.65 63 2.65V2.95ZM4.2 2.95H63V2.65H4.2V2.95ZM2.95 4.2C2.95 3.51284 3.51284 2.95 4.2 2.95V2.65C3.34716 2.65 2.65 3.34716 2.65 4.2H2.95ZM2.95 71.4V4.2H2.65V71.4H2.95ZM7 75.45C4.75534 75.45 2.95 73.6447 2.95 71.4H2.65C2.65 73.8103 4.58966 75.75 7 75.75V75.45ZM11.05 71.4C11.05 73.6447 9.24466 75.45 7 75.45V75.75C9.41034 75.75 11.35 73.8103 11.35 71.4H11.05ZM11.05 68.6V71.4H11.35V68.6H11.05ZM64.4 68.45H11.2V68.75H64.4V68.45ZM64.25 67.9853V68.6H64.55V67.9853H64.25ZM65 67.85C64.8013 67.85 64.6037 67.8451 64.4074 67.8354L64.3926 68.1351C64.5938 68.145 64.7963 68.15 65 68.15V67.85ZM67.1727 67.6513C66.4684 67.7818 65.7423 67.85 65 67.85V68.15C65.7607 68.15 66.5052 68.0801 67.2273 67.9463L67.1727 67.6513ZM56.5374 64.295C55.7378 63.4793 55.0551 62.5485 54.5167 61.5299L54.2515 61.6701C54.8036 62.7146 55.5034 63.6688 56.3232 64.505L56.5374 64.295ZM44.8 64.55H56.4303V64.25H44.8V64.55ZM44.65 61.6V64.4H44.95V61.6H44.65ZM54.3841 61.45H44.8V61.75H54.3841V61.45ZM53 55.85L37.7999 55.85V56.15L53 56.15V55.85ZM37.6499 56V58.8H37.9499V56H37.6499ZM37.7999 58.95H53.3284V58.65H37.7999V58.95ZM53.4743 58.7652C53.2623 57.8782 53.15 56.9523 53.15 56H52.85C52.85 56.976 52.9651 57.9252 53.1825 58.8349L53.4743 58.7652ZM60.35 44.9985V19.6H60.05V44.9985H60.35ZM60.2 19.45H7.00004V19.75H60.2V19.45ZM6.85004 19.6V53.2H7.15004V19.6H6.85004ZM7.00004 53.35H53.3284V53.05H7.00004V53.35ZM53.4743 53.2349C53.7071 52.2611 54.06 51.334 54.5167 50.4701L54.2515 50.3299C53.7832 51.2157 53.4212 52.1665 53.1825 53.1651L53.4743 53.2349ZM54.3841 50.25H47.6V50.55H54.3841V50.25ZM47.75 50.4V29.4H47.45V50.4H47.75ZM47.6 29.55H57.4V29.25H47.6V29.55ZM57.25 29.4V46.713H57.55V29.4H57.25ZM57.4951 46.829C58.3295 46.1454 59.2587 45.5734 60.2601 45.1359L60.14 44.861C59.1131 45.3097 58.1603 45.8961 57.305 46.5969L57.4951 46.829ZM64.25 79.8C64.25 80.4872 63.6872 81.05 63 81.05V81.35C63.8528 81.35 64.55 80.6528 64.55 79.8H64.25ZM64.25 78.4V79.8H64.55V78.4H64.25ZM7 78.55H64.4V78.25H7V78.55ZM2.70972 77.1198C3.94343 78.0495 5.44517 78.55 7 78.55V78.25C5.50983 78.25 4.07157 77.7705 2.89028 76.8802L2.70972 77.1198ZM2.95 79.8V77H2.65V79.8H2.95ZM4.2 81.05C3.51284 81.05 2.95 80.4872 2.95 79.8H2.65C2.65 80.6528 3.34716 81.35 4.2 81.35V81.05ZM63 81.05H4.2V81.35H63V81.05ZM68.6 75.45H12.6V75.75H68.6V75.45ZM72.65 71.4C72.65 73.6272 70.8272 75.45 68.6 75.45V75.75C70.9928 75.75 72.95 73.7928 72.95 71.4H72.65ZM14 71.55H72.8V71.25H14V71.55ZM12.7198 75.6903C13.6495 74.4566 14.15 72.9548 14.15 71.4H13.85C13.85 72.8902 13.3705 74.3284 12.4802 75.5097L12.7198 75.6903ZM30.8 50.25H9.80005V50.55H30.8V50.25ZM30.65 29.4V50.4H30.95V29.4H30.65ZM9.80005 29.55H30.8V29.25H9.80005V29.55ZM9.95004 50.4V29.4H9.65005V50.4H9.95004ZM30.8 26.45H9.80005V26.75H30.8V26.45ZM30.65 22.4V26.6H30.95V22.4H30.65ZM9.80005 22.55H30.8V22.25H9.80005V22.55ZM9.95004 26.6V22.4H9.65005V26.6H9.95004ZM44.8 50.25H33.6V50.55H44.8V50.25ZM44.65 29.4V50.4H44.95V29.4H44.65ZM33.6 29.55H44.8V29.25H33.6V29.55ZM33.75 50.4V29.4H33.45V50.4H33.75ZM44.8 26.45H33.6V26.75H44.8V26.45ZM44.65 22.4V26.6H44.95V22.4H44.65ZM33.6 22.55H44.8V22.25H33.6V22.55ZM33.75 26.6V22.4H33.45V26.6H33.75ZM57.4 26.45H47.6V26.75H57.4V26.45ZM57.25 22.4V26.6H57.55V22.4H57.25ZM47.6 22.55H57.4V22.25H47.6V22.55ZM47.75 26.6V22.4H47.45V26.6H47.75ZM46.2001 7.14998H49V6.84998H46.2001V7.14998ZM46.3501 9.79998V6.99998H46.05V9.79998H46.3501ZM49 9.64998H46.2001V9.94998H49V9.64998ZM48.85 6.99998V9.79998H49.1501V6.99998H48.85ZM60.2 6.84998H51.8V7.14998H60.2V6.84998ZM60.35 9.79998V6.99998H60.05V9.79998H60.35ZM51.8 9.94998H60.2V9.64998H51.8V9.94998ZM51.65 6.99998V9.79998H51.95V6.99998H51.65ZM46.2001 12.75H60.2001V12.45H46.2001V12.75ZM46.3501 15.4V12.6H46.05V15.4H46.3501ZM60.2001 15.25H46.2001V15.55H60.2001V15.25ZM60.05 12.6V15.4H60.3501V12.6H60.05ZM18.2 6.84998H7.00004V7.14998H18.2V6.84998ZM18.35 9.79998V6.99998H18.05V9.79998H18.35ZM7.00004 9.94998H18.2V9.64998H7.00004V9.94998ZM6.85004 6.99998V9.79998H7.15004V6.99998H6.85004ZM7.00004 12.75H21V12.45H7.00004V12.75ZM7.15004 15.4V12.6H6.85004V15.4H7.15004ZM21 15.25H7.00004V15.55H21V15.25ZM20.85 12.6V15.4H21.15V12.6H20.85ZM7.00004 56.15H21V55.85H7.00004V56.15ZM7.15004 58.8V56H6.85004V58.8H7.15004ZM21 58.65H7.00004V58.95H21V58.65ZM20.85 56V58.8H21.15V56H20.85ZM12.6 32.35H25.2V32.05H12.6V32.35ZM12.75 35V32.2H12.45V35H12.75ZM25.2 34.85H12.6V35.15H25.2V34.85ZM25.05 32.2V35H25.35V32.2H25.05ZM21 37.65H12.6V37.95H21V37.65ZM21.15 40.6V37.8H20.85V40.6H21.15ZM12.6 40.75H21V40.45H12.6V40.75ZM12.45 37.8V40.6H12.75V37.8H12.45ZM12.6 43.55H21V43.25H12.6V43.55ZM12.75 46.2V43.4H12.45V46.2H12.75ZM21 46.05H12.6V46.35H21V46.05ZM20.85 43.4V46.2H21.15V43.4H20.85ZM42 32.05H36.4V32.35H42V32.05ZM42.15 35V32.2H41.85V35H42.15ZM36.4 35.15H42V34.85H36.4V35.15ZM36.25 32.2V35H36.55V32.2H36.25ZM36.4 37.95H42V37.65H36.4V37.95ZM36.55 40.6V37.8H36.25V40.6H36.55ZM42 40.45H36.4V40.75H42V40.45ZM41.85 37.8V40.6H42.15V37.8H41.85ZM42 43.25H36.4V43.55H42V43.25ZM42.15 46.2V43.4H41.85V46.2H42.15ZM36.4 46.35H42V46.05H36.4V46.35ZM36.25 43.4V46.2H36.55V43.4H36.25ZM50.4 32.35H54.6V32.05H50.4V32.35ZM50.55 35V32.2H50.25V35H50.55ZM54.6 34.85H50.4V35.15H54.6V34.85ZM54.45 32.2V35H54.75V32.2H54.45ZM54.6 37.65H50.4V37.95H54.6V37.65ZM54.75 40.6V37.8H54.45V40.6H54.75ZM50.4 40.75H54.6V40.45H50.4V40.75ZM50.25 37.8V40.6H50.55V37.8H50.25ZM50.4 43.55H54.6V43.25H50.4V43.55ZM50.55 46.2V43.4H50.25V46.2H50.55ZM54.6 46.05H50.4V46.35H54.6V46.05ZM54.45 43.4V46.2H54.75V43.4H54.45Z"
                  fill="white"
                  mask="url(#path-1-inside-1_8603_34903)"
                />
              </g>
              <path
                d="M63.6006 60.6386L70.7561 53.483L69.6345 52.3614L63.6006 58.3953L60.5672 55.362L59.4456 56.4836L63.6006 60.6386ZM65.1129 66.2222C63.7144 66.2222 62.4 65.9568 61.1694 65.4261C59.9389 64.8954 58.8685 64.1751 57.9583 63.2652C57.0481 62.3554 56.3274 61.2855 55.7965 60.0555C55.2655 58.8256 55 57.5114 55 56.1129C55 54.7144 55.2654 53.4 55.7961 52.1694C56.3269 50.9389 57.0472 49.8685 57.957 48.9583C58.8668 48.0481 59.9367 47.3274 61.1667 46.7965C62.3967 46.2655 63.7109 46 65.1093 46C66.5078 46 67.8223 46.2654 69.0528 46.7961C70.2833 47.3269 71.3537 48.0472 72.2639 48.957C73.1742 49.8668 73.8948 50.9367 74.4258 52.1667C74.9567 53.3967 75.2222 54.7109 75.2222 56.1093C75.2222 57.5078 74.9568 58.8223 74.4261 60.0528C73.8954 61.2833 73.1751 62.3537 72.2652 63.2639C71.3554 64.1742 70.2855 64.8948 69.0555 65.4258C67.8256 65.9567 66.5114 66.2222 65.1129 66.2222ZM65.1111 64.6258C67.4881 64.6258 69.5015 63.8009 71.1512 62.1512C72.8009 60.5015 73.6258 58.4881 73.6258 56.1111C73.6258 53.7341 72.8009 51.7207 71.1512 50.071C69.5015 48.4213 67.4881 47.5965 65.1111 47.5965C62.7341 47.5965 60.7207 48.4213 59.071 50.071C57.4213 51.7207 56.5965 53.7341 56.5965 56.1111C56.5965 58.4881 57.4213 60.5015 59.071 62.1512C60.7207 63.8009 62.7341 64.6258 65.1111 64.6258Z"
                fill="#35A543"
              />
            </svg>
          </div>
          <div class="swiftContent">
            <h3 class="medium font-16">Your Swift Quote is Ready!</h3>
            <p>
              Our quote engine brings you the best price. Download, review and
              confirm to accept.
            </p>

            <button
              id="modules_rfq_rfqquote_7"
              mat-button
              color="primary"
              type="button"
              class="btnCustom btn-outline-primary"
            >
              Download Quote
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter">
    <button
      id="modules_rfq_rfqquote_8"
      mat-button
      class="drafts-button"
      (click)="closeRfqQuote()"
    >
      Cancel
    </button>

    <button
      id="modules_rfq_rfqquote_9"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-primary"
      [ngClass]="{ disable: saveButtonEnable }"
      (click)="updateRFQFile()"
    >
      Save
    </button>
  </div>
</ng-container>
<!-- Draft end -->

<!-- quote ready start-->
<ng-container
  *ngIf="
    rfqItem?.status == RFQStatus.QUOTE_READY && !quotreReturn && !Sendarchive
  "
>
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_10"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>

      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>
          <div class="rfqInfo col-lg-4 col-md-4">
            <div class="category-chips-and-more">
              <h4>Category</h4>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
              <span
                (click)="isExpanded = true"
                *ngIf="!isExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>

        <div *ngIf="isExpanded" class="mt-10">
          <h4>Sub-Category</h4>
          <div class="category-chips-and-more">
            <mat-chip
              *ngFor="
                let cat of (
                  (rfqItem?.createdByShop
                    ? rfqItem?.mroSubCategory
                    : rfqItem?.subCategory
                  ) | categoryFormatter : 2
                ).display
              "
            >
              <span
                class="capability"
                [matTooltip]="
                  (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroSubCategory
                      : rfqItem?.subCategory
                    ) | categoryFormatter : 2
                  ).tooltip
                "
              >
                {{ cat }}
              </span>
            </mat-chip>
          </div>
          <h4 *ngIf="rfqItem?.materials.length != 0 && !rfqItem?.createdByShop">
            Materials
          </h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let material of (rfqItem?.materials | categoryFormatter : 10)
                    .display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (rfqItem?.materials | categoryFormatter : 10).tooltip
                  "
                >
                  {{ material }}
                </span>
              </mat-chip>
            </div>
            <span (click)="isExpanded = false" class="more-less-button">
              <mat-icon>expand_less</mat-icon></span
            >
          </div>
        </div>

        <div
          class="col-lg-12 col-md-12 col-sm-12"
          *ngIf="!rfqItem?.createdByShop"
        >
          <div class="step-2">
            <div class="step_heading">
              <h4 class="step-title pb-5">
                New attachments:
                <span class="attach" *ngIf="files.length > 0">
                  <span class="icon"> </span>
                  {{ files.length || 0 }}
                  file(s)
                </span>
              </h4>
              <div class="icon">
                <span
                  ><svg
                    (click)="navExpantion()"
                    *ngIf="isExpanded"
                    xmlns="http://www.w3.org/2000/svg"
                    class="badge-notfication"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path
                      d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                    /></svg
                ></span>

                <svg
                  (click)="closeNavExpantion()"
                  *ngIf="!isExpanded"
                  xmlns="http://www.w3.org/2000/svg"
                  class=""
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path
                    d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                  />
                </svg>
              </div>
            </div>

            <div
              class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
              appDnd
              #fileDropRef
              id="fileDropRef"
              *ngIf="fileUpload"
              (fileDropped)="onFileDropped($event)"
            >
              <input
                id="modules_rfq_rfqquote_11"
                type="file"
                #fileSelector
                multiple
                (change)="fileBrowseHandler($event)"
                accept=".xlsx"
                style="display: none"
              />
              <h4 class="file-uploader-label">Upload New Files</h4>
              <p class="file-uploader-size-label">(Max file size: 100MB)</p>
              <p class="file-uploader-drag-drop-label">
                Drag & Drop .xlsx File Or
              </p>

              <p class="choose-file-button" (click)="chooseFiles()">
                Choose File
              </p>
            </div>
            <div class="files-list" *ngIf="files.length > 0">
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of files; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4 class="name" matTooltip="{{ getFileName(file?.name) }}">
                    {{ getFileName(file?.name) }}
                  </h4>
                </div>

                <div>
                  <p>{{ getFileExt(file?.name) }}</p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(file?.size) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="deleteFile(i)"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiftQuote">
          <div class="swiftIco">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="76"
              height="84"
              viewBox="0 0 76 84"
              fill="none"
            >
              <g opacity="0.7">
                <mask id="path-1-inside-1_8603_34903" fill="white">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  />
                </mask>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  fill="#999999"
                />
                <path
                  d="M67.2 68.6H67.05V68.75H67.2V68.6ZM67.2 67.7988H67.35V67.6184L67.1727 67.6513L67.2 67.7988ZM75.6 68.6H75.75V68.45H75.6V68.6ZM67.2 78.4V78.25H67.05V78.4H67.2ZM67.2 44.2012L67.1727 44.3487L67.35 44.3816V44.2012H67.2ZM64.4 44.0147H64.25V44.1723L64.4074 44.1646L64.4 44.0147ZM11.2 68.6V68.45H11.05V68.6H11.2ZM64.4 68.6V68.75H64.55V68.6H64.4ZM64.4 67.9853L64.4074 67.8354L64.25 67.8277V67.9853H64.4ZM56.4303 64.4V64.55H56.7874L56.5374 64.295L56.4303 64.4ZM54.3841 61.6L54.5167 61.5299L54.4745 61.45H54.3841V61.6ZM44.8 64.4H44.65V64.55H44.8V64.4ZM44.8 61.6V61.45H44.65V61.6H44.8ZM53 56H53.15V55.85H53V56ZM37.7999 56V55.85H37.6499V56H37.7999ZM37.7999 58.8H37.6499V58.95H37.7999V58.8ZM53.3284 58.8V58.95H53.5185L53.4743 58.7652L53.3284 58.8ZM60.2 44.9985L60.2601 45.1359L60.35 45.0966V44.9985H60.2ZM60.2 19.6H60.35V19.45H60.2V19.6ZM7.00004 19.6V19.45H6.85004V19.6H7.00004ZM7.00004 53.2H6.85004V53.35H7.00004V53.2ZM53.3284 53.2V53.35H53.4468L53.4743 53.2349L53.3284 53.2ZM54.3841 50.4L54.5167 50.4701L54.633 50.25H54.3841V50.4ZM47.6 50.4H47.45V50.55H47.6V50.4ZM47.6 29.4V29.25H47.45V29.4H47.6ZM57.4 29.4H57.55V29.25H57.4V29.4ZM57.4 46.713H57.25V47.0298L57.4951 46.829L57.4 46.713ZM64.4 78.4H64.55V78.25H64.4V78.4ZM2.8 77L2.89028 76.8802L2.65 76.6991V77H2.8ZM12.6 75.6L12.4802 75.5097L12.2991 75.75H12.6V75.6ZM72.8 71.4H72.95V71.25H72.8V71.4ZM14 71.4V71.25H13.85V71.4H14ZM30.8 50.4V50.55H30.95V50.4H30.8ZM9.80005 50.4H9.65005V50.55H9.80005V50.4ZM30.8 29.4H30.95V29.25H30.8V29.4ZM9.80005 29.4V29.25H9.65005V29.4H9.80005ZM30.8 26.6V26.75H30.95V26.6H30.8ZM9.80005 26.6H9.65005V26.75H9.80005V26.6ZM30.8 22.4H30.95V22.25H30.8V22.4ZM9.80005 22.4V22.25H9.65005V22.4H9.80005ZM44.8 50.4V50.55H44.95V50.4H44.8ZM33.6 50.4H33.45V50.55H33.6V50.4ZM44.8 29.4H44.95V29.25H44.8V29.4ZM33.6 29.4V29.25H33.45V29.4H33.6ZM44.8 26.6V26.75H44.95V26.6H44.8ZM33.6 26.6H33.45V26.75H33.6V26.6ZM44.8 22.4H44.95V22.25H44.8V22.4ZM33.6 22.4V22.25H33.45V22.4H33.6ZM57.4 26.6V26.75H57.55V26.6H57.4ZM47.6 26.6H47.45V26.75H47.6V26.6ZM57.4 22.4H57.55V22.25H57.4V22.4ZM47.6 22.4V22.25H47.45V22.4H47.6ZM46.2001 6.99998V6.84998H46.05V6.99998H46.2001ZM49 6.99998H49.1501V6.84998H49V6.99998ZM46.2001 9.79998H46.05V9.94998H46.2001V9.79998ZM49 9.79998V9.94998H49.1501V9.79998H49ZM60.2 6.99998H60.35V6.84998H60.2V6.99998ZM51.8 6.99998V6.84998H51.65V6.99998H51.8ZM60.2 9.79998V9.94998H60.35V9.79998H60.2ZM51.8 9.79998H51.65V9.94998H51.8V9.79998ZM46.2001 12.6V12.45H46.05V12.6H46.2001ZM60.2001 12.6H60.3501V12.45H60.2001V12.6ZM46.2001 15.4H46.05V15.55H46.2001V15.4ZM60.2001 15.4V15.55H60.3501V15.4H60.2001ZM18.2 6.99998H18.35V6.84998H18.2V6.99998ZM7.00004 6.99998V6.84998H6.85004V6.99998H7.00004ZM18.2 9.79998V9.94998H18.35V9.79998H18.2ZM7.00004 9.79998H6.85004V9.94998H7.00004V9.79998ZM7.00004 12.6V12.45H6.85004V12.6H7.00004ZM21 12.6H21.15V12.45H21V12.6ZM7.00004 15.4H6.85004V15.55H7.00004V15.4ZM21 15.4V15.55H21.15V15.4H21ZM7.00004 56V55.85H6.85004V56H7.00004ZM21 56H21.15V55.85H21V56ZM7.00004 58.8H6.85004V58.95H7.00004V58.8ZM21 58.8V58.95H21.15V58.8H21ZM12.6 32.2V32.05H12.45V32.2H12.6ZM25.2 32.2H25.35V32.05H25.2V32.2ZM12.6 35H12.45V35.15H12.6V35ZM25.2 35V35.15H25.35V35H25.2ZM21 37.8H21.15V37.65H21V37.8ZM12.6 37.8V37.65H12.45V37.8H12.6ZM21 40.6V40.75H21.15V40.6H21ZM12.6 40.6H12.45V40.75H12.6V40.6ZM12.6 43.4V43.25H12.45V43.4H12.6ZM21 43.4H21.15V43.25H21V43.4ZM12.6 46.2H12.45V46.35H12.6V46.2ZM21 46.2V46.35H21.15V46.2H21ZM42 32.2H42.15V32.05H42V32.2ZM36.4 32.2V32.05H36.25V32.2H36.4ZM42 35V35.15H42.15V35H42ZM36.4 35H36.25V35.15H36.4V35ZM36.4 37.8V37.65H36.25V37.8H36.4ZM42 37.8H42.15V37.65H42V37.8ZM36.4 40.6H36.25V40.75H36.4V40.6ZM42 40.6V40.75H42.15V40.6H42ZM42 43.4H42.15V43.25H42V43.4ZM36.4 43.4V43.25H36.25V43.4H36.4ZM42 46.2V46.35H42.15V46.2H42ZM36.4 46.2H36.25V46.35H36.4V46.2ZM50.4 32.2V32.05H50.25V32.2H50.4ZM54.6 32.2H54.75V32.05H54.6V32.2ZM50.4 35H50.25V35.15H50.4V35ZM54.6 35V35.15H54.75V35H54.6ZM54.6 37.8H54.75V37.65H54.6V37.8ZM50.4 37.8V37.65H50.25V37.8H50.4ZM54.6 40.6V40.75H54.75V40.6H54.6ZM50.4 40.6H50.25V40.75H50.4V40.6ZM50.4 43.4V43.25H50.25V43.4H50.4ZM54.6 43.4H54.75V43.25H54.6V43.4ZM50.4 46.2H50.25V46.35H50.4V46.2ZM54.6 46.2V46.35H54.75V46.2H54.6ZM67.35 68.6V67.7988H67.05V68.6H67.35ZM75.6 68.45H67.2V68.75H75.6V68.45ZM75.75 71.4V68.6H75.45V71.4H75.75ZM68.6 78.55C72.5503 78.55 75.75 75.3503 75.75 71.4H75.45C75.45 75.1847 72.3847 78.25 68.6 78.25V78.55ZM67.2 78.55H68.6V78.25H67.2V78.55ZM67.35 79.8V78.4H67.05V79.8H67.35ZM63 84.15C65.3928 84.15 67.35 82.1928 67.35 79.8H67.05C67.05 82.0272 65.2272 83.85 63 83.85V84.15ZM4.2 84.15H63V83.85H4.2V84.15ZM-0.15 79.8C-0.15 82.1928 1.80716 84.15 4.2 84.15V83.85C1.97284 83.85 0.15 82.0272 0.15 79.8H-0.15ZM-0.15 4.2V79.8H0.15V4.2H-0.15ZM4.2 -0.15C1.80716 -0.15 -0.15 1.80716 -0.15 4.2H0.15C0.15 1.97284 1.97284 0.15 4.2 0.15V-0.15ZM63 -0.15H4.2V0.15H63V-0.15ZM67.35 4.2C67.35 1.80716 65.3928 -0.15 63 -0.15V0.15C65.2272 0.15 67.05 1.97284 67.05 4.2H67.35ZM67.35 44.2012V4.2H67.05V44.2012H67.35ZM65 44.15C65.7423 44.15 66.4684 44.2182 67.1727 44.3487L67.2273 44.0537C66.5052 43.9199 65.7607 43.85 65 43.85V44.15ZM64.4074 44.1646C64.6037 44.1549 64.8013 44.15 65 44.15V43.85C64.7963 43.85 64.5938 43.855 64.3926 43.8649L64.4074 44.1646ZM64.25 4.2V44.0147H64.55V4.2H64.25ZM63 2.95C63.6872 2.95 64.25 3.51284 64.25 4.2H64.55C64.55 3.34716 63.8528 2.65 63 2.65V2.95ZM4.2 2.95H63V2.65H4.2V2.95ZM2.95 4.2C2.95 3.51284 3.51284 2.95 4.2 2.95V2.65C3.34716 2.65 2.65 3.34716 2.65 4.2H2.95ZM2.95 71.4V4.2H2.65V71.4H2.95ZM7 75.45C4.75534 75.45 2.95 73.6447 2.95 71.4H2.65C2.65 73.8103 4.58966 75.75 7 75.75V75.45ZM11.05 71.4C11.05 73.6447 9.24466 75.45 7 75.45V75.75C9.41034 75.75 11.35 73.8103 11.35 71.4H11.05ZM11.05 68.6V71.4H11.35V68.6H11.05ZM64.4 68.45H11.2V68.75H64.4V68.45ZM64.25 67.9853V68.6H64.55V67.9853H64.25ZM65 67.85C64.8013 67.85 64.6037 67.8451 64.4074 67.8354L64.3926 68.1351C64.5938 68.145 64.7963 68.15 65 68.15V67.85ZM67.1727 67.6513C66.4684 67.7818 65.7423 67.85 65 67.85V68.15C65.7607 68.15 66.5052 68.0801 67.2273 67.9463L67.1727 67.6513ZM56.5374 64.295C55.7378 63.4793 55.0551 62.5485 54.5167 61.5299L54.2515 61.6701C54.8036 62.7146 55.5034 63.6688 56.3232 64.505L56.5374 64.295ZM44.8 64.55H56.4303V64.25H44.8V64.55ZM44.65 61.6V64.4H44.95V61.6H44.65ZM54.3841 61.45H44.8V61.75H54.3841V61.45ZM53 55.85L37.7999 55.85V56.15L53 56.15V55.85ZM37.6499 56V58.8H37.9499V56H37.6499ZM37.7999 58.95H53.3284V58.65H37.7999V58.95ZM53.4743 58.7652C53.2623 57.8782 53.15 56.9523 53.15 56H52.85C52.85 56.976 52.9651 57.9252 53.1825 58.8349L53.4743 58.7652ZM60.35 44.9985V19.6H60.05V44.9985H60.35ZM60.2 19.45H7.00004V19.75H60.2V19.45ZM6.85004 19.6V53.2H7.15004V19.6H6.85004ZM7.00004 53.35H53.3284V53.05H7.00004V53.35ZM53.4743 53.2349C53.7071 52.2611 54.06 51.334 54.5167 50.4701L54.2515 50.3299C53.7832 51.2157 53.4212 52.1665 53.1825 53.1651L53.4743 53.2349ZM54.3841 50.25H47.6V50.55H54.3841V50.25ZM47.75 50.4V29.4H47.45V50.4H47.75ZM47.6 29.55H57.4V29.25H47.6V29.55ZM57.25 29.4V46.713H57.55V29.4H57.25ZM57.4951 46.829C58.3295 46.1454 59.2587 45.5734 60.2601 45.1359L60.14 44.861C59.1131 45.3097 58.1603 45.8961 57.305 46.5969L57.4951 46.829ZM64.25 79.8C64.25 80.4872 63.6872 81.05 63 81.05V81.35C63.8528 81.35 64.55 80.6528 64.55 79.8H64.25ZM64.25 78.4V79.8H64.55V78.4H64.25ZM7 78.55H64.4V78.25H7V78.55ZM2.70972 77.1198C3.94343 78.0495 5.44517 78.55 7 78.55V78.25C5.50983 78.25 4.07157 77.7705 2.89028 76.8802L2.70972 77.1198ZM2.95 79.8V77H2.65V79.8H2.95ZM4.2 81.05C3.51284 81.05 2.95 80.4872 2.95 79.8H2.65C2.65 80.6528 3.34716 81.35 4.2 81.35V81.05ZM63 81.05H4.2V81.35H63V81.05ZM68.6 75.45H12.6V75.75H68.6V75.45ZM72.65 71.4C72.65 73.6272 70.8272 75.45 68.6 75.45V75.75C70.9928 75.75 72.95 73.7928 72.95 71.4H72.65ZM14 71.55H72.8V71.25H14V71.55ZM12.7198 75.6903C13.6495 74.4566 14.15 72.9548 14.15 71.4H13.85C13.85 72.8902 13.3705 74.3284 12.4802 75.5097L12.7198 75.6903ZM30.8 50.25H9.80005V50.55H30.8V50.25ZM30.65 29.4V50.4H30.95V29.4H30.65ZM9.80005 29.55H30.8V29.25H9.80005V29.55ZM9.95004 50.4V29.4H9.65005V50.4H9.95004ZM30.8 26.45H9.80005V26.75H30.8V26.45ZM30.65 22.4V26.6H30.95V22.4H30.65ZM9.80005 22.55H30.8V22.25H9.80005V22.55ZM9.95004 26.6V22.4H9.65005V26.6H9.95004ZM44.8 50.25H33.6V50.55H44.8V50.25ZM44.65 29.4V50.4H44.95V29.4H44.65ZM33.6 29.55H44.8V29.25H33.6V29.55ZM33.75 50.4V29.4H33.45V50.4H33.75ZM44.8 26.45H33.6V26.75H44.8V26.45ZM44.65 22.4V26.6H44.95V22.4H44.65ZM33.6 22.55H44.8V22.25H33.6V22.55ZM33.75 26.6V22.4H33.45V26.6H33.75ZM57.4 26.45H47.6V26.75H57.4V26.45ZM57.25 22.4V26.6H57.55V22.4H57.25ZM47.6 22.55H57.4V22.25H47.6V22.55ZM47.75 26.6V22.4H47.45V26.6H47.75ZM46.2001 7.14998H49V6.84998H46.2001V7.14998ZM46.3501 9.79998V6.99998H46.05V9.79998H46.3501ZM49 9.64998H46.2001V9.94998H49V9.64998ZM48.85 6.99998V9.79998H49.1501V6.99998H48.85ZM60.2 6.84998H51.8V7.14998H60.2V6.84998ZM60.35 9.79998V6.99998H60.05V9.79998H60.35ZM51.8 9.94998H60.2V9.64998H51.8V9.94998ZM51.65 6.99998V9.79998H51.95V6.99998H51.65ZM46.2001 12.75H60.2001V12.45H46.2001V12.75ZM46.3501 15.4V12.6H46.05V15.4H46.3501ZM60.2001 15.25H46.2001V15.55H60.2001V15.25ZM60.05 12.6V15.4H60.3501V12.6H60.05ZM18.2 6.84998H7.00004V7.14998H18.2V6.84998ZM18.35 9.79998V6.99998H18.05V9.79998H18.35ZM7.00004 9.94998H18.2V9.64998H7.00004V9.94998ZM6.85004 6.99998V9.79998H7.15004V6.99998H6.85004ZM7.00004 12.75H21V12.45H7.00004V12.75ZM7.15004 15.4V12.6H6.85004V15.4H7.15004ZM21 15.25H7.00004V15.55H21V15.25ZM20.85 12.6V15.4H21.15V12.6H20.85ZM7.00004 56.15H21V55.85H7.00004V56.15ZM7.15004 58.8V56H6.85004V58.8H7.15004ZM21 58.65H7.00004V58.95H21V58.65ZM20.85 56V58.8H21.15V56H20.85ZM12.6 32.35H25.2V32.05H12.6V32.35ZM12.75 35V32.2H12.45V35H12.75ZM25.2 34.85H12.6V35.15H25.2V34.85ZM25.05 32.2V35H25.35V32.2H25.05ZM21 37.65H12.6V37.95H21V37.65ZM21.15 40.6V37.8H20.85V40.6H21.15ZM12.6 40.75H21V40.45H12.6V40.75ZM12.45 37.8V40.6H12.75V37.8H12.45ZM12.6 43.55H21V43.25H12.6V43.55ZM12.75 46.2V43.4H12.45V46.2H12.75ZM21 46.05H12.6V46.35H21V46.05ZM20.85 43.4V46.2H21.15V43.4H20.85ZM42 32.05H36.4V32.35H42V32.05ZM42.15 35V32.2H41.85V35H42.15ZM36.4 35.15H42V34.85H36.4V35.15ZM36.25 32.2V35H36.55V32.2H36.25ZM36.4 37.95H42V37.65H36.4V37.95ZM36.55 40.6V37.8H36.25V40.6H36.55ZM42 40.45H36.4V40.75H42V40.45ZM41.85 37.8V40.6H42.15V37.8H41.85ZM42 43.25H36.4V43.55H42V43.25ZM42.15 46.2V43.4H41.85V46.2H42.15ZM36.4 46.35H42V46.05H36.4V46.35ZM36.25 43.4V46.2H36.55V43.4H36.25ZM50.4 32.35H54.6V32.05H50.4V32.35ZM50.55 35V32.2H50.25V35H50.55ZM54.6 34.85H50.4V35.15H54.6V34.85ZM54.45 32.2V35H54.75V32.2H54.45ZM54.6 37.65H50.4V37.95H54.6V37.65ZM54.75 40.6V37.8H54.45V40.6H54.75ZM50.4 40.75H54.6V40.45H50.4V40.75ZM50.25 37.8V40.6H50.55V37.8H50.25ZM50.4 43.55H54.6V43.25H50.4V43.55ZM50.55 46.2V43.4H50.25V46.2H50.55ZM54.6 46.05H50.4V46.35H54.6V46.05ZM54.45 43.4V46.2H54.75V43.4H54.45Z"
                  fill="white"
                  mask="url(#path-1-inside-1_8603_34903)"
                />
              </g>
              <path
                d="M63.6006 60.6386L70.7561 53.483L69.6345 52.3614L63.6006 58.3953L60.5672 55.362L59.4456 56.4836L63.6006 60.6386ZM65.1129 66.2222C63.7144 66.2222 62.4 65.9568 61.1694 65.4261C59.9389 64.8954 58.8685 64.1751 57.9583 63.2652C57.0481 62.3554 56.3274 61.2855 55.7965 60.0555C55.2655 58.8256 55 57.5114 55 56.1129C55 54.7144 55.2654 53.4 55.7961 52.1694C56.3269 50.9389 57.0472 49.8685 57.957 48.9583C58.8668 48.0481 59.9367 47.3274 61.1667 46.7965C62.3967 46.2655 63.7109 46 65.1093 46C66.5078 46 67.8223 46.2654 69.0528 46.7961C70.2833 47.3269 71.3537 48.0472 72.2639 48.957C73.1742 49.8668 73.8948 50.9367 74.4258 52.1667C74.9567 53.3967 75.2222 54.7109 75.2222 56.1093C75.2222 57.5078 74.9568 58.8223 74.4261 60.0528C73.8954 61.2833 73.1751 62.3537 72.2652 63.2639C71.3554 64.1742 70.2855 64.8948 69.0555 65.4258C67.8256 65.9567 66.5114 66.2222 65.1129 66.2222ZM65.1111 64.6258C67.4881 64.6258 69.5015 63.8009 71.1512 62.1512C72.8009 60.5015 73.6258 58.4881 73.6258 56.1111C73.6258 53.7341 72.8009 51.7207 71.1512 50.071C69.5015 48.4213 67.4881 47.5965 65.1111 47.5965C62.7341 47.5965 60.7207 48.4213 59.071 50.071C57.4213 51.7207 56.5965 53.7341 56.5965 56.1111C56.5965 58.4881 57.4213 60.5015 59.071 62.1512C60.7207 63.8009 62.7341 64.6258 65.1111 64.6258Z"
                fill="#35A543"
              />
            </svg>
          </div>
          <div class="swiftContent">
            <h3 class="medium font-16">Your Swift Quote is Ready!</h3>
            <p>
              Our quote engine brings you the best price. Download, review and
              confirm to accept.
            </p>
            <div>
              <button
                id="modules_rfq_rfqquote_12"
                mat-button
                color="primary"
                class="btnCustom btn-outline-primary"
                type="button"
                (click)="downloadAllQuoteFiles(rfqItem.attachments)"
              >
                Download Quote
              </button>
            </div>
          </div>
        </div>
        <div class="files-list">
          <h3 class="pb-3 pointer" (click)="toggleAttachments()">
            Last Previous: {{ rfqItem.attachments?.length || 0 }} Files
            <ng-container *ngIf="showHideAttachments; else chevDown">
              <lucide-icon
                name="chevron-up"
                [size]="16"
                class="chevron-up"
              ></lucide-icon>
            </ng-container>
            <ng-template #chevDown>
              <lucide-icon
                name="chevron-down"
                [size]="16"
                class="chevron-down"
              ></lucide-icon>
            </ng-template>

            <span></span>
          </h3>

          <div *ngIf="showHideAttachments">
            <div *ngFor="let files of getFileTypes(); let i = index">
              <h3 class="font-12 medium">{{ getFileTypeLabel(files.key) }}</h3>
              <div *ngIf="files.value">
                <div *ngFor="let file of files.value">
                  <div
                    class="single-file flex justify-content-between"
                    *ngIf="file.fileStatus === fileStatus.Live"
                  >
                    <!-- <div class="single-file flex justify-content-between" *ngFor="let file of files.value"> -->
                    <div class="rfq-item rfq-icon">
                      <span class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5589_19343"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5589_19343)">
                            <path
                              d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                              fill="#333333"
                            />
                          </g>
                        </svg>
                      </span>

                      <h4
                        title="{{ getFileName(file?.name || file?.fileName) }}"
                        class="name"
                      >
                        {{ getFileName(file?.name || file?.fileName) }}
                      </h4>
                    </div>

                    <div>
                      <p
                        class="type"
                        title="{{ getFileExt(file?.name || file?.fileName) }}"
                      >
                        {{ getFileExt(file?.name || file?.fileName) }}
                      </p>
                    </div>

                    <div>
                      <p class="size">{{ file.size }}</p>
                    </div>

                    <div>
                      <p class="size">
                        {{ file.createdOn | date : "MMM d, y, h:mm" }}
                      </p>
                    </div>
                    <div class="delete-icon" (click)="saveFile(file)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                          fill="#666666"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- returned quote-->
            <label class="label" *ngIf="isPreviousQuote(rfqItem?.attachments)"
              >Previous Quote</label
            >
            <div *ngFor="let attachFile of rfqItem?.attachments; let i = index">
              <div
                class="quoteReason"
                *ngIf="
                  (attachFile?.fileType === FileType.Quote ||
                    attachFile?.fileType === FileType.Quote_Tooling ||
                    attachFile?.fileType === FileType.Quote_Component ||
                    attachFile?.fileType === FileType.Quote_Capex) &&
                  attachFile?.fileStatus === fileStatus.Archive
                "
              >
                <h4 class="font-12 medium flex">
                  Reason for return
                  <span class="date ml-auto">{{
                    attachFile?.createdOn | date : "MMM d, y"
                  }}</span>
                </h4>
                <p class="font-12">{{ attachFile?.returnReason }}</p>

                <h4 class="font-12 medium" *ngIf="attachFile?.returnOthers">
                  Remarks
                </h4>
                <p class="font-12" *ngIf="attachFile?.returnOthers">
                  {{ attachFile?.returnOthers }}
                </p>
                <div class="returnFile">
                  <div class="rfq-item rfq-icon">
                    <span class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <mask
                          id="mask0_5589_19343"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_5589_19343)">
                          <path
                            d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    </span>
                    <h4
                      class="name"
                      matTooltip="{{ getFileName(attachFile?.fileName) }}"
                    >
                      {{ getFileName(attachFile?.fileName) }}
                    </h4>
                  </div>

                  <div class="align-items-center">
                    <p
                      class="type"
                      matTooltip="{{ getFileExt(attachFile?.fileName) }}"
                    >
                      .{{ getFileExt(attachFile?.fileName) }}
                    </p>
                  </div>

                  <div class="align-items-center">
                    <p class="size">{{ attachFile?.size }}</p>
                  </div>
                  <div class="download-file">
                    <span
                      class="iconCenter"
                      (click)="
                        downloadFiles(attachFile?.id, attachFile?.fileName)
                      "
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_8832_38514"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9"></rect>
                        </mask>
                        <g mask="url(#mask0_8832_38514)">
                          <path
                            d="M12 15.7884L7.7308 11.5192L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5192L12 15.7884ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6922V14.9807H5.99997V17.6922C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6922V14.9807H19.5V17.6922C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
                            fill="#DA2128"
                          ></path>
                        </g>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- returned quote end -->
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter">
    <button
      id="modules_rfq_rfqquote_13"
      mat-button
      class="drafts-button"
      (click)="returnQuote()"
    >
      Return Quote
    </button>
    <button
      id="modules_rfq_rfqquote_14"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-primary"
      (click)="acceptQuote()"
    >
      Accept Quote & Raise P.O.
    </button>
  </div>
</ng-container>
<!-- quote ready end-->

<!-- quote accepted start -->
<ng-container
  *ngIf="rfqItem?.status === RFQStatus.QUOTE_ACCEPTED && !Sendarchive"
>
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_15"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>
      <span class="rfqClose" (click)="closeUploadPo()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>

          <div class="rfqInfo col-lg-4 col-md-4">
            <div class="category-chips-and-more">
              <h4>Category</h4>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
              <span
                (click)="isPoExpanded = true"
                *ngIf="!isPoExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="step-2">
            <div class="step_heading">
              <h4 class="step-title pb-5">P.O. Upload</h4>

              <div class="icon"></div>
            </div>

            <div
              class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
              appDnd
              #singleFileDropRef
              id="singleFileDropRef"
              (fileDropped)="onSingleFileDropped($event)"
            >
              <input
                id="modules_rfq_rfqquote_16"
                type="file"
                #singleFileSelector
                accept=".xls,.xlsx,.pdf"
                (change)="fileBrowseHandlerSingle($event)"
                style="display: none"
              />
              <h4 class="file-uploader-label">Upload P.O.</h4>
              <p class="file-uploader-size-label">(Max file size: 100MB)</p>
              <p class="file-uploader-size-label">
                Raise your P.O within 7 days for swift processing
              </p>
              <p class="file-uploader-drag-drop-label">
                Drag & Drop .xls, .xlsx, .pdf File Or
              </p>

              <p class="choose-file-button" (click)="chooseSingleFiles()">
                Choose File
              </p>
            </div>
            <div class="files-list" *ngIf="SingleFile">
              <div class="single-file flex justify-content-between">
                <div class="rfq-item rfq-icon">
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>

                  <h4
                    class="name"
                    matTooltip="{{
                      getSingleFileName(
                        SingleFile?.name || SingleFile?.fileName || ''
                      )
                    }}"
                  >
                    {{
                      getSingleFileName(
                        SingleFile?.name || SingleFile?.fileName || ""
                      )
                    }}
                  </h4>
                </div>

                <div>
                  <p>
                    .{{
                      getSingleFileExt(
                        SingleFile?.name || SingleFile?.fileName || ""
                      )
                    }}
                  </p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(SingleFile?.size || 0) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="removeFile()"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="files-list">
              <h3 class="pb-3">
                Last Uploaded: {{ rfqItem.attachments?.length || 0 }} Files
              </h3>
              <div *ngFor="let files of getFileTypes(); let i = index">
                <h3 class="font-12 medium">
                  {{ getFileTypeLabel(files.key) }}
                </h3>
                <div *ngIf="files.value">
                  <div *ngFor="let file of files.value">
                    <div
                      class="single-file flex justify-content-between"
                      *ngIf="file.fileStatus === fileStatus.Live"
                    >
                      <!-- <div class="single-file flex justify-content-between" *ngFor="let file of files.value"> -->
                      <div class="rfq-item rfq-icon">
                        <span class="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <mask
                              id="mask0_5589_19343"
                              style="mask-type: alpha"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="20"
                              height="20"
                            >
                              <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_5589_19343)">
                              <path
                                d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                                fill="#333333"
                              />
                            </g>
                          </svg>
                        </span>

                        <h4
                          title="{{
                            getFileName(file?.name || file?.fileName)
                          }}"
                          class="name"
                        >
                          {{ getFileName(file?.name || file?.fileName) }}
                        </h4>
                      </div>

                      <div>
                        <p
                          class="type"
                          title="{{ getFileExt(file?.name || file?.fileName) }}"
                        >
                          {{ getFileExt(file?.name || file?.fileName) }}
                        </p>
                      </div>

                      <div>
                        <p class="size">{{ file.size }}</p>
                      </div>

                      <div>
                        <p class="size">
                          {{ file.createdOn | date : "MMMM d, y" }}
                        </p>
                      </div>

                      <div class="delete-icon" (click)="saveFile(file)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                            fill="#666666"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- returned quote-->
              <label class="label" *ngIf="isPreviousQuote(rfqItem?.attachments)"
                >Previous Quote</label
              >
              <div
                *ngFor="let attachFile of rfqItem?.attachments; let i = index"
              >
                <div
                  class="quoteReason"
                  *ngIf="
                    (attachFile?.fileType === FileType.Quote ||
                      attachFile?.fileType === FileType.Quote_Tooling ||
                      attachFile?.fileType === FileType.Quote_Component ||
                      attachFile?.fileType === FileType.Quote_Capex) &&
                    attachFile?.fileStatus === fileStatus.Archive
                  "
                >
                  <h4 class="font-12 medium flex">
                    Reason for return
                    <span class="date ml-auto">{{
                      attachFile?.createdOn | date : "MMM d, y"
                    }}</span>
                  </h4>
                  <p class="font-12">{{ attachFile?.returnReason }}</p>

                  <h4 class="font-12 medium" *ngIf="attachFile?.returnOthers">
                    Remarks
                  </h4>
                  <p class="font-12" *ngIf="attachFile?.returnOthers">
                    {{ attachFile?.returnOthers }}
                  </p>
                  <div class="returnFile">
                    <div class="rfq-item rfq-icon">
                      <span class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5589_19343"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5589_19343)">
                            <path
                              d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                              fill="#333333"
                            />
                          </g>
                        </svg>
                      </span>
                      <h4
                        class="name"
                        matTooltip="{{ getFileName(attachFile?.fileName) }}"
                      >
                        {{ getFileName(attachFile?.fileName) }}
                      </h4>
                    </div>

                    <div class="align-items-center">
                      <p
                        class="type"
                        matTooltip="{{ getFileExt(attachFile?.fileName) }}"
                      >
                        .{{ getFileExt(attachFile?.fileName) }}
                      </p>
                    </div>

                    <div class="align-items-center">
                      <p class="size">{{ attachFile?.size }}</p>
                    </div>
                    <div class="download-file">
                      <span
                        class="iconCenter"
                        (click)="
                          downloadFiles(attachFile?.id, attachFile?.fileName)
                        "
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_8832_38514"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                          >
                            <rect width="24" height="24" fill="#D9D9D9"></rect>
                          </mask>
                          <g mask="url(#mask0_8832_38514)">
                            <path
                              d="M12 15.7884L7.7308 11.5192L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5192L12 15.7884ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6922V14.9807H5.99997V17.6922C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6922V14.9807H19.5V17.6922C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
                              fill="#DA2128"
                            ></path>
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- returned quote end -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter">
    <button
      id="modules_rfq_rfqquote_17"
      mat-button
      class="drafts-button"
      (click)="closeUploadPo()"
    >
      Close
    </button>

    <button
      id="modules_rfq_rfqquote_18"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-primary"
      [ngClass]="{ disabledBut: !SingleFile }"
      (click)="updatePOFile()"
      [disabled]="!SingleFile"
    >
      Upload P.O.
    </button>
  </div>
</ng-container>
<!-- quote accepted end-->

<!-- quote po raise start -->
<ng-container *ngIf="rfqItem?.status === RFQStatus.PO_RAISED && !Sendarchive">
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_19"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>
      <span class="rfqClose" (click)="closeUploadPo()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>

          <div class="rfqInfo col-lg-4 col-md-4">
            <div class="category-chips-and-more">
              <h4>Category</h4>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
            </div>
          </div>
        </div>
        <div class="accordion-header pb-3">
          <h4>Sub-Category</h4>
        </div>
        <div class="category-chips-and-more">
          <mat-chip
            *ngFor="
              let cat of (
                (rfqItem?.createdByShop
                  ? rfqItem?.mroSubCategory
                  : rfqItem?.subCategory
                ) | categoryFormatter : 2
              ).display
            "
          >
            <span
              class="capability"
              [matTooltip]="
                (
                  (rfqItem?.createdByShop
                    ? rfqItem?.mroSubCategory
                    : rfqItem?.subCategory
                  ) | categoryFormatter : 2
                ).tooltip
              "
            >
              {{ cat }}
            </span>
          </mat-chip>
          <span
            (click)="isPoExpanded = true"
            *ngIf="!isPoExpanded"
            class="more-less-button"
          >
            <mat-icon>expand_more</mat-icon></span
          >
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="step-2">
            <div class="files-list">
              <h3 class="pb-3">Latest Uploaded P.O.</h3>
              <div *ngFor="let poAttch of rfqItem.attachments">
                <div
                  class="single-file flex justify-content-between"
                  *ngIf="
                    poAttch?.fileType === FileType.PO &&
                    poAttch?.fileStatus === fileStatus.Live
                  "
                >
                  <div class="rfq-item rfq-icon">
                    <span class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <mask
                          id="mask0_5589_19343"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_5589_19343)">
                          <path
                            d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    </span>
                    <h4
                      class="name"
                      matTooltip="{{
                        getSingleFileName(
                          poAttch?.name || poAttch?.fileName || ''
                        )
                      }}"
                    >
                      {{
                        getSingleFileName(
                          poAttch?.name || poAttch?.fileName || ""
                        )
                      }}
                    </h4>
                  </div>
                  <div>
                    <p
                      class="type"
                      matTooltip="{{ getSingleFileExt(poAttch?.type) }}"
                    >
                      {{ getSingleFileExt(poAttch?.type) }}
                    </p>
                  </div>
                  <div>
                    <p>.{{ poAttch?.createdOn | date : "MMM d, y" }}</p>
                  </div>
                  <div>
                    <p class="size">{{ poAttch?.size || 0 }}</p>
                  </div>
                  <div>
                    <p>{{ poAttch?.createdOn | date : "MMMM d, y" }}</p>
                  </div>
                  <div
                    class="delete-icon"
                    (click)="downloadFiles(poAttch.id, poAttch.fileName)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                        fill="#666666"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="files-list">
              <ng-container
                *ngIf="rfqItem.attachments.length && archivedPOFile?.length"
              >
                <h3 class="pb-3">Previous Uploaded P.O.</h3>
              </ng-container>

              <div *ngFor="let poAttch of rfqItem.attachments">
                <div
                  class="single-file flex justify-content-between"
                  *ngIf="
                    poAttch?.fileType === FileType.PO &&
                    poAttch?.fileStatus === fileStatus.Archive
                  "
                >
                  <div class="rfq-item rfq-icon">
                    <span class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <mask
                          id="mask0_5589_19343"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_5589_19343)">
                          <path
                            d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    </span>
                    <h4
                      class="name"
                      matTooltip="{{
                        getSingleFileName(
                          poAttch?.name || poAttch?.fileName || ''
                        )
                      }}"
                    >
                      {{
                        getSingleFileName(
                          poAttch?.name || poAttch?.fileName || ""
                        )
                      }}
                    </h4>
                  </div>
                  <div>
                    <p
                      class="type"
                      matTooltip="{{ getSingleFileExt(poAttch?.type) }}"
                    >
                      {{ getSingleFileExt(poAttch?.type) }}
                    </p>
                  </div>
                  <div>
                    <p>.{{ poAttch?.createdOn | date : "MMM d, y" }}</p>
                  </div>
                  <div>
                    <p class="size">{{ poAttch?.size || 0 }}</p>
                  </div>
                  <div>
                    <p>{{ poAttch?.createdOn | date : "MMMM d, y" }}</p>
                  </div>
                  <div
                    class="delete-icon"
                    (click)="downloadFiles(poAttch.id, poAttch.fileName)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                        fill="#666666"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="files-list">
              <h3 class="pb-3">Previous Uploaded Files</h3>
              <div *ngFor="let files of getFileTypes(); let i = index">
                <div *ngIf="files.key !== FileTypeLabel.PO">
                  <h3 class="font-12 medium">
                    {{ getFileTypeLabel(files.key) }}
                  </h3>
                  <div *ngIf="files.value">
                    <div *ngFor="let file of files.value">
                      <div
                        class="single-file flex justify-content-between"
                        *ngIf="file.fileStatus === fileStatus.Live"
                      >
                        <!-- <div class="single-file flex justify-content-between" *ngFor="let file of files.value"> -->
                        <div class="rfq-item rfq-icon">
                          <span class="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <mask
                                id="mask0_5589_19343"
                                style="mask-type: alpha"
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="20"
                                height="20"
                              >
                                <rect width="20" height="20" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_5589_19343)">
                                <path
                                  d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                                  fill="#333333"
                                />
                              </g>
                            </svg>
                          </span>

                          <h4
                            title="{{
                              getFileName(file?.name || file?.fileName)
                            }}"
                            class="name"
                          >
                            {{ getFileName(file?.name || file?.fileName) }}
                          </h4>
                        </div>

                        <div>
                          <p
                            class="type"
                            title="{{
                              getFileExt(file?.name || file?.fileName)
                            }}"
                          >
                            {{ getFileExt(file?.name || file?.fileName) }}
                          </p>
                        </div>

                        <div>
                          <p class="size">{{ file.size }}</p>
                        </div>

                        <div>
                          <p class="size">
                            {{ file.createdOn | date : "MMMM d, y" }}
                          </p>
                        </div>

                        <div class="delete-icon" (click)="saveFile(file)">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                              fill="#666666"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- returned quote-->
              <label class="label" *ngIf="isPreviousQuote(rfqItem?.attachments)"
                >Previous Quote</label
              >
              <div
                *ngFor="let attachFile of rfqItem?.attachments; let i = index"
              >
                <div
                  class="quoteReason"
                  *ngIf="
                    (attachFile?.fileType === FileType.Quote ||
                      attachFile?.fileType === FileType.Quote_Tooling ||
                      attachFile?.fileType === FileType.Quote_Component ||
                      attachFile?.fileType === FileType.Quote_Capex) &&
                    attachFile?.fileStatus === fileStatus.Archive
                  "
                >
                  <h4 class="font-12 medium flex">
                    Reason for return
                    <span class="date ml-auto">{{
                      attachFile?.createdOn | date : "MMM d, y"
                    }}</span>
                  </h4>
                  <p class="font-12">{{ attachFile?.returnReason }}</p>

                  <h4 class="font-12 medium" *ngIf="attachFile?.returnOthers">
                    Remarks
                  </h4>
                  <p class="font-12" *ngIf="attachFile?.returnOthers">
                    {{ attachFile?.returnOthers }}
                  </p>
                  <div class="returnFile">
                    <div class="rfq-item rfq-icon">
                      <span class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5589_19343"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5589_19343)">
                            <path
                              d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                              fill="#333333"
                            />
                          </g>
                        </svg>
                      </span>
                      <h4
                        class="name"
                        matTooltip="{{ getFileName(attachFile?.fileName) }}"
                      >
                        {{ getFileName(attachFile?.fileName) }}
                      </h4>
                    </div>

                    <div class="align-items-center">
                      <p
                        class="type"
                        matTooltip="{{ getFileExt(attachFile?.fileName) }}"
                      >
                        .{{ getFileExt(attachFile?.fileName) }}
                      </p>
                    </div>

                    <div class="align-items-center">
                      <p class="size">{{ attachFile?.size }}</p>
                    </div>
                    <div class="download-file">
                      <span
                        class="iconCenter"
                        (click)="
                          downloadFiles(attachFile?.id, attachFile?.fileName)
                        "
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_8832_38514"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                          >
                            <rect width="24" height="24" fill="#D9D9D9"></rect>
                          </mask>
                          <g mask="url(#mask0_8832_38514)">
                            <path
                              d="M12 15.7884L7.7308 11.5192L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5192L12 15.7884ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6922V14.9807H5.99997V17.6922C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6922V14.9807H19.5V17.6922C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
                              fill="#DA2128"
                            ></path>
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- returned quote end -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter">
    <button
      id="modules_rfq_rfqquote_20"
      mat-button
      class="drafts-button"
      (click)="closeUploadPo()"
    >
      Close
    </button>
  </div>
</ng-container>
<!-- quote po raise end-->

<!-- quote ready for returned start-->
<ng-container
  *ngIf="
    rfqItem?.status == RFQStatus.QUOTE_READY && quotreReturn && !Sendarchive
  "
>
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_21"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>
      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>
          <div class="rfqInfo col-lg-4 col-md-4">
            <div class="category-chips-and-more">
              <h4>Category</h4>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
              <span
                (click)="isExpanded = true"
                *ngIf="!isExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>
        <div *ngIf="isExpanded && !rfqItem?.createdByShop" class="mt-10">
          <h4>Materials</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let material of (rfqItem?.materials | categoryFormatter : 10)
                    .display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (rfqItem?.materials | categoryFormatter : 10).tooltip
                  "
                >
                  {{ material }}
                </span>
              </mat-chip>
            </div>
            <span (click)="isExpanded = false" class="more-less-button">
              <mat-icon>expand_less</mat-icon></span
            >
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="step-2">
            <div class="step_heading">
              <h4 class="step-title pb-5">
                New attachments:
                <span class="attach" *ngIf="files.length > 0">
                  <span class="icon"> </span>
                  {{ files.length }}
                  file(s)
                </span>
              </h4>
              <div class="icon">
                <span
                  ><svg
                    (click)="navExpantion()"
                    *ngIf="isExpanded"
                    xmlns="http://www.w3.org/2000/svg"
                    class="badge-notfication"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path
                      d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                    /></svg
                ></span>

                <svg
                  (click)="closeNavExpantion()"
                  *ngIf="!isExpanded"
                  xmlns="http://www.w3.org/2000/svg"
                  class=""
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path
                    d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                  />
                </svg>
              </div>
            </div>

            <div
              class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
              appDnd
              #fileDropRef
              id="fileDropRef"
              *ngIf="fileUpload"
              (fileDropped)="onFileDropped($event)"
            >
              <input
                id="modules_rfq_rfqquote_22"
                type="file"
                #fileSelector
                multiple
                (change)="fileBrowseHandler($event)"
                accept=".xlsx"
                style="display: none"
              />
              <h4 class="file-uploader-label">Upload New Files</h4>
              <p class="file-uploader-size-label">(Max file size: 100MB)</p>
              <p class="file-uploader-drag-drop-label">
                Drag & Drop .xlsx File Or
              </p>

              <p class="choose-file-button" (click)="chooseFiles()">
                Choose File
              </p>
            </div>
            <div class="files-list" *ngIf="files.length > 0">
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of files; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4 class="name" matTooltip="{{ getFileName(file?.name) }}">
                    {{ getFileName(file?.name) }}
                  </h4>
                </div>

                <div>
                  <p class="type" matTooltip="{{ getFileExt(file?.name) }}">
                    {{ getFileExt(file?.name) }}
                  </p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(file?.size) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="deleteFile(i)"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiftQuote alignCenter">
          <div class="swiftIco">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="69"
              height="76"
              viewBox="0 0 69 76"
              fill="none"
            >
              <g opacity="0.7">
                <mask id="path-1-inside-1_7835_6707" fill="white">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M60.8 61.3418V62.0667H68.4V64.6C68.4 68.0992 65.5658 70.9333 62.0667 70.9333H60.8V72.2C60.8 74.29 59.09 76 57 76H3.8C1.71 76 0 74.29 0 72.2V3.8C0 1.71 1.71 0 3.8 0H57C59.09 0 60.8 1.71 60.8 3.8V39.9916C60.1547 39.872 59.4894 39.8095 58.8095 39.8095C58.6275 39.8095 58.4465 39.814 58.2667 39.8229V3.8C58.2667 3.10333 57.6967 2.53333 57 2.53333H3.8C3.10333 2.53333 2.53333 3.10333 2.53333 3.8V64.6C2.53333 66.7058 4.2275 68.4 6.33333 68.4C8.43917 68.4 10.1333 66.7058 10.1333 64.6V62.0667H58.2667V61.5105C58.4465 61.5193 58.6275 61.5238 58.8095 61.5238C59.4894 61.5238 60.1547 61.4613 60.8 61.3418ZM49.2046 55.7333C49.698 56.6666 50.3234 57.5194 51.0559 58.2666H40.5333V55.7333H49.2046ZM47.9524 50.6667C47.9524 51.539 48.0553 52.3872 48.2495 53.2H34.2V50.6667H47.9524ZM54.4667 40.7129V17.7333H6.33336V48.1333H48.2495C48.4628 47.241 48.7862 46.3915 49.2047 45.6H43.0667V26.6H51.9334V42.2641C52.6978 41.6378 53.5492 41.1138 54.4667 40.7129ZM57 73.4667C57.6967 73.4667 58.2667 72.8967 58.2667 72.2V70.9333H6.33333C4.95583 70.9333 3.62583 70.49 2.53333 69.6667V72.2C2.53333 72.8967 3.10333 73.4667 3.8 73.4667H57ZM11.4 68.4H62.0667C64.1567 68.4 65.8667 66.69 65.8667 64.6H12.6667C12.6667 65.9775 12.2233 67.3075 11.4 68.4ZM8.86669 45.6H27.8667V26.6H8.86669V45.6ZM8.86669 24.0666H27.8667V20.2666H8.86669V24.0666ZM30.4 45.6H40.5334V26.6H30.4V45.6ZM30.4 24.0666H40.5334V20.2666H30.4V24.0666ZM43.0667 24.0666H51.9334V20.2666H43.0667V24.0666ZM44.3334 6.33333H41.8V8.86667H44.3334V6.33333ZM46.8667 6.33333H54.4667V8.86667H46.8667V6.33333ZM54.4667 11.4H41.8V13.9334H54.4667V11.4ZM6.33336 6.33333H16.4667V8.86667H6.33336V6.33333ZM19 11.4H6.33336V13.9334H19V11.4ZM19 50.6667H6.33336V53.2H19V50.6667ZM22.8 29.1333H11.4V31.6667H22.8V29.1333ZM11.4 34.2H19V36.7333H11.4V34.2ZM19 39.2667H11.4V41.8H19V39.2667ZM32.9334 29.1333H38V31.6667H32.9334V29.1333ZM38 34.2H32.9334V36.7333H38V34.2ZM32.9334 39.2667H38V41.8H32.9334V39.2667ZM49.4 29.1333H45.6V31.6667H49.4V29.1333ZM45.6 34.2H49.4V36.7333H45.6V34.2ZM49.4 39.2667H45.6V41.8H49.4V39.2667Z"
                  />
                </mask>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M60.8 61.3418V62.0667H68.4V64.6C68.4 68.0992 65.5658 70.9333 62.0667 70.9333H60.8V72.2C60.8 74.29 59.09 76 57 76H3.8C1.71 76 0 74.29 0 72.2V3.8C0 1.71 1.71 0 3.8 0H57C59.09 0 60.8 1.71 60.8 3.8V39.9916C60.1547 39.872 59.4894 39.8095 58.8095 39.8095C58.6275 39.8095 58.4465 39.814 58.2667 39.8229V3.8C58.2667 3.10333 57.6967 2.53333 57 2.53333H3.8C3.10333 2.53333 2.53333 3.10333 2.53333 3.8V64.6C2.53333 66.7058 4.2275 68.4 6.33333 68.4C8.43917 68.4 10.1333 66.7058 10.1333 64.6V62.0667H58.2667V61.5105C58.4465 61.5193 58.6275 61.5238 58.8095 61.5238C59.4894 61.5238 60.1547 61.4613 60.8 61.3418ZM49.2046 55.7333C49.698 56.6666 50.3234 57.5194 51.0559 58.2666H40.5333V55.7333H49.2046ZM47.9524 50.6667C47.9524 51.539 48.0553 52.3872 48.2495 53.2H34.2V50.6667H47.9524ZM54.4667 40.7129V17.7333H6.33336V48.1333H48.2495C48.4628 47.241 48.7862 46.3915 49.2047 45.6H43.0667V26.6H51.9334V42.2641C52.6978 41.6378 53.5492 41.1138 54.4667 40.7129ZM57 73.4667C57.6967 73.4667 58.2667 72.8967 58.2667 72.2V70.9333H6.33333C4.95583 70.9333 3.62583 70.49 2.53333 69.6667V72.2C2.53333 72.8967 3.10333 73.4667 3.8 73.4667H57ZM11.4 68.4H62.0667C64.1567 68.4 65.8667 66.69 65.8667 64.6H12.6667C12.6667 65.9775 12.2233 67.3075 11.4 68.4ZM8.86669 45.6H27.8667V26.6H8.86669V45.6ZM8.86669 24.0666H27.8667V20.2666H8.86669V24.0666ZM30.4 45.6H40.5334V26.6H30.4V45.6ZM30.4 24.0666H40.5334V20.2666H30.4V24.0666ZM43.0667 24.0666H51.9334V20.2666H43.0667V24.0666ZM44.3334 6.33333H41.8V8.86667H44.3334V6.33333ZM46.8667 6.33333H54.4667V8.86667H46.8667V6.33333ZM54.4667 11.4H41.8V13.9334H54.4667V11.4ZM6.33336 6.33333H16.4667V8.86667H6.33336V6.33333ZM19 11.4H6.33336V13.9334H19V11.4ZM19 50.6667H6.33336V53.2H19V50.6667ZM22.8 29.1333H11.4V31.6667H22.8V29.1333ZM11.4 34.2H19V36.7333H11.4V34.2ZM19 39.2667H11.4V41.8H19V39.2667ZM32.9334 29.1333H38V31.6667H32.9334V29.1333ZM38 34.2H32.9334V36.7333H38V34.2ZM32.9334 39.2667H38V41.8H32.9334V39.2667ZM49.4 29.1333H45.6V31.6667H49.4V29.1333ZM45.6 34.2H49.4V36.7333H45.6V34.2ZM49.4 39.2667H45.6V41.8H49.4V39.2667Z"
                  fill="#999999"
                />
                <path
                  d="M60.8 62.0667H60.65V62.2167H60.8V62.0667ZM60.8 61.3418H60.95V61.1614L60.7727 61.1943L60.8 61.3418ZM68.4 62.0667H68.55V61.9167H68.4V62.0667ZM60.8 70.9333V70.7833H60.65V70.9333H60.8ZM60.8 39.9916L60.7727 40.1391L60.95 40.1719V39.9916H60.8ZM58.2667 39.8229H58.1167V39.9804L58.274 39.9727L58.2667 39.8229ZM10.1333 62.0667V61.9167H9.98333V62.0667H10.1333ZM58.2667 62.0667V62.2167H58.4167V62.0667H58.2667ZM58.2667 61.5105L58.274 61.3607L58.1167 61.3529V61.5105H58.2667ZM51.0559 58.2666V58.4166H51.413L51.1631 58.1616L51.0559 58.2666ZM49.2046 55.7333L49.3372 55.6632L49.295 55.5833H49.2046V55.7333ZM40.5333 58.2666H40.3833V58.4166H40.5333V58.2666ZM40.5333 55.7333V55.5833H40.3833V55.7333H40.5333ZM48.2495 53.2V53.35H48.4396L48.3954 53.1651L48.2495 53.2ZM47.9524 50.6667H48.1024V50.5167H47.9524V50.6667ZM34.2 53.2H34.05V53.35H34.2V53.2ZM34.2 50.6667V50.5167H34.05V50.6667H34.2ZM54.4667 40.7129L54.5268 40.8504L54.6167 40.8111V40.7129H54.4667ZM54.4667 17.7333H54.6167V17.5833H54.4667V17.7333ZM6.33336 17.7333V17.5833H6.18336V17.7333H6.33336ZM6.33336 48.1333H6.18336V48.2833H6.33336V48.1333ZM48.2495 48.1333V48.2833H48.3679L48.3954 48.1682L48.2495 48.1333ZM49.2047 45.6L49.3373 45.6701L49.4536 45.45H49.2047V45.6ZM43.0667 45.6H42.9167V45.75H43.0667V45.6ZM43.0667 26.6V26.45H42.9167V26.6H43.0667ZM51.9334 26.6H52.0834V26.45H51.9334V26.6ZM51.9334 42.2641H51.7834V42.5809L52.0284 42.3801L51.9334 42.2641ZM58.2667 70.9333H58.4167V70.7833H58.2667V70.9333ZM2.53333 69.6667L2.62361 69.5469L2.38333 69.3658V69.6667H2.53333ZM11.4 68.4L11.2802 68.3097L11.0991 68.55H11.4V68.4ZM65.8667 64.6H66.0167V64.45H65.8667V64.6ZM12.6667 64.6V64.45H12.5167V64.6H12.6667ZM27.8667 45.6V45.75H28.0167V45.6H27.8667ZM8.86669 45.6H8.71669V45.75H8.86669V45.6ZM27.8667 26.6H28.0167V26.45H27.8667V26.6ZM8.86669 26.6V26.45H8.71669V26.6H8.86669ZM27.8667 24.0666V24.2166H28.0167V24.0666H27.8667ZM8.86669 24.0666H8.71669V24.2166H8.86669V24.0666ZM27.8667 20.2666H28.0167V20.1166H27.8667V20.2666ZM8.86669 20.2666V20.1166H8.71669V20.2666H8.86669ZM40.5334 45.6V45.75H40.6834V45.6H40.5334ZM30.4 45.6H30.25V45.75H30.4V45.6ZM40.5334 26.6H40.6834V26.45H40.5334V26.6ZM30.4 26.6V26.45H30.25V26.6H30.4ZM40.5334 24.0666V24.2166H40.6834V24.0666H40.5334ZM30.4 24.0666H30.25V24.2166H30.4V24.0666ZM40.5334 20.2666H40.6834V20.1166H40.5334V20.2666ZM30.4 20.2666V20.1166H30.25V20.2666H30.4ZM51.9334 24.0666V24.2166H52.0834V24.0666H51.9334ZM43.0667 24.0666H42.9167V24.2166H43.0667V24.0666ZM51.9334 20.2666H52.0834V20.1166H51.9334V20.2666ZM43.0667 20.2666V20.1166H42.9167V20.2666H43.0667ZM41.8 6.33333V6.18333H41.65V6.33333H41.8ZM44.3334 6.33333H44.4834V6.18333H44.3334V6.33333ZM41.8 8.86667H41.65V9.01667H41.8V8.86667ZM44.3334 8.86667V9.01667H44.4834V8.86667H44.3334ZM54.4667 6.33333H54.6167V6.18333H54.4667V6.33333ZM46.8667 6.33333V6.18333H46.7167V6.33333H46.8667ZM54.4667 8.86667V9.01667H54.6167V8.86667H54.4667ZM46.8667 8.86667H46.7167V9.01667H46.8667V8.86667ZM41.8 11.4V11.25H41.65V11.4H41.8ZM54.4667 11.4H54.6167V11.25H54.4667V11.4ZM41.8 13.9334H41.65V14.0834H41.8V13.9334ZM54.4667 13.9334V14.0834H54.6167V13.9334H54.4667ZM16.4667 6.33333H16.6167V6.18333H16.4667V6.33333ZM6.33336 6.33333V6.18333H6.18336V6.33333H6.33336ZM16.4667 8.86667V9.01667H16.6167V8.86667H16.4667ZM6.33336 8.86667H6.18336V9.01667H6.33336V8.86667ZM6.33336 11.4V11.25H6.18336V11.4H6.33336ZM19 11.4H19.15V11.25H19V11.4ZM6.33336 13.9334H6.18336V14.0834H6.33336V13.9334ZM19 13.9334V14.0834H19.15V13.9334H19ZM6.33336 50.6667V50.5167H6.18336V50.6667H6.33336ZM19 50.6667H19.15V50.5167H19V50.6667ZM6.33336 53.2H6.18336V53.35H6.33336V53.2ZM19 53.2V53.35H19.15V53.2H19ZM11.4 29.1333V28.9833H11.25V29.1333H11.4ZM22.8 29.1333H22.95V28.9833H22.8V29.1333ZM11.4 31.6667H11.25V31.8167H11.4V31.6667ZM22.8 31.6667V31.8167H22.95V31.6667H22.8ZM19 34.2H19.15V34.05H19V34.2ZM11.4 34.2V34.05H11.25V34.2H11.4ZM19 36.7333V36.8833H19.15V36.7333H19ZM11.4 36.7333H11.25V36.8833H11.4V36.7333ZM11.4 39.2667V39.1167H11.25V39.2667H11.4ZM19 39.2667H19.15V39.1167H19V39.2667ZM11.4 41.8H11.25V41.95H11.4V41.8ZM19 41.8V41.95H19.15V41.8H19ZM38 29.1333H38.15V28.9833H38V29.1333ZM32.9334 29.1333V28.9833H32.7834V29.1333H32.9334ZM38 31.6667V31.8167H38.15V31.6667H38ZM32.9334 31.6667H32.7834V31.8167H32.9334V31.6667ZM32.9334 34.2V34.05H32.7834V34.2H32.9334ZM38 34.2H38.15V34.05H38V34.2ZM32.9334 36.7333H32.7834V36.8833H32.9334V36.7333ZM38 36.7333V36.8833H38.15V36.7333H38ZM38 39.2667H38.15V39.1167H38V39.2667ZM32.9334 39.2667V39.1167H32.7834V39.2667H32.9334ZM38 41.8V41.95H38.15V41.8H38ZM32.9334 41.8H32.7834V41.95H32.9334V41.8ZM45.6 29.1333V28.9833H45.45V29.1333H45.6ZM49.4 29.1333H49.55V28.9833H49.4V29.1333ZM45.6 31.6667H45.45V31.8167H45.6V31.6667ZM49.4 31.6667V31.8167H49.55V31.6667H49.4ZM49.4 34.2H49.55V34.05H49.4V34.2ZM45.6 34.2V34.05H45.45V34.2H45.6ZM49.4 36.7333V36.8833H49.55V36.7333H49.4ZM45.6 36.7333H45.45V36.8833H45.6V36.7333ZM45.6 39.2667V39.1167H45.45V39.2667H45.6ZM49.4 39.2667H49.55V39.1167H49.4V39.2667ZM45.6 41.8H45.45V41.95H45.6V41.8ZM49.4 41.8V41.95H49.55V41.8H49.4ZM60.95 62.0667V61.3418H60.65V62.0667H60.95ZM68.4 61.9167H60.8V62.2167H68.4V61.9167ZM68.55 64.6V62.0667H68.25V64.6H68.55ZM62.0667 71.0833C65.6487 71.0833 68.55 68.182 68.55 64.6H68.25C68.25 68.0163 65.483 70.7833 62.0667 70.7833V71.0833ZM60.8 71.0833H62.0667V70.7833H60.8V71.0833ZM60.95 72.2V70.9333H60.65V72.2H60.95ZM57 76.15C59.1728 76.15 60.95 74.3728 60.95 72.2H60.65C60.65 74.2072 59.0072 75.85 57 75.85V76.15ZM3.8 76.15H57V75.85H3.8V76.15ZM-0.15 72.2C-0.15 74.3728 1.62716 76.15 3.8 76.15V75.85C1.79284 75.85 0.15 74.2072 0.15 72.2H-0.15ZM-0.15 3.8V72.2H0.15V3.8H-0.15ZM3.8 -0.15C1.62716 -0.15 -0.15 1.62716 -0.15 3.8H0.15C0.15 1.79284 1.79284 0.15 3.8 0.15V-0.15ZM57 -0.15H3.8V0.15H57V-0.15ZM60.95 3.8C60.95 1.62716 59.1728 -0.15 57 -0.15V0.15C59.0072 0.15 60.65 1.79284 60.65 3.8H60.95ZM60.95 39.9916V3.8H60.65V39.9916H60.95ZM58.8095 39.9595C59.4802 39.9595 60.1364 40.0212 60.7727 40.1391L60.8273 39.8441C60.1731 39.7229 59.4986 39.6595 58.8095 39.6595V39.9595ZM58.274 39.9727C58.4514 39.9639 58.63 39.9595 58.8095 39.9595V39.6595C58.625 39.6595 58.4416 39.6641 58.2593 39.673L58.274 39.9727ZM58.1167 3.8V39.8229H58.4167V3.8H58.1167ZM57 2.68333C57.6138 2.68333 58.1167 3.18618 58.1167 3.8H58.4167C58.4167 3.02049 57.7795 2.38333 57 2.38333V2.68333ZM3.8 2.68333H57V2.38333H3.8V2.68333ZM2.68333 3.8C2.68333 3.18618 3.18618 2.68333 3.8 2.68333V2.38333C3.02049 2.38333 2.38333 3.02049 2.38333 3.8H2.68333ZM2.68333 64.6V3.8H2.38333V64.6H2.68333ZM6.33333 68.25C4.31034 68.25 2.68333 66.623 2.68333 64.6H2.38333C2.38333 66.7887 4.14466 68.55 6.33333 68.55V68.25ZM9.98333 64.6C9.98333 66.623 8.35632 68.25 6.33333 68.25V68.55C8.52201 68.55 10.2833 66.7887 10.2833 64.6H9.98333ZM9.98333 62.0667V64.6H10.2833V62.0667H9.98333ZM58.2667 61.9167H10.1333V62.2167H58.2667V61.9167ZM58.1167 61.5105V62.0667H58.4167V61.5105H58.1167ZM58.8095 61.3738C58.63 61.3738 58.4514 61.3694 58.274 61.3607L58.2593 61.6603C58.4416 61.6693 58.625 61.6738 58.8095 61.6738V61.3738ZM60.7727 61.1943C60.1364 61.3122 59.4802 61.3738 58.8095 61.3738V61.6738C59.4986 61.6738 60.1731 61.6105 60.8273 61.4892L60.7727 61.1943ZM51.1631 58.1616C50.4405 57.4246 49.8238 56.5836 49.3372 55.6632L49.072 55.8034C49.5722 56.7496 50.2062 57.6141 50.9488 58.3717L51.1631 58.1616ZM40.5333 58.4166H51.0559V58.1166H40.5333V58.4166ZM40.3833 55.7333V58.2666H40.6833V55.7333H40.3833ZM49.2046 55.5833H40.5333V55.8833H49.2046V55.5833ZM48.3954 53.1651C48.2039 52.3637 48.1024 51.5271 48.1024 50.6667H47.8024C47.8024 51.5508 47.9067 52.4108 48.1036 53.2349L48.3954 53.1651ZM34.2 53.35H48.2495V53.05H34.2V53.35ZM34.05 50.6667V53.2H34.35V50.6667H34.05ZM47.9524 50.5167H34.2V50.8167H47.9524V50.5167ZM54.6167 40.7129V17.7333H54.3167V40.7129H54.6167ZM54.4667 17.5833H6.33336V17.8833H54.4667V17.5833ZM6.18336 17.7333V48.1333H6.48336V17.7333H6.18336ZM6.33336 48.2833H48.2495V47.9833H6.33336V48.2833ZM48.3954 48.1682C48.6057 47.2883 48.9246 46.4506 49.3373 45.6701L49.072 45.5299C48.6478 46.3324 48.3199 47.1937 48.1036 48.0984L48.3954 48.1682ZM49.2047 45.45H43.0667V45.75H49.2047V45.45ZM43.2167 45.6V26.6H42.9167V45.6H43.2167ZM43.0667 26.75H51.9334V26.45H43.0667V26.75ZM51.7834 26.6V42.2641H52.0834V26.6H51.7834ZM52.0284 42.3801C52.7823 41.7625 53.622 41.2457 54.5268 40.8504L54.4066 40.5755C53.4764 40.9819 52.6132 41.5132 51.8383 42.1481L52.0284 42.3801ZM58.1167 72.2C58.1167 72.8138 57.6138 73.3167 57 73.3167V73.6167C57.7795 73.6167 58.4167 72.9795 58.4167 72.2H58.1167ZM58.1167 70.9333V72.2H58.4167V70.9333H58.1167ZM6.33333 71.0833H58.2667V70.7833H6.33333V71.0833ZM2.44306 69.7865C3.56176 70.6295 4.9235 71.0833 6.33333 71.0833V70.7833C4.98816 70.7833 3.6899 70.3505 2.62361 69.5469L2.44306 69.7865ZM2.68333 72.2V69.6667H2.38333V72.2H2.68333ZM3.8 73.3167C3.18618 73.3167 2.68333 72.8138 2.68333 72.2H2.38333C2.38333 72.9795 3.02049 73.6167 3.8 73.6167V73.3167ZM57 73.3167H3.8V73.6167H57V73.3167ZM62.0667 68.25H11.4V68.55H62.0667V68.25ZM65.7167 64.6C65.7167 66.6072 64.0738 68.25 62.0667 68.25V68.55C64.2395 68.55 66.0167 66.7728 66.0167 64.6H65.7167ZM12.6667 64.75H65.8667V64.45H12.6667V64.75ZM11.5198 68.4903C12.3629 67.3716 12.8167 66.0098 12.8167 64.6H12.5167C12.5167 65.9452 12.0838 67.2434 11.2802 68.3097L11.5198 68.4903ZM27.8667 45.45H8.86669V45.75H27.8667V45.45ZM27.7167 26.6V45.6H28.0167V26.6H27.7167ZM8.86669 26.75H27.8667V26.45H8.86669V26.75ZM9.01669 45.6V26.6H8.71669V45.6H9.01669ZM27.8667 23.9166H8.86669V24.2166H27.8667V23.9166ZM27.7167 20.2666V24.0666H28.0167V20.2666H27.7167ZM8.86669 20.4166H27.8667V20.1166H8.86669V20.4166ZM9.01669 24.0666V20.2666H8.71669V24.0666H9.01669ZM40.5334 45.45H30.4V45.75H40.5334V45.45ZM40.3834 26.6V45.6H40.6834V26.6H40.3834ZM30.4 26.75H40.5334V26.45H30.4V26.75ZM30.55 45.6V26.6H30.25V45.6H30.55ZM40.5334 23.9166H30.4V24.2166H40.5334V23.9166ZM40.3834 20.2666V24.0666H40.6834V20.2666H40.3834ZM30.4 20.4166H40.5334V20.1166H30.4V20.4166ZM30.55 24.0666V20.2666H30.25V24.0666H30.55ZM51.9334 23.9166H43.0667V24.2166H51.9334V23.9166ZM51.7834 20.2666V24.0666H52.0834V20.2666H51.7834ZM43.0667 20.4166H51.9334V20.1166H43.0667V20.4166ZM43.2167 24.0666V20.2666H42.9167V24.0666H43.2167ZM41.8 6.48333H44.3334V6.18333H41.8V6.48333ZM41.95 8.86667V6.33333H41.65V8.86667H41.95ZM44.3334 8.71667H41.8V9.01667H44.3334V8.71667ZM44.1834 6.33333V8.86667H44.4834V6.33333H44.1834ZM54.4667 6.18333H46.8667V6.48333H54.4667V6.18333ZM54.6167 8.86667V6.33333H54.3167V8.86667H54.6167ZM46.8667 9.01667H54.4667V8.71667H46.8667V9.01667ZM46.7167 6.33333V8.86667H47.0167V6.33333H46.7167ZM41.8 11.55H54.4667V11.25H41.8V11.55ZM41.95 13.9334V11.4H41.65V13.9334H41.95ZM54.4667 13.7834H41.8V14.0834H54.4667V13.7834ZM54.3167 11.4V13.9334H54.6167V11.4H54.3167ZM16.4667 6.18333H6.33336V6.48333H16.4667V6.18333ZM16.6167 8.86667V6.33333H16.3167V8.86667H16.6167ZM6.33336 9.01667H16.4667V8.71667H6.33336V9.01667ZM6.18336 6.33333V8.86667H6.48336V6.33333H6.18336ZM6.33336 11.55H19V11.25H6.33336V11.55ZM6.48336 13.9334V11.4H6.18336V13.9334H6.48336ZM19 13.7834H6.33336V14.0834H19V13.7834ZM18.85 11.4V13.9334H19.15V11.4H18.85ZM6.33336 50.8167H19V50.5167H6.33336V50.8167ZM6.48336 53.2V50.6667H6.18336V53.2H6.48336ZM19 53.05H6.33336V53.35H19V53.05ZM18.85 50.6667V53.2H19.15V50.6667H18.85ZM11.4 29.2833H22.8V28.9833H11.4V29.2833ZM11.55 31.6667V29.1333H11.25V31.6667H11.55ZM22.8 31.5167H11.4V31.8167H22.8V31.5167ZM22.65 29.1333V31.6667H22.95V29.1333H22.65ZM19 34.05H11.4V34.35H19V34.05ZM19.15 36.7333V34.2H18.85V36.7333H19.15ZM11.4 36.8833H19V36.5833H11.4V36.8833ZM11.25 34.2V36.7333H11.55V34.2H11.25ZM11.4 39.4167H19V39.1167H11.4V39.4167ZM11.55 41.8V39.2667H11.25V41.8H11.55ZM19 41.65H11.4V41.95H19V41.65ZM18.85 39.2667V41.8H19.15V39.2667H18.85ZM38 28.9833H32.9334V29.2833H38V28.9833ZM38.15 31.6667V29.1333H37.85V31.6667H38.15ZM32.9334 31.8167H38V31.5167H32.9334V31.8167ZM32.7834 29.1333V31.6667H33.0834V29.1333H32.7834ZM32.9334 34.35H38V34.05H32.9334V34.35ZM33.0834 36.7333V34.2H32.7834V36.7333H33.0834ZM38 36.5833H32.9334V36.8833H38V36.5833ZM37.85 34.2V36.7333H38.15V34.2H37.85ZM38 39.1167H32.9334V39.4167H38V39.1167ZM38.15 41.8V39.2667H37.85V41.8H38.15ZM32.9334 41.95H38V41.65H32.9334V41.95ZM32.7834 39.2667V41.8H33.0834V39.2667H32.7834ZM45.6 29.2833H49.4V28.9833H45.6V29.2833ZM45.75 31.6667V29.1333H45.45V31.6667H45.75ZM49.4 31.5167H45.6V31.8167H49.4V31.5167ZM49.25 29.1333V31.6667H49.55V29.1333H49.25ZM49.4 34.05H45.6V34.35H49.4V34.05ZM49.55 36.7333V34.2H49.25V36.7333H49.55ZM45.6 36.8833H49.4V36.5833H45.6V36.8833ZM45.45 34.2V36.7333H45.75V34.2H45.45ZM45.6 39.4167H49.4V39.1167H45.6V39.4167ZM45.75 41.8V39.2667H45.45V41.8H45.75ZM49.4 41.65H45.6V41.95H49.4V41.65ZM49.25 39.2667V41.8H49.55V39.2667H49.25Z"
                  fill="white"
                  mask="url(#path-1-inside-1_7835_6707)"
                />
              </g>
              <path
                d="M58.8631 56.2546C59.1833 56.2546 59.4539 56.144 59.6749 55.923C59.896 55.7019 60.0065 55.4313 60.0065 55.1112C60.0065 54.791 59.896 54.5204 59.6749 54.2994C59.4539 54.0783 59.1833 53.9678 58.8631 53.9678C58.543 53.9678 58.2724 54.0783 58.0513 54.2994C57.8303 54.5204 57.7197 54.791 57.7197 55.1112C57.7197 55.4313 57.8303 55.7019 58.0513 55.923C58.2724 56.144 58.543 56.2546 58.8631 56.2546ZM58.0399 52.7329H59.7321C59.7321 52.2298 59.7893 51.8334 59.9036 51.5438C60.018 51.2541 60.3419 50.8578 60.8755 50.3547C61.2719 49.9583 61.5844 49.581 61.8131 49.2227C62.0418 48.8644 62.1561 48.4338 62.1561 47.9307C62.1561 47.0769 61.8436 46.4214 61.2185 45.964C60.5935 45.5067 59.8541 45.278 59.0003 45.278C58.1314 45.278 57.4263 45.5067 56.8851 45.964C56.3439 46.4214 55.9665 46.9702 55.7531 47.6105L57.2624 48.2051C57.3386 47.9307 57.5101 47.6334 57.7769 47.3132C58.0437 46.9931 58.4515 46.833 59.0003 46.833C59.4882 46.833 59.8541 46.9664 60.098 47.2332C60.3419 47.5 60.4639 47.7935 60.4639 48.1136C60.4639 48.4185 60.3724 48.7044 60.1895 48.9712C60.0065 49.2379 59.7778 49.4857 59.5034 49.7144C58.8326 50.3089 58.421 50.7587 58.2686 51.0636C58.1161 51.3685 58.0399 51.9249 58.0399 52.7329ZM58.9089 59.9134C57.6435 59.9134 56.4544 59.6733 55.3415 59.1931C54.2286 58.7129 53.2605 58.0611 52.4373 57.2379C51.614 56.4146 50.9623 55.4466 50.4821 54.3337C50.0018 53.2208 49.7617 52.0316 49.7617 50.7663C49.7617 49.5009 50.0018 48.3118 50.4821 47.1989C50.9623 46.086 51.614 45.1179 52.4373 44.2947C53.2605 43.4714 54.2286 42.8197 55.3415 42.3395C56.4544 41.8593 57.6435 41.6191 58.9089 41.6191C60.1742 41.6191 61.3633 41.8593 62.4762 42.3395C63.5891 42.8197 64.5572 43.4714 65.3805 44.2947C66.2037 45.1179 66.8554 46.086 67.3357 47.1989C67.8159 48.3118 68.056 49.5009 68.056 50.7663C68.056 52.0316 67.8159 53.2208 67.3357 54.3337C66.8554 55.4466 66.2037 56.4146 65.3805 57.2379C64.5572 58.0611 63.5891 58.7129 62.4762 59.1931C61.3633 59.6733 60.1742 59.9134 58.9089 59.9134ZM58.9089 58.084C60.9517 58.084 62.6821 57.3751 64.0999 55.9573C65.5177 54.5395 66.2266 52.8091 66.2266 50.7663C66.2266 48.7234 65.5177 46.9931 64.0999 45.5753C62.6821 44.1575 60.9517 43.4486 58.9089 43.4486C56.866 43.4486 55.1357 44.1575 53.7179 45.5753C52.3001 46.9931 51.5911 48.7234 51.5911 50.7663C51.5911 52.8091 52.3001 54.5395 53.7179 55.9573C55.1357 57.3751 56.866 58.084 58.9089 58.084Z"
                fill="#E66A70"
              />
            </svg>
          </div>
          <div class="swiftContent">
            <h3 class="medium font-16">
              Are you sure, you want to return the quote?
            </h3>
          </div>
        </div>
        <div class="returnForm">
          <h3 class="medium font-12">Help us understand better</h3>
          <form [formGroup]="returnQuoteForm">
            <div class="formGroup">
              <label>Reason for not accepting the quote<sup>*</sup></label>
              <mat-form-field appearance="outline">
                <mat-select
                  id="modules_rfq_rfqquote_23"
                  placeholder="Select "
                  (selectionChange)="reasonForReturn($event.value)"
                  formControlName="reason"
                >
                  <mat-option value="Price not matching Target cost"
                    >Price not matching Target cost</mat-option
                  >
                  <mat-option value="Delivery period not acceptable."
                    >Delivery period not acceptable.</mat-option
                  >
                  <mat-option
                    value="Technical specifications/ Quality not suitable."
                    >Technical specifications/ Quality not suitable.</mat-option
                  >
                  <mat-option value="Product/Capability not suitable."
                    >Product/Capability not suitable.</mat-option
                  >
                  <mat-option value="Terms and Conditions not acceptable"
                    >Terms and Conditions not acceptable</mat-option
                  >
                  <mat-option value="others">Others</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div *ngIf="otherResonQuoteRetchk" class="formGroup">
              <label class="flex">If others, specify <sup>*</sup></label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  formControlName="detailedReason"
                  placeholder="Specify details
                              "
                ></textarea>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter">
    <button
      id="modules_rfq_rfqquote_24"
      mat-button
      class="drafts-button"
      (click)="backQuote()"
    >
      Back
    </button>
    <button
      id="modules_rfq_rfqquote_25"
      mat-button
      color="primary"
      type="button"
      [ngClass]="{ disabledBut: disabledSubmitQuoteReturn() }"
      [disabled]="disabledSubmitQuoteReturn()"
      class="btnCustom btn-primary"
      (click)="confirmSubmission()"
    >
      Submit Feedback
    </button>
  </div>
</ng-container>
<!-- quote ready for returned end-->

<!-- quote returned start-->
<ng-container
  *ngIf="rfqItem?.status == RFQStatus.QUOTE_RETURNED && !Sendarchive"
>
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_26"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>
      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>
          <div class="rfqInfo col-lg-4 col-md-4">
            <div class="category-chips-and-more">
              <h4>Category</h4>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
              <span
                (click)="isExpanded = true"
                *ngIf="!isExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>
        <div *ngIf="isExpanded" class="mt-10">
          <h4>Materials</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let material of (rfqItem?.materials | categoryFormatter : 10)
                    .display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (rfqItem?.materials | categoryFormatter : 10).tooltip
                  "
                >
                  {{ material }}
                </span>
              </mat-chip>
            </div>
            <span (click)="isExpanded = false" class="more-less-button">
              <mat-icon>expand_less</mat-icon></span
            >
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="step-2">
            <div class="step_heading">
              <h4 class="step-title pb-5">
                New attachments:
                <span class="attach" *ngIf="files.length > 0">
                  <span class="icon"> </span>
                  {{ files.length }}
                  file(s)
                </span>
              </h4>
              <div class="icon">
                <span
                  ><svg
                    (click)="navExpantion()"
                    *ngIf="isExpanded"
                    xmlns="http://www.w3.org/2000/svg"
                    class="badge-notfication"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path
                      d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                    /></svg
                ></span>

                <svg
                  (click)="closeNavExpantion()"
                  *ngIf="!isExpanded"
                  xmlns="http://www.w3.org/2000/svg"
                  class=""
                  height="24"
                  viewBox="0 -960 960 960"
                  width="24"
                >
                  <path
                    d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                  />
                </svg>
              </div>
            </div>

            <div
              class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
              appDnd
              #fileDropRef
              id="fileDropRef"
              *ngIf="fileUpload"
              (fileDropped)="onFileDropped($event)"
            >
              <input
                id="modules_rfq_rfqquote_27"
                type="file"
                #fileSelector
                multiple
                (change)="fileBrowseHandler($event)"
                accept=".xlsx"
                style="display: none"
              />
              <h4 class="file-uploader-label">Upload New Files</h4>
              <p class="file-uploader-size-label">(Max file size: 100MB)</p>
              <p class="file-uploader-drag-drop-label">
                Drag & Drop .xlsx File Or
              </p>

              <p class="choose-file-button" (click)="chooseFiles()">
                Choose File
              </p>
            </div>
            <div class="files-list" *ngIf="files.length > 0">
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of files; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4 class="name" matTooltip="{{ getFileName(file?.name) }}">
                    {{ getFileName(file?.name) }}
                  </h4>
                </div>

                <div>
                  <p class="type" matTooltip="{{ getFileExt(file?.name) }}">
                    {{ getFileExt(file?.name) }}
                  </p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(file?.size) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="deleteFile(i)"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiftQuote alignCenter">
          <div class="swiftIco">
            <svg
              width="69"
              height="76"
              viewBox="0 0 69 76"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.7">
                <mask id="path-1-inside-1_7835_7883" fill="white">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M60.8 61.3417V62.0667H68.4V64.6C68.4 68.0992 65.5658 70.9333 62.0667 70.9333H60.8V72.2C60.8 74.29 59.09 76 57 76H3.8C1.71 76 0 74.29 0 72.2V3.8C0 1.71 1.71 0 3.8 0H57C59.09 0 60.8 1.71 60.8 3.8V39.9916C60.1547 39.872 59.4894 39.8095 58.8095 39.8095C58.6275 39.8095 58.4465 39.814 58.2667 39.8229V3.8C58.2667 3.10333 57.6967 2.53333 57 2.53333H3.8C3.10333 2.53333 2.53333 3.10333 2.53333 3.8V64.6C2.53333 66.7058 4.2275 68.4 6.33333 68.4C8.43917 68.4 10.1333 66.7058 10.1333 64.6V62.0667H58.2667V61.5105C58.4465 61.5193 58.6275 61.5238 58.8095 61.5238C59.4894 61.5238 60.1547 61.4613 60.8 61.3417ZM49.2046 55.7333C49.698 56.6666 50.3234 57.5193 51.0559 58.2666H40.5333V55.7333H49.2046ZM47.9524 50.6667C47.9524 51.539 48.0552 52.3872 48.2495 53.2H34.2V50.6667L47.9524 50.6667ZM54.4667 40.7129V17.7333H6.33336V48.1333H48.2495C48.4628 47.241 48.7862 46.3915 49.2047 45.6H43.0667V26.6H51.9334V42.2641C52.6978 41.6378 53.5492 41.1138 54.4667 40.7129ZM57 73.4667C57.6967 73.4667 58.2667 72.8967 58.2667 72.2V70.9333H6.33333C4.95583 70.9333 3.62583 70.49 2.53333 69.6667V72.2C2.53333 72.8967 3.10333 73.4667 3.8 73.4667H57ZM11.4 68.4H62.0667C64.1567 68.4 65.8667 66.69 65.8667 64.6H12.6667C12.6667 65.9775 12.2233 67.3075 11.4 68.4ZM8.86669 45.6H27.8667V26.6H8.86669V45.6ZM8.86669 24.0666H27.8667V20.2666H8.86669V24.0666ZM30.4 45.6H40.5334V26.6H30.4V45.6ZM30.4 24.0666H40.5334V20.2666H30.4V24.0666ZM43.0667 24.0666H51.9334V20.2666H43.0667V24.0666ZM44.3334 6.33332H41.8V8.86665H44.3334V6.33332ZM46.8667 6.33332H54.4667V8.86665H46.8667V6.33332ZM54.4667 11.4H41.8V13.9334H54.4667V11.4ZM6.33336 6.33332H16.4667V8.86665H6.33336V6.33332ZM19 11.4H6.33336V13.9334H19V11.4ZM19 50.6667H6.33336V53.2H19V50.6667ZM22.8 29.1333H11.4V31.6667H22.8V29.1333ZM11.4 34.2H19V36.7333H11.4V34.2ZM19 39.2667H11.4V41.8H19V39.2667ZM32.9334 29.1333H38V31.6667H32.9334V29.1333ZM38 34.2H32.9334V36.7333H38V34.2ZM32.9334 39.2667H38V41.8H32.9334V39.2667ZM49.4 29.1333H45.6V31.6667H49.4V29.1333ZM45.6 34.2H49.4V36.7333H45.6V34.2ZM49.4 39.2667H45.6V41.8H49.4V39.2667Z"
                  />
                </mask>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M60.8 61.3417V62.0667H68.4V64.6C68.4 68.0992 65.5658 70.9333 62.0667 70.9333H60.8V72.2C60.8 74.29 59.09 76 57 76H3.8C1.71 76 0 74.29 0 72.2V3.8C0 1.71 1.71 0 3.8 0H57C59.09 0 60.8 1.71 60.8 3.8V39.9916C60.1547 39.872 59.4894 39.8095 58.8095 39.8095C58.6275 39.8095 58.4465 39.814 58.2667 39.8229V3.8C58.2667 3.10333 57.6967 2.53333 57 2.53333H3.8C3.10333 2.53333 2.53333 3.10333 2.53333 3.8V64.6C2.53333 66.7058 4.2275 68.4 6.33333 68.4C8.43917 68.4 10.1333 66.7058 10.1333 64.6V62.0667H58.2667V61.5105C58.4465 61.5193 58.6275 61.5238 58.8095 61.5238C59.4894 61.5238 60.1547 61.4613 60.8 61.3417ZM49.2046 55.7333C49.698 56.6666 50.3234 57.5193 51.0559 58.2666H40.5333V55.7333H49.2046ZM47.9524 50.6667C47.9524 51.539 48.0552 52.3872 48.2495 53.2H34.2V50.6667L47.9524 50.6667ZM54.4667 40.7129V17.7333H6.33336V48.1333H48.2495C48.4628 47.241 48.7862 46.3915 49.2047 45.6H43.0667V26.6H51.9334V42.2641C52.6978 41.6378 53.5492 41.1138 54.4667 40.7129ZM57 73.4667C57.6967 73.4667 58.2667 72.8967 58.2667 72.2V70.9333H6.33333C4.95583 70.9333 3.62583 70.49 2.53333 69.6667V72.2C2.53333 72.8967 3.10333 73.4667 3.8 73.4667H57ZM11.4 68.4H62.0667C64.1567 68.4 65.8667 66.69 65.8667 64.6H12.6667C12.6667 65.9775 12.2233 67.3075 11.4 68.4ZM8.86669 45.6H27.8667V26.6H8.86669V45.6ZM8.86669 24.0666H27.8667V20.2666H8.86669V24.0666ZM30.4 45.6H40.5334V26.6H30.4V45.6ZM30.4 24.0666H40.5334V20.2666H30.4V24.0666ZM43.0667 24.0666H51.9334V20.2666H43.0667V24.0666ZM44.3334 6.33332H41.8V8.86665H44.3334V6.33332ZM46.8667 6.33332H54.4667V8.86665H46.8667V6.33332ZM54.4667 11.4H41.8V13.9334H54.4667V11.4ZM6.33336 6.33332H16.4667V8.86665H6.33336V6.33332ZM19 11.4H6.33336V13.9334H19V11.4ZM19 50.6667H6.33336V53.2H19V50.6667ZM22.8 29.1333H11.4V31.6667H22.8V29.1333ZM11.4 34.2H19V36.7333H11.4V34.2ZM19 39.2667H11.4V41.8H19V39.2667ZM32.9334 29.1333H38V31.6667H32.9334V29.1333ZM38 34.2H32.9334V36.7333H38V34.2ZM32.9334 39.2667H38V41.8H32.9334V39.2667ZM49.4 29.1333H45.6V31.6667H49.4V29.1333ZM45.6 34.2H49.4V36.7333H45.6V34.2ZM49.4 39.2667H45.6V41.8H49.4V39.2667Z"
                  fill="#999999"
                />
                <path
                  d="M60.8 62.0667H60.65V62.2167H60.8V62.0667ZM60.8 61.3417H60.95V61.1614L60.7727 61.1943L60.8 61.3417ZM68.4 62.0667H68.55V61.9167H68.4V62.0667ZM60.8 70.9333V70.7833H60.65V70.9333H60.8ZM60.8 39.9916L60.7727 40.1391L60.95 40.1719V39.9916H60.8ZM58.2667 39.8229H58.1167V39.9804L58.274 39.9727L58.2667 39.8229ZM10.1333 62.0667V61.9167H9.98333V62.0667H10.1333ZM58.2667 62.0667V62.2167H58.4167V62.0667H58.2667ZM58.2667 61.5105L58.274 61.3606L58.1167 61.3529V61.5105H58.2667ZM51.0559 58.2666V58.4166H51.413L51.1631 58.1616L51.0559 58.2666ZM49.2046 55.7333L49.3372 55.6632L49.295 55.5833H49.2046V55.7333ZM40.5333 58.2666H40.3833V58.4166H40.5333V58.2666ZM40.5333 55.7333V55.5833H40.3833V55.7333H40.5333ZM48.2495 53.2V53.35H48.4396L48.3954 53.1651L48.2495 53.2ZM47.9524 50.6667H48.1024V50.5167H47.9524V50.6667ZM34.2 53.2H34.05V53.35H34.2V53.2ZM34.2 50.6667V50.5167H34.05V50.6667H34.2ZM54.4667 40.7129L54.5268 40.8504L54.6167 40.8111V40.7129H54.4667ZM54.4667 17.7333H54.6167V17.5833H54.4667V17.7333ZM6.33336 17.7333V17.5833H6.18336V17.7333H6.33336ZM6.33336 48.1333H6.18336V48.2833H6.33336V48.1333ZM48.2495 48.1333V48.2833H48.3679L48.3954 48.1682L48.2495 48.1333ZM49.2047 45.6L49.3373 45.6701L49.4536 45.45H49.2047V45.6ZM43.0667 45.6H42.9167V45.75H43.0667V45.6ZM43.0667 26.6V26.45H42.9167V26.6H43.0667ZM51.9334 26.6H52.0834V26.45H51.9334V26.6ZM51.9334 42.2641H51.7834V42.5809L52.0284 42.3801L51.9334 42.2641ZM58.2667 70.9333H58.4167V70.7833H58.2667V70.9333ZM2.53333 69.6667L2.62361 69.5469L2.38333 69.3658V69.6667H2.53333ZM11.4 68.4L11.2802 68.3097L11.0991 68.55H11.4V68.4ZM65.8667 64.6H66.0167V64.45H65.8667V64.6ZM12.6667 64.6V64.45H12.5167V64.6H12.6667ZM27.8667 45.6V45.75H28.0167V45.6H27.8667ZM8.86669 45.6H8.71669V45.75H8.86669V45.6ZM27.8667 26.6H28.0167V26.45H27.8667V26.6ZM8.86669 26.6V26.45H8.71669V26.6H8.86669ZM27.8667 24.0666V24.2166H28.0167V24.0666H27.8667ZM8.86669 24.0666H8.71669V24.2166H8.86669V24.0666ZM27.8667 20.2666H28.0167V20.1166H27.8667V20.2666ZM8.86669 20.2666V20.1166H8.71669V20.2666H8.86669ZM40.5334 45.6V45.75H40.6834V45.6H40.5334ZM30.4 45.6H30.25V45.75H30.4V45.6ZM40.5334 26.6H40.6834V26.45H40.5334V26.6ZM30.4 26.6V26.45H30.25V26.6H30.4ZM40.5334 24.0666V24.2166H40.6834V24.0666H40.5334ZM30.4 24.0666H30.25V24.2166H30.4V24.0666ZM40.5334 20.2666H40.6834V20.1166H40.5334V20.2666ZM30.4 20.2666V20.1166H30.25V20.2666H30.4ZM51.9334 24.0666V24.2166H52.0834V24.0666H51.9334ZM43.0667 24.0666H42.9167V24.2166H43.0667V24.0666ZM51.9334 20.2666H52.0834V20.1166H51.9334V20.2666ZM43.0667 20.2666V20.1166H42.9167V20.2666H43.0667ZM41.8 6.33332V6.18332H41.65V6.33332H41.8ZM44.3334 6.33332H44.4834V6.18332H44.3334V6.33332ZM41.8 8.86665H41.65V9.01665H41.8V8.86665ZM44.3334 8.86665V9.01665H44.4834V8.86665H44.3334ZM54.4667 6.33332H54.6167V6.18332H54.4667V6.33332ZM46.8667 6.33332V6.18332H46.7167V6.33332H46.8667ZM54.4667 8.86665V9.01665H54.6167V8.86665H54.4667ZM46.8667 8.86665H46.7167V9.01665H46.8667V8.86665ZM41.8 11.4V11.25H41.65V11.4H41.8ZM54.4667 11.4H54.6167V11.25H54.4667V11.4ZM41.8 13.9334H41.65V14.0834H41.8V13.9334ZM54.4667 13.9334V14.0834H54.6167V13.9334H54.4667ZM16.4667 6.33332H16.6167V6.18332H16.4667V6.33332ZM6.33336 6.33332V6.18332H6.18336V6.33332H6.33336ZM16.4667 8.86665V9.01665H16.6167V8.86665H16.4667ZM6.33336 8.86665H6.18336V9.01665H6.33336V8.86665ZM6.33336 11.4V11.25H6.18336V11.4H6.33336ZM19 11.4H19.15V11.25H19V11.4ZM6.33336 13.9334H6.18336V14.0834H6.33336V13.9334ZM19 13.9334V14.0834H19.15V13.9334H19ZM6.33336 50.6667V50.5167H6.18336V50.6667H6.33336ZM19 50.6667H19.15V50.5167H19V50.6667ZM6.33336 53.2H6.18336V53.35H6.33336V53.2ZM19 53.2V53.35H19.15V53.2H19ZM11.4 29.1333V28.9833H11.25V29.1333H11.4ZM22.8 29.1333H22.95V28.9833H22.8V29.1333ZM11.4 31.6667H11.25V31.8167H11.4V31.6667ZM22.8 31.6667V31.8167H22.95V31.6667H22.8ZM19 34.2H19.15V34.05H19V34.2ZM11.4 34.2V34.05H11.25V34.2H11.4ZM19 36.7333V36.8833H19.15V36.7333H19ZM11.4 36.7333H11.25V36.8833H11.4V36.7333ZM11.4 39.2667V39.1167H11.25V39.2667H11.4ZM19 39.2667H19.15V39.1167H19V39.2667ZM11.4 41.8H11.25V41.95H11.4V41.8ZM19 41.8V41.95H19.15V41.8H19ZM38 29.1333H38.15V28.9833H38V29.1333ZM32.9334 29.1333V28.9833H32.7834V29.1333H32.9334ZM38 31.6667V31.8167H38.15V31.6667H38ZM32.9334 31.6667H32.7834V31.8167H32.9334V31.6667ZM32.9334 34.2V34.05H32.7834V34.2H32.9334ZM38 34.2H38.15V34.05H38V34.2ZM32.9334 36.7333H32.7834V36.8833H32.9334V36.7333ZM38 36.7333V36.8833H38.15V36.7333H38ZM38 39.2667H38.15V39.1167H38V39.2667ZM32.9334 39.2667V39.1167H32.7834V39.2667H32.9334ZM38 41.8V41.95H38.15V41.8H38ZM32.9334 41.8H32.7834V41.95H32.9334V41.8ZM45.6 29.1333V28.9833H45.45V29.1333H45.6ZM49.4 29.1333H49.55V28.9833H49.4V29.1333ZM45.6 31.6667H45.45V31.8167H45.6V31.6667ZM49.4 31.6667V31.8167H49.55V31.6667H49.4ZM49.4 34.2H49.55V34.05H49.4V34.2ZM45.6 34.2V34.05H45.45V34.2H45.6ZM49.4 36.7333V36.8833H49.55V36.7333H49.4ZM45.6 36.7333H45.45V36.8833H45.6V36.7333ZM45.6 39.2667V39.1167H45.45V39.2667H45.6ZM49.4 39.2667H49.55V39.1167H49.4V39.2667ZM45.6 41.8H45.45V41.95H45.6V41.8ZM49.4 41.8V41.95H49.55V41.8H49.4ZM60.95 62.0667V61.3417H60.65V62.0667H60.95ZM68.4 61.9167H60.8V62.2167H68.4V61.9167ZM68.55 64.6V62.0667H68.25V64.6H68.55ZM62.0667 71.0833C65.6487 71.0833 68.55 68.182 68.55 64.6H68.25C68.25 68.0163 65.483 70.7833 62.0667 70.7833V71.0833ZM60.8 71.0833H62.0667V70.7833H60.8V71.0833ZM60.95 72.2V70.9333H60.65V72.2H60.95ZM57 76.15C59.1728 76.15 60.95 74.3728 60.95 72.2H60.65C60.65 74.2072 59.0072 75.85 57 75.85V76.15ZM3.8 76.15H57V75.85H3.8V76.15ZM-0.15 72.2C-0.15 74.3728 1.62716 76.15 3.8 76.15V75.85C1.79284 75.85 0.15 74.2072 0.15 72.2H-0.15ZM-0.15 3.8V72.2H0.15V3.8H-0.15ZM3.8 -0.15C1.62716 -0.15 -0.15 1.62716 -0.15 3.8H0.15C0.15 1.79284 1.79284 0.15 3.8 0.15V-0.15ZM57 -0.15H3.8V0.15H57V-0.15ZM60.95 3.8C60.95 1.62716 59.1728 -0.15 57 -0.15V0.15C59.0072 0.15 60.65 1.79284 60.65 3.8H60.95ZM60.95 39.9916V3.8H60.65V39.9916H60.95ZM58.8095 39.9595C59.4802 39.9595 60.1364 40.0212 60.7727 40.1391L60.8273 39.8441C60.1731 39.7229 59.4986 39.6595 58.8095 39.6595V39.9595ZM58.274 39.9727C58.4514 39.9639 58.63 39.9595 58.8095 39.9595V39.6595C58.625 39.6595 58.4416 39.6641 58.2593 39.673L58.274 39.9727ZM58.1167 3.8V39.8229H58.4167V3.8H58.1167ZM57 2.68333C57.6138 2.68333 58.1167 3.18618 58.1167 3.8H58.4167C58.4167 3.02049 57.7795 2.38333 57 2.38333V2.68333ZM3.8 2.68333H57V2.38333H3.8V2.68333ZM2.68333 3.8C2.68333 3.18618 3.18618 2.68333 3.8 2.68333V2.38333C3.02049 2.38333 2.38333 3.02049 2.38333 3.8H2.68333ZM2.68333 64.6V3.8H2.38333V64.6H2.68333ZM6.33333 68.25C4.31034 68.25 2.68333 66.623 2.68333 64.6H2.38333C2.38333 66.7887 4.14466 68.55 6.33333 68.55V68.25ZM9.98333 64.6C9.98333 66.623 8.35632 68.25 6.33333 68.25V68.55C8.52201 68.55 10.2833 66.7887 10.2833 64.6H9.98333ZM9.98333 62.0667V64.6H10.2833V62.0667H9.98333ZM58.2667 61.9167H10.1333V62.2167H58.2667V61.9167ZM58.1167 61.5105V62.0667H58.4167V61.5105H58.1167ZM58.8095 61.3738C58.63 61.3738 58.4514 61.3694 58.274 61.3606L58.2593 61.6603C58.4416 61.6693 58.625 61.6738 58.8095 61.6738V61.3738ZM60.7727 61.1943C60.1364 61.3122 59.4802 61.3738 58.8095 61.3738V61.6738C59.4986 61.6738 60.1731 61.6105 60.8273 61.4892L60.7727 61.1943ZM51.1631 58.1616C50.4405 57.4246 49.8238 56.5836 49.3372 55.6632L49.072 55.8034C49.5722 56.7496 50.2062 57.6141 50.9488 58.3716L51.1631 58.1616ZM40.5333 58.4166H51.0559V58.1166H40.5333V58.4166ZM40.3833 55.7333V58.2666H40.6833V55.7333H40.3833ZM49.2046 55.5833H40.5333V55.8833H49.2046V55.5833ZM48.3954 53.1651C48.2038 52.3637 48.1024 51.5271 48.1024 50.6667H47.8024C47.8024 51.5508 47.9066 52.4108 48.1036 53.2349L48.3954 53.1651ZM34.2 53.35H48.2495V53.05H34.2V53.35ZM34.05 50.6667V53.2H34.35V50.6667H34.05ZM47.9524 50.5167L34.2 50.5167V50.8167L47.9524 50.8167V50.5167ZM54.6167 40.7129V17.7333H54.3167V40.7129H54.6167ZM54.4667 17.5833H6.33336V17.8833H54.4667V17.5833ZM6.18336 17.7333V48.1333H6.48336V17.7333H6.18336ZM6.33336 48.2833H48.2495V47.9833H6.33336V48.2833ZM48.3954 48.1682C48.6057 47.2883 48.9247 46.4506 49.3373 45.6701L49.072 45.5299C48.6478 46.3324 48.3199 47.1937 48.1036 48.0984L48.3954 48.1682ZM49.2047 45.45H43.0667V45.75H49.2047V45.45ZM43.2167 45.6V26.6H42.9167V45.6H43.2167ZM43.0667 26.75H51.9334V26.45H43.0667V26.75ZM51.7834 26.6V42.2641H52.0834V26.6H51.7834ZM52.0284 42.3801C52.7823 41.7625 53.622 41.2457 54.5268 40.8504L54.4066 40.5755C53.4764 40.9819 52.6132 41.5132 51.8383 42.1481L52.0284 42.3801ZM58.1167 72.2C58.1167 72.8138 57.6138 73.3167 57 73.3167V73.6167C57.7795 73.6167 58.4167 72.9795 58.4167 72.2H58.1167ZM58.1167 70.9333V72.2H58.4167V70.9333H58.1167ZM6.33333 71.0833H58.2667V70.7833H6.33333V71.0833ZM2.44306 69.7865C3.56176 70.6295 4.9235 71.0833 6.33333 71.0833V70.7833C4.98816 70.7833 3.6899 70.3505 2.62361 69.5469L2.44306 69.7865ZM2.68333 72.2V69.6667H2.38333V72.2H2.68333ZM3.8 73.3167C3.18618 73.3167 2.68333 72.8138 2.68333 72.2H2.38333C2.38333 72.9795 3.02049 73.6167 3.8 73.6167V73.3167ZM57 73.3167H3.8V73.6167H57V73.3167ZM62.0667 68.25H11.4V68.55H62.0667V68.25ZM65.7167 64.6C65.7167 66.6072 64.0738 68.25 62.0667 68.25V68.55C64.2395 68.55 66.0167 66.7728 66.0167 64.6H65.7167ZM12.6667 64.75H65.8667V64.45H12.6667V64.75ZM11.5198 68.4903C12.3629 67.3716 12.8167 66.0098 12.8167 64.6H12.5167C12.5167 65.9452 12.0838 67.2434 11.2802 68.3097L11.5198 68.4903ZM27.8667 45.45H8.86669V45.75H27.8667V45.45ZM27.7167 26.6V45.6H28.0167V26.6H27.7167ZM8.86669 26.75H27.8667V26.45H8.86669V26.75ZM9.01669 45.6V26.6H8.71669V45.6H9.01669ZM27.8667 23.9166H8.86669V24.2166H27.8667V23.9166ZM27.7167 20.2666V24.0666H28.0167V20.2666H27.7167ZM8.86669 20.4166H27.8667V20.1166H8.86669V20.4166ZM9.01669 24.0666V20.2666H8.71669V24.0666H9.01669ZM40.5334 45.45H30.4V45.75H40.5334V45.45ZM40.3834 26.6V45.6H40.6834V26.6H40.3834ZM30.4 26.75H40.5334V26.45H30.4V26.75ZM30.55 45.6V26.6H30.25V45.6H30.55ZM40.5334 23.9166H30.4V24.2166H40.5334V23.9166ZM40.3834 20.2666V24.0666H40.6834V20.2666H40.3834ZM30.4 20.4166H40.5334V20.1166H30.4V20.4166ZM30.55 24.0666V20.2666H30.25V24.0666H30.55ZM51.9334 23.9166H43.0667V24.2166H51.9334V23.9166ZM51.7834 20.2666V24.0666H52.0834V20.2666H51.7834ZM43.0667 20.4166H51.9334V20.1166H43.0667V20.4166ZM43.2167 24.0666V20.2666H42.9167V24.0666H43.2167ZM41.8 6.48332H44.3334V6.18332H41.8V6.48332ZM41.95 8.86665V6.33332H41.65V8.86665H41.95ZM44.3334 8.71665H41.8V9.01665H44.3334V8.71665ZM44.1834 6.33332V8.86665H44.4834V6.33332H44.1834ZM54.4667 6.18332H46.8667V6.48332H54.4667V6.18332ZM54.6167 8.86665V6.33332H54.3167V8.86665H54.6167ZM46.8667 9.01665H54.4667V8.71665H46.8667V9.01665ZM46.7167 6.33332V8.86665H47.0167V6.33332H46.7167ZM41.8 11.55H54.4667V11.25H41.8V11.55ZM41.95 13.9334V11.4H41.65V13.9334H41.95ZM54.4667 13.7834H41.8V14.0834H54.4667V13.7834ZM54.3167 11.4V13.9334H54.6167V11.4H54.3167ZM16.4667 6.18332H6.33336V6.48332H16.4667V6.18332ZM16.6167 8.86665V6.33332H16.3167V8.86665H16.6167ZM6.33336 9.01665H16.4667V8.71665H6.33336V9.01665ZM6.18336 6.33332V8.86665H6.48336V6.33332H6.18336ZM6.33336 11.55H19V11.25H6.33336V11.55ZM6.48336 13.9334V11.4H6.18336V13.9334H6.48336ZM19 13.7834H6.33336V14.0834H19V13.7834ZM18.85 11.4V13.9334H19.15V11.4H18.85ZM6.33336 50.8167H19V50.5167H6.33336V50.8167ZM6.48336 53.2V50.6667H6.18336V53.2H6.48336ZM19 53.05H6.33336V53.35H19V53.05ZM18.85 50.6667V53.2H19.15V50.6667H18.85ZM11.4 29.2833H22.8V28.9833H11.4V29.2833ZM11.55 31.6667V29.1333H11.25V31.6667H11.55ZM22.8 31.5167H11.4V31.8167H22.8V31.5167ZM22.65 29.1333V31.6667H22.95V29.1333H22.65ZM19 34.05H11.4V34.35H19V34.05ZM19.15 36.7333V34.2H18.85V36.7333H19.15ZM11.4 36.8833H19V36.5833H11.4V36.8833ZM11.25 34.2V36.7333H11.55V34.2H11.25ZM11.4 39.4167H19V39.1167H11.4V39.4167ZM11.55 41.8V39.2667H11.25V41.8H11.55ZM19 41.65H11.4V41.95H19V41.65ZM18.85 39.2667V41.8H19.15V39.2667H18.85ZM38 28.9833H32.9334V29.2833H38V28.9833ZM38.15 31.6667V29.1333H37.85V31.6667H38.15ZM32.9334 31.8167H38V31.5167H32.9334V31.8167ZM32.7834 29.1333V31.6667H33.0834V29.1333H32.7834ZM32.9334 34.35H38V34.05H32.9334V34.35ZM33.0834 36.7333V34.2H32.7834V36.7333H33.0834ZM38 36.5833H32.9334V36.8833H38V36.5833ZM37.85 34.2V36.7333H38.15V34.2H37.85ZM38 39.1167H32.9334V39.4167H38V39.1167ZM38.15 41.8V39.2667H37.85V41.8H38.15ZM32.9334 41.95H38V41.65H32.9334V41.95ZM32.7834 39.2667V41.8H33.0834V39.2667H32.7834ZM45.6 29.2833H49.4V28.9833H45.6V29.2833ZM45.75 31.6667V29.1333H45.45V31.6667H45.75ZM49.4 31.5167H45.6V31.8167H49.4V31.5167ZM49.25 29.1333V31.6667H49.55V29.1333H49.25ZM49.4 34.05H45.6V34.35H49.4V34.05ZM49.55 36.7333V34.2H49.25V36.7333H49.55ZM45.6 36.8833H49.4V36.5833H45.6V36.8833ZM45.45 34.2V36.7333H45.75V34.2H45.45ZM45.6 39.4167H49.4V39.1167H45.6V39.4167ZM45.75 41.8V39.2667H45.45V41.8H45.75ZM49.4 41.65H45.6V41.95H49.4V41.65ZM49.25 39.2667V41.8H49.55V39.2667H49.25Z"
                  fill="white"
                  mask="url(#path-1-inside-1_7835_7883)"
                />
              </g>
              <path
                d="M55 57V55H62.1C63.15 55 64.0625 54.6667 64.8375 54C65.6125 53.3333 66 52.5 66 51.5C66 50.5 65.6125 49.6667 64.8375 49C64.0625 48.3333 63.15 48 62.1 48H55.8L58.4 50.6L57 52L52 47L57 42L58.4 43.4L55.8 46H62.1C63.7167 46 65.1042 46.525 66.2625 47.575C67.4208 48.625 68 49.9333 68 51.5C68 53.0667 67.4208 54.375 66.2625 55.425C65.1042 56.475 63.7167 57 62.1 57H55Z"
                fill="#E66A70"
              />
            </svg>
          </div>
          <div class="swiftContent">
            <h3 class="medium font-16">Quote Returned</h3>
            <p>You have returned this quotation.</p>
          </div>
        </div>

        <label class="label" *ngIf="isLatestQuote(rfqItem?.attachments)"
          >Latest Quote</label
        >
        <div *ngFor="let attachFile of rfqItem?.attachments; let i = index">
          <div
            class="quoteReason"
            *ngIf="
              (attachFile?.fileType === FileType.Quote ||
                attachFile?.fileType === FileType.Quote_Tooling ||
                attachFile?.fileType === FileType.Quote_Component ||
                attachFile?.fileType === FileType.Quote_Capex) &&
              attachFile?.fileStatus === fileStatus.Live
            "
          >
            <h4 class="font-12 medium flex">
              Reason for return
              <span class="date ml-auto">{{
                attachFile?.createdOn | date : "MMM d, y"
              }}</span>
            </h4>
            <p class="font-12">{{ attachFile?.returnReason }}</p>

            <h4 class="font-12 medium" *ngIf="attachFile?.returnOthers">
              Remarks
            </h4>
            <p class="font-12" *ngIf="attachFile?.returnOthers">
              {{ attachFile?.returnOthers }}
            </p>
            <div class="returnFile">
              <div class="rfq-item rfq-icon">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <mask
                      id="mask0_5589_19343"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_5589_19343)">
                      <path
                        d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                        fill="#333333"
                      />
                    </g>
                  </svg>
                </span>
                <h4
                  class="name"
                  matTooltip="{{ getFileName(attachFile?.fileName) }}"
                >
                  {{ getFileName(attachFile?.fileName) }}
                </h4>
              </div>

              <div class="align-items-center">
                <p
                  class="type"
                  matTooltip="{{ getFileExt(attachFile?.fileName) }}"
                >
                  .{{ getFileExt(attachFile?.fileName) }}
                </p>
              </div>

              <div class="align-items-center">
                <p class="size">{{ attachFile?.size }}</p>
              </div>
              <div class="download-file">
                <span
                  class="iconCenter"
                  (click)="downloadFiles(attachFile?.id, attachFile?.fileName)"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_8832_38514"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9"></rect>
                    </mask>
                    <g mask="url(#mask0_8832_38514)">
                      <path
                        d="M12 15.7884L7.7308 11.5192L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5192L12 15.7884ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6922V14.9807H5.99997V17.6922C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6922V14.9807H19.5V17.6922C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
                        fill="#DA2128"
                      ></path>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
        <label class="label" *ngIf="isPreviousQuote(rfqItem?.attachments)"
          >Previous Quote</label
        >
        <div *ngFor="let attachFile of rfqItem?.attachments; let i = index">
          <div
            class="quoteReason"
            *ngIf="
              (attachFile?.fileType === FileType.Quote ||
                attachFile?.fileType === FileType.Quote_Tooling ||
                attachFile?.fileType === FileType.Quote_Component ||
                attachFile?.fileType === FileType.Quote_Capex) &&
              attachFile?.fileStatus === fileStatus.Archive
            "
          >
            <h4 class="font-12 medium flex">
              Reason for return
              <span class="date ml-auto">{{
                attachFile?.createdOn | date : "MMM d, y"
              }}</span>
            </h4>
            <p class="font-12">{{ attachFile?.returnReason }}</p>

            <h4 class="font-12 medium" *ngIf="attachFile?.returnOthers">
              Remarks
            </h4>
            <p class="font-12" *ngIf="attachFile?.returnOthers">
              {{ attachFile?.returnOthers }}
            </p>
            <div class="returnFile">
              <div class="rfq-item rfq-icon">
                <span class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <mask
                      id="mask0_5589_19343"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_5589_19343)">
                      <path
                        d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                        fill="#333333"
                      />
                    </g>
                  </svg>
                </span>
                <h4
                  class="name"
                  matTooltip="{{ getFileName(attachFile?.fileName) }}"
                >
                  {{ getFileName(attachFile?.fileName) }}
                </h4>
              </div>

              <div class="align-items-center">
                <p
                  class="type"
                  matTooltip="{{ getFileExt(attachFile?.fileName) }}"
                >
                  .{{ getFileExt(attachFile?.fileName) }}
                </p>
              </div>

              <div class="align-items-center">
                <p class="size">{{ attachFile?.size }}</p>
              </div>
              <div class="download-file">
                <span
                  class="iconCenter"
                  (click)="downloadFiles(attachFile?.id, attachFile?.fileName)"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_8832_38514"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9"></rect>
                    </mask>
                    <g mask="url(#mask0_8832_38514)">
                      <path
                        d="M12 15.7884L7.7308 11.5192L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5192L12 15.7884ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6922V14.9807H5.99997V17.6922C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6922V14.9807H19.5V17.6922C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
                        fill="#DA2128"
                      ></path>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
</ng-container>
<!-- quote returned end-->

<!-- rfq returned start-->
<ng-container *ngIf="rfqItem?.status == RFQStatus.RFQ_RETURNED && !Sendarchive">
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_1"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>

      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>
          <div class="rfqInfo col-lg-4 col-md-4">
            <div class="category-chips-and-more">
              <h4>Category</h4>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
              <span
                (click)="isMoreExpanded = true"
                *ngIf="!isMoreExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>
        <div *ngIf="isMoreExpanded" class="mt-10">
          <h4>Sub-Category</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroSubCategory
                      : rfqItem?.subCategory
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroSubCategory
                        : rfqItem?.subCategory
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
            </div>
          </div>
          <h4>Materials</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let material of (rfqItem?.materials | categoryFormatter : 10)
                    .display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (rfqItem?.materials | categoryFormatter : 10).tooltip
                  "
                >
                  {{ material }}
                </span>
              </mat-chip>
            </div>
            <span (click)="isMoreExpanded = false" class="more-less-button">
              <mat-icon>expand_less</mat-icon></span
            >
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="step-2">
            <div class="files-list" *ngIf="files.length > 0">
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of files; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="iocn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4 matTooltip="{{ getFileName(file?.name) }}" class="name">
                    {{ getFileName(file?.name) }}
                  </h4>
                </div>

                <div>
                  <p>{{ getFileExt(file?.name) }}</p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(file?.size) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="deleteFile(i)"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="files-list">
              <h3 class="pb-3">
                Last Uploaded: {{ rfqItem.attachments?.length || 0 }} Files
              </h3>

              <div *ngFor="let files of getFileTypes(); let i = index">
                <h3 class="font-12 medium">
                  {{ getFileTypeLabel(files.key) }}
                </h3>
                <div *ngIf="files.value">
                  <div
                    class="single-file flex justify-content-between"
                    *ngFor="let file of files.value"
                  >
                    <div class="rfq-item rfq-icon">
                      <span class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5589_19343"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5589_19343)">
                            <path
                              d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                              fill="#333333"
                            />
                          </g>
                        </svg>
                      </span>

                      <h4
                        title="{{ getFileName(file?.name || file?.fileName) }}"
                        class="name"
                      >
                        {{ getFileName(file?.name || file?.fileName) }}
                      </h4>
                    </div>

                    <div>
                      <p
                        class="type"
                        title="{{ getFileExt(file?.name || file?.fileName) }}"
                      >
                        {{ getFileExt(file?.name || file?.fileName) }}
                      </p>
                    </div>

                    <div>
                      <p class="size">{{ file.size }}</p>
                    </div>

                    <div>
                      <p class="size">
                        {{ file.createdOn | date : "MMM d, y" }}
                      </p>
                    </div>
                    <div class="delete-icon" (click)="saveFile(file)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                          fill="#666666"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h3 class="font-12 medium">Return Reason</h3>
        <div class="quoteReason">
          <h4 class="font-12 medium flex">{{ rfqItem?.returnReason }}</h4>
          <p *ngIf="rfqItem?.returnOthers">{{ rfqItem?.returnOthers }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter">
    <button
      id="modules_rfq_rfqquote_4"
      mat-button
      class="drafts-button"
      (click)="closeRfqQuote()"
    >
      Cancel
    </button>

    <button
      id="modules_rfq_rfqquote_5"
      mat-button
      color="primary"
      type="button"
      class="btnCustom btn-primary"
      [ngClass]="{ disable: saveButtonEnable }"
      (click)="openUpdteRfq(rfqItem)"
    >
      Edit
    </button>
  </div>
</ng-container>
<!-- rfq returned end-->

<!-- discontinued -->

<ng-container
  *ngIf="rfqItem?.status == RFQStatus.RFQ_DISCONTINUED && !Sendarchive"
>
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="accordianWrapper">
        <div class="accordion-header">
          <div class="rfqInfo col-lg-5 col-md-5">
            <span class="subLabel d-block font-12 medium"
              >RFQ ID : {{ rfqItem?.id }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Created On: {{ rfqItem?.createdOn | date : "MMM d, y" }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Delivery Date:
              {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span
            >
            <span
              class="subLabel d-block font-12 medium"
              *ngIf="rfqItem?.incotermList?.length"
              >Incoterms : {{ rfqItem?.incotermList[0] }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Payment Term: {{ rfqItem?.paymentTerm }}</span
            >
            <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq"
              >Minimum Order Quantity (MOQ): {{ rfqItem?.moq }}</span
            >
            <span class="subLabel d-block font-12 medium"
              >Address: {{ rfqItem?.address }}</span
            >
          </div>
          <div class="rfqInfo col-lg-4 col-md-4">
            <div class="category-chips-and-more">
              <h4>Category</h4>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroCategory
                      : rfqItem?.category
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
              <span
                (click)="isMoreExpanded = true"
                *ngIf="!isMoreExpanded"
                class="more-less-button"
              >
                <mat-icon>expand_more</mat-icon></span
              >
            </div>
          </div>
        </div>
        <div *ngIf="isMoreExpanded" class="mt-10">
          <h4>Sub-Category</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroSubCategory
                      : rfqItem?.subCategory
                    ) | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroSubCategory
                        : rfqItem?.subCategory
                      ) | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </mat-chip>
            </div>
          </div>
          <h4>Materials</h4>
          <div class="category-chips-and-more">
            <div>
              <mat-chip
                *ngFor="
                  let material of (rfqItem?.materials | categoryFormatter : 10)
                    .display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (rfqItem?.materials | categoryFormatter : 10).tooltip
                  "
                >
                  {{ material }}
                </span>
              </mat-chip>
            </div>
            <span (click)="isMoreExpanded = false" class="more-less-button">
              <mat-icon>expand_less</mat-icon></span
            >
          </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="step-2">
            <div class="step_heading">
              <h4 class="step-title pb-5">
                New attachments:
                <span class="attach" *ngIf="files.length > 0">
                  <span class="icon"> </span>
                  {{ files.length || 0 }}
                  file(s)
                </span>
              </h4>
            </div>

            <div class="files-list" *ngIf="files.length > 0">
              <div
                class="single-file flex justify-content-between"
                *ngFor="let file of files; let i = index"
              >
                <div class="rfq-item rfq-icon">
                  <span class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <mask
                        id="mask0_5589_19343"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5589_19343)">
                        <path
                          d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  </span>
                  <h4 class="name" matTooltip="{{ getFileName(file?.name) }}">
                    {{ getFileName(file?.name) }}
                  </h4>
                </div>

                <div>
                  <p class="type" matTooltip="{{ getFileExt(file?.name) }}">
                    {{ getFileExt(file?.name) }}
                  </p>
                </div>

                <div>
                  <p class="size">{{ formatBytes(file?.size) }}</p>
                </div>

                <div
                  class="delete-icon"
                  (click)="deleteFile(i)"
                  aria-label="Delete File"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                      fill="#666666"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="files-list">
              <h3 class="pb-3">
                Last Uploaded: {{ rfqItem.attachments?.length || 0 }} Files
              </h3>
              <div *ngFor="let files of getFileTypes(); let i = index">
                <h3 class="font-12 medium">
                  {{ getFileTypeLabel(files.key) }}
                </h3>
                <div *ngIf="files.value">
                  <div
                    class="single-file flex justify-content-between"
                    *ngFor="let file of files.value"
                  >
                    <div class="rfq-item rfq-icon">
                      <span class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5589_19343"
                            style="mask-type: alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5589_19343)">
                            <path
                              d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                              fill="#333333"
                            />
                          </g>
                        </svg>
                      </span>

                      <h4
                        title="{{ getFileName(file?.name || file?.fileName) }}"
                        class="name"
                      >
                        {{ getFileName(file?.name || file?.fileName) }}
                      </h4>
                    </div>

                    <div>
                      <p
                        class="type"
                        title="{{ getFileExt(file?.name || file?.fileName) }}"
                      >
                        {{ getFileExt(file?.name || file?.fileName) }}
                      </p>
                    </div>

                    <div>
                      <p class="size">{{ file.size }}</p>
                    </div>

                    <div>
                      <p class="size">
                        {{ file.createdOn | date : "MMM d, y" }}
                      </p>
                    </div>

                    <div class="delete-icon" (click)="saveFile(file)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M7.8263 11.7884L3.71046 7.51925L4.72644 6.43465L7.10326 8.90003V0.5H8.54934V8.90003L10.9262 6.43465L11.9421 7.51925L7.8263 11.7884ZM2.33848 15.5C1.85149 15.5 1.43928 15.325 1.10185 14.975C0.764418 14.625 0.595703 14.1974 0.595703 13.6922V10.9807H2.0418V13.6922C2.0418 13.7692 2.0727 13.8397 2.1345 13.9038C2.19631 13.9679 2.26431 14 2.33848 14H13.3141C13.3883 14 13.4563 13.9679 13.5181 13.9038C13.5799 13.8397 13.6108 13.7692 13.6108 13.6922V10.9807H15.0569V13.6922C15.0569 14.1974 14.8882 14.625 14.5508 14.975C14.2133 15.325 13.8011 15.5 13.3141 15.5H2.33848Z"
                          fill="#666666"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiftQuote" *ngIf="rfqItem.status == 'QUOTE_READY'">
          <div class="swiftIco">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="76"
              height="84"
              viewBox="0 0 76 84"
              fill="none"
            >
              <g opacity="0.7">
                <mask id="path-1-inside-1_8603_34903" fill="white">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  />
                </mask>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M67.2 67.7988V68.6H75.6V71.4C75.6 75.2675 72.4675 78.4 68.6 78.4H67.2V79.8C67.2 82.11 65.31 84 63 84H4.2C1.89 84 0 82.11 0 79.8V4.2C0 1.89 1.89 0 4.2 0H63C65.31 0 67.2 1.89 67.2 4.2V44.2012C66.4868 44.0691 65.7515 44 65 44C64.7988 44 64.5988 44.005 64.4 44.0147V4.2C64.4 3.43 63.77 2.8 63 2.8H4.2C3.43 2.8 2.8 3.43 2.8 4.2V71.4C2.8 73.7275 4.6725 75.6 7 75.6C9.3275 75.6 11.2 73.7275 11.2 71.4V68.6H64.4V67.9853C64.5988 67.995 64.7988 68 65 68C65.7515 68 66.4868 67.9309 67.2 67.7988ZM54.3841 61.6C54.9294 62.6316 55.6206 63.5741 56.4303 64.4H44.8V61.6H54.3841ZM53 56L37.7999 56V58.8H53.3284C53.1137 57.9017 53 56.9641 53 56ZM60.2 44.9985V19.6H7.00004V53.2H53.3284C53.5641 52.2138 53.9216 51.2749 54.3841 50.4H47.6V29.4H57.4V46.713C58.2449 46.0207 59.1859 45.4416 60.2 44.9985ZM63 81.2C63.77 81.2 64.4 80.57 64.4 79.8V78.4H7C5.4775 78.4 4.0075 77.91 2.8 77V79.8C2.8 80.57 3.43 81.2 4.2 81.2H63ZM12.6 75.6H68.6C70.91 75.6 72.8 73.71 72.8 71.4H14C14 72.9225 13.51 74.3925 12.6 75.6ZM9.80005 50.4H30.8V29.4H9.80005V50.4ZM9.80005 26.6H30.8V22.4H9.80005V26.6ZM33.6 50.4H44.8V29.4H33.6V50.4ZM33.6 26.6H44.8V22.4H33.6V26.6ZM47.6 26.6H57.4V22.4H47.6V26.6ZM49 6.99998H46.2001V9.79998H49V6.99998ZM51.8 6.99998H60.2V9.79998H51.8V6.99998ZM60.2001 12.6H46.2001V15.4H60.2001V12.6ZM7.00004 6.99998H18.2V9.79998H7.00004V6.99998ZM21 12.6H7.00004V15.4H21V12.6ZM21 56H7.00004V58.8H21V56ZM25.2 32.2H12.6V35H25.2V32.2ZM12.6 37.8H21V40.6H12.6V37.8ZM21 43.4H12.6V46.2H21V43.4ZM36.4 32.2H42V35H36.4V32.2ZM42 37.8H36.4V40.6H42V37.8ZM36.4 43.4H42V46.2H36.4V43.4ZM54.6 32.2H50.4V35H54.6V32.2ZM50.4 37.8H54.6V40.6H50.4V37.8ZM54.6 43.4H50.4V46.2H54.6V43.4Z"
                  fill="#999999"
                />
                <path
                  d="M67.2 68.6H67.05V68.75H67.2V68.6ZM67.2 67.7988H67.35V67.6184L67.1727 67.6513L67.2 67.7988ZM75.6 68.6H75.75V68.45H75.6V68.6ZM67.2 78.4V78.25H67.05V78.4H67.2ZM67.2 44.2012L67.1727 44.3487L67.35 44.3816V44.2012H67.2ZM64.4 44.0147H64.25V44.1723L64.4074 44.1646L64.4 44.0147ZM11.2 68.6V68.45H11.05V68.6H11.2ZM64.4 68.6V68.75H64.55V68.6H64.4ZM64.4 67.9853L64.4074 67.8354L64.25 67.8277V67.9853H64.4ZM56.4303 64.4V64.55H56.7874L56.5374 64.295L56.4303 64.4ZM54.3841 61.6L54.5167 61.5299L54.4745 61.45H54.3841V61.6ZM44.8 64.4H44.65V64.55H44.8V64.4ZM44.8 61.6V61.45H44.65V61.6H44.8ZM53 56H53.15V55.85H53V56ZM37.7999 56V55.85H37.6499V56H37.7999ZM37.7999 58.8H37.6499V58.95H37.7999V58.8ZM53.3284 58.8V58.95H53.5185L53.4743 58.7652L53.3284 58.8ZM60.2 44.9985L60.2601 45.1359L60.35 45.0966V44.9985H60.2ZM60.2 19.6H60.35V19.45H60.2V19.6ZM7.00004 19.6V19.45H6.85004V19.6H7.00004ZM7.00004 53.2H6.85004V53.35H7.00004V53.2ZM53.3284 53.2V53.35H53.4468L53.4743 53.2349L53.3284 53.2ZM54.3841 50.4L54.5167 50.4701L54.633 50.25H54.3841V50.4ZM47.6 50.4H47.45V50.55H47.6V50.4ZM47.6 29.4V29.25H47.45V29.4H47.6ZM57.4 29.4H57.55V29.25H57.4V29.4ZM57.4 46.713H57.25V47.0298L57.4951 46.829L57.4 46.713ZM64.4 78.4H64.55V78.25H64.4V78.4ZM2.8 77L2.89028 76.8802L2.65 76.6991V77H2.8ZM12.6 75.6L12.4802 75.5097L12.2991 75.75H12.6V75.6ZM72.8 71.4H72.95V71.25H72.8V71.4ZM14 71.4V71.25H13.85V71.4H14ZM30.8 50.4V50.55H30.95V50.4H30.8ZM9.80005 50.4H9.65005V50.55H9.80005V50.4ZM30.8 29.4H30.95V29.25H30.8V29.4ZM9.80005 29.4V29.25H9.65005V29.4H9.80005ZM30.8 26.6V26.75H30.95V26.6H30.8ZM9.80005 26.6H9.65005V26.75H9.80005V26.6ZM30.8 22.4H30.95V22.25H30.8V22.4ZM9.80005 22.4V22.25H9.65005V22.4H9.80005ZM44.8 50.4V50.55H44.95V50.4H44.8ZM33.6 50.4H33.45V50.55H33.6V50.4ZM44.8 29.4H44.95V29.25H44.8V29.4ZM33.6 29.4V29.25H33.45V29.4H33.6ZM44.8 26.6V26.75H44.95V26.6H44.8ZM33.6 26.6H33.45V26.75H33.6V26.6ZM44.8 22.4H44.95V22.25H44.8V22.4ZM33.6 22.4V22.25H33.45V22.4H33.6ZM57.4 26.6V26.75H57.55V26.6H57.4ZM47.6 26.6H47.45V26.75H47.6V26.6ZM57.4 22.4H57.55V22.25H57.4V22.4ZM47.6 22.4V22.25H47.45V22.4H47.6ZM46.2001 6.99998V6.84998H46.05V6.99998H46.2001ZM49 6.99998H49.1501V6.84998H49V6.99998ZM46.2001 9.79998H46.05V9.94998H46.2001V9.79998ZM49 9.79998V9.94998H49.1501V9.79998H49ZM60.2 6.99998H60.35V6.84998H60.2V6.99998ZM51.8 6.99998V6.84998H51.65V6.99998H51.8ZM60.2 9.79998V9.94998H60.35V9.79998H60.2ZM51.8 9.79998H51.65V9.94998H51.8V9.79998ZM46.2001 12.6V12.45H46.05V12.6H46.2001ZM60.2001 12.6H60.3501V12.45H60.2001V12.6ZM46.2001 15.4H46.05V15.55H46.2001V15.4ZM60.2001 15.4V15.55H60.3501V15.4H60.2001ZM18.2 6.99998H18.35V6.84998H18.2V6.99998ZM7.00004 6.99998V6.84998H6.85004V6.99998H7.00004ZM18.2 9.79998V9.94998H18.35V9.79998H18.2ZM7.00004 9.79998H6.85004V9.94998H7.00004V9.79998ZM7.00004 12.6V12.45H6.85004V12.6H7.00004ZM21 12.6H21.15V12.45H21V12.6ZM7.00004 15.4H6.85004V15.55H7.00004V15.4ZM21 15.4V15.55H21.15V15.4H21ZM7.00004 56V55.85H6.85004V56H7.00004ZM21 56H21.15V55.85H21V56ZM7.00004 58.8H6.85004V58.95H7.00004V58.8ZM21 58.8V58.95H21.15V58.8H21ZM12.6 32.2V32.05H12.45V32.2H12.6ZM25.2 32.2H25.35V32.05H25.2V32.2ZM12.6 35H12.45V35.15H12.6V35ZM25.2 35V35.15H25.35V35H25.2ZM21 37.8H21.15V37.65H21V37.8ZM12.6 37.8V37.65H12.45V37.8H12.6ZM21 40.6V40.75H21.15V40.6H21ZM12.6 40.6H12.45V40.75H12.6V40.6ZM12.6 43.4V43.25H12.45V43.4H12.6ZM21 43.4H21.15V43.25H21V43.4ZM12.6 46.2H12.45V46.35H12.6V46.2ZM21 46.2V46.35H21.15V46.2H21ZM42 32.2H42.15V32.05H42V32.2ZM36.4 32.2V32.05H36.25V32.2H36.4ZM42 35V35.15H42.15V35H42ZM36.4 35H36.25V35.15H36.4V35ZM36.4 37.8V37.65H36.25V37.8H36.4ZM42 37.8H42.15V37.65H42V37.8ZM36.4 40.6H36.25V40.75H36.4V40.6ZM42 40.6V40.75H42.15V40.6H42ZM42 43.4H42.15V43.25H42V43.4ZM36.4 43.4V43.25H36.25V43.4H36.4ZM42 46.2V46.35H42.15V46.2H42ZM36.4 46.2H36.25V46.35H36.4V46.2ZM50.4 32.2V32.05H50.25V32.2H50.4ZM54.6 32.2H54.75V32.05H54.6V32.2ZM50.4 35H50.25V35.15H50.4V35ZM54.6 35V35.15H54.75V35H54.6ZM54.6 37.8H54.75V37.65H54.6V37.8ZM50.4 37.8V37.65H50.25V37.8H50.4ZM54.6 40.6V40.75H54.75V40.6H54.6ZM50.4 40.6H50.25V40.75H50.4V40.6ZM50.4 43.4V43.25H50.25V43.4H50.4ZM54.6 43.4H54.75V43.25H54.6V43.4ZM50.4 46.2H50.25V46.35H50.4V46.2ZM54.6 46.2V46.35H54.75V46.2H54.6ZM67.35 68.6V67.7988H67.05V68.6H67.35ZM75.6 68.45H67.2V68.75H75.6V68.45ZM75.75 71.4V68.6H75.45V71.4H75.75ZM68.6 78.55C72.5503 78.55 75.75 75.3503 75.75 71.4H75.45C75.45 75.1847 72.3847 78.25 68.6 78.25V78.55ZM67.2 78.55H68.6V78.25H67.2V78.55ZM67.35 79.8V78.4H67.05V79.8H67.35ZM63 84.15C65.3928 84.15 67.35 82.1928 67.35 79.8H67.05C67.05 82.0272 65.2272 83.85 63 83.85V84.15ZM4.2 84.15H63V83.85H4.2V84.15ZM-0.15 79.8C-0.15 82.1928 1.80716 84.15 4.2 84.15V83.85C1.97284 83.85 0.15 82.0272 0.15 79.8H-0.15ZM-0.15 4.2V79.8H0.15V4.2H-0.15ZM4.2 -0.15C1.80716 -0.15 -0.15 1.80716 -0.15 4.2H0.15C0.15 1.97284 1.97284 0.15 4.2 0.15V-0.15ZM63 -0.15H4.2V0.15H63V-0.15ZM67.35 4.2C67.35 1.80716 65.3928 -0.15 63 -0.15V0.15C65.2272 0.15 67.05 1.97284 67.05 4.2H67.35ZM67.35 44.2012V4.2H67.05V44.2012H67.35ZM65 44.15C65.7423 44.15 66.4684 44.2182 67.1727 44.3487L67.2273 44.0537C66.5052 43.9199 65.7607 43.85 65 43.85V44.15ZM64.4074 44.1646C64.6037 44.1549 64.8013 44.15 65 44.15V43.85C64.7963 43.85 64.5938 43.855 64.3926 43.8649L64.4074 44.1646ZM64.25 4.2V44.0147H64.55V4.2H64.25ZM63 2.95C63.6872 2.95 64.25 3.51284 64.25 4.2H64.55C64.55 3.34716 63.8528 2.65 63 2.65V2.95ZM4.2 2.95H63V2.65H4.2V2.95ZM2.95 4.2C2.95 3.51284 3.51284 2.95 4.2 2.95V2.65C3.34716 2.65 2.65 3.34716 2.65 4.2H2.95ZM2.95 71.4V4.2H2.65V71.4H2.95ZM7 75.45C4.75534 75.45 2.95 73.6447 2.95 71.4H2.65C2.65 73.8103 4.58966 75.75 7 75.75V75.45ZM11.05 71.4C11.05 73.6447 9.24466 75.45 7 75.45V75.75C9.41034 75.75 11.35 73.8103 11.35 71.4H11.05ZM11.05 68.6V71.4H11.35V68.6H11.05ZM64.4 68.45H11.2V68.75H64.4V68.45ZM64.25 67.9853V68.6H64.55V67.9853H64.25ZM65 67.85C64.8013 67.85 64.6037 67.8451 64.4074 67.8354L64.3926 68.1351C64.5938 68.145 64.7963 68.15 65 68.15V67.85ZM67.1727 67.6513C66.4684 67.7818 65.7423 67.85 65 67.85V68.15C65.7607 68.15 66.5052 68.0801 67.2273 67.9463L67.1727 67.6513ZM56.5374 64.295C55.7378 63.4793 55.0551 62.5485 54.5167 61.5299L54.2515 61.6701C54.8036 62.7146 55.5034 63.6688 56.3232 64.505L56.5374 64.295ZM44.8 64.55H56.4303V64.25H44.8V64.55ZM44.65 61.6V64.4H44.95V61.6H44.65ZM54.3841 61.45H44.8V61.75H54.3841V61.45ZM53 55.85L37.7999 55.85V56.15L53 56.15V55.85ZM37.6499 56V58.8H37.9499V56H37.6499ZM37.7999 58.95H53.3284V58.65H37.7999V58.95ZM53.4743 58.7652C53.2623 57.8782 53.15 56.9523 53.15 56H52.85C52.85 56.976 52.9651 57.9252 53.1825 58.8349L53.4743 58.7652ZM60.35 44.9985V19.6H60.05V44.9985H60.35ZM60.2 19.45H7.00004V19.75H60.2V19.45ZM6.85004 19.6V53.2H7.15004V19.6H6.85004ZM7.00004 53.35H53.3284V53.05H7.00004V53.35ZM53.4743 53.2349C53.7071 52.2611 54.06 51.334 54.5167 50.4701L54.2515 50.3299C53.7832 51.2157 53.4212 52.1665 53.1825 53.1651L53.4743 53.2349ZM54.3841 50.25H47.6V50.55H54.3841V50.25ZM47.75 50.4V29.4H47.45V50.4H47.75ZM47.6 29.55H57.4V29.25H47.6V29.55ZM57.25 29.4V46.713H57.55V29.4H57.25ZM57.4951 46.829C58.3295 46.1454 59.2587 45.5734 60.2601 45.1359L60.14 44.861C59.1131 45.3097 58.1603 45.8961 57.305 46.5969L57.4951 46.829ZM64.25 79.8C64.25 80.4872 63.6872 81.05 63 81.05V81.35C63.8528 81.35 64.55 80.6528 64.55 79.8H64.25ZM64.25 78.4V79.8H64.55V78.4H64.25ZM7 78.55H64.4V78.25H7V78.55ZM2.70972 77.1198C3.94343 78.0495 5.44517 78.55 7 78.55V78.25C5.50983 78.25 4.07157 77.7705 2.89028 76.8802L2.70972 77.1198ZM2.95 79.8V77H2.65V79.8H2.95ZM4.2 81.05C3.51284 81.05 2.95 80.4872 2.95 79.8H2.65C2.65 80.6528 3.34716 81.35 4.2 81.35V81.05ZM63 81.05H4.2V81.35H63V81.05ZM68.6 75.45H12.6V75.75H68.6V75.45ZM72.65 71.4C72.65 73.6272 70.8272 75.45 68.6 75.45V75.75C70.9928 75.75 72.95 73.7928 72.95 71.4H72.65ZM14 71.55H72.8V71.25H14V71.55ZM12.7198 75.6903C13.6495 74.4566 14.15 72.9548 14.15 71.4H13.85C13.85 72.8902 13.3705 74.3284 12.4802 75.5097L12.7198 75.6903ZM30.8 50.25H9.80005V50.55H30.8V50.25ZM30.65 29.4V50.4H30.95V29.4H30.65ZM9.80005 29.55H30.8V29.25H9.80005V29.55ZM9.95004 50.4V29.4H9.65005V50.4H9.95004ZM30.8 26.45H9.80005V26.75H30.8V26.45ZM30.65 22.4V26.6H30.95V22.4H30.65ZM9.80005 22.55H30.8V22.25H9.80005V22.55ZM9.95004 26.6V22.4H9.65005V26.6H9.95004ZM44.8 50.25H33.6V50.55H44.8V50.25ZM44.65 29.4V50.4H44.95V29.4H44.65ZM33.6 29.55H44.8V29.25H33.6V29.55ZM33.75 50.4V29.4H33.45V50.4H33.75ZM44.8 26.45H33.6V26.75H44.8V26.45ZM44.65 22.4V26.6H44.95V22.4H44.65ZM33.6 22.55H44.8V22.25H33.6V22.55ZM33.75 26.6V22.4H33.45V26.6H33.75ZM57.4 26.45H47.6V26.75H57.4V26.45ZM57.25 22.4V26.6H57.55V22.4H57.25ZM47.6 22.55H57.4V22.25H47.6V22.55ZM47.75 26.6V22.4H47.45V26.6H47.75ZM46.2001 7.14998H49V6.84998H46.2001V7.14998ZM46.3501 9.79998V6.99998H46.05V9.79998H46.3501ZM49 9.64998H46.2001V9.94998H49V9.64998ZM48.85 6.99998V9.79998H49.1501V6.99998H48.85ZM60.2 6.84998H51.8V7.14998H60.2V6.84998ZM60.35 9.79998V6.99998H60.05V9.79998H60.35ZM51.8 9.94998H60.2V9.64998H51.8V9.94998ZM51.65 6.99998V9.79998H51.95V6.99998H51.65ZM46.2001 12.75H60.2001V12.45H46.2001V12.75ZM46.3501 15.4V12.6H46.05V15.4H46.3501ZM60.2001 15.25H46.2001V15.55H60.2001V15.25ZM60.05 12.6V15.4H60.3501V12.6H60.05ZM18.2 6.84998H7.00004V7.14998H18.2V6.84998ZM18.35 9.79998V6.99998H18.05V9.79998H18.35ZM7.00004 9.94998H18.2V9.64998H7.00004V9.94998ZM6.85004 6.99998V9.79998H7.15004V6.99998H6.85004ZM7.00004 12.75H21V12.45H7.00004V12.75ZM7.15004 15.4V12.6H6.85004V15.4H7.15004ZM21 15.25H7.00004V15.55H21V15.25ZM20.85 12.6V15.4H21.15V12.6H20.85ZM7.00004 56.15H21V55.85H7.00004V56.15ZM7.15004 58.8V56H6.85004V58.8H7.15004ZM21 58.65H7.00004V58.95H21V58.65ZM20.85 56V58.8H21.15V56H20.85ZM12.6 32.35H25.2V32.05H12.6V32.35ZM12.75 35V32.2H12.45V35H12.75ZM25.2 34.85H12.6V35.15H25.2V34.85ZM25.05 32.2V35H25.35V32.2H25.05ZM21 37.65H12.6V37.95H21V37.65ZM21.15 40.6V37.8H20.85V40.6H21.15ZM12.6 40.75H21V40.45H12.6V40.75ZM12.45 37.8V40.6H12.75V37.8H12.45ZM12.6 43.55H21V43.25H12.6V43.55ZM12.75 46.2V43.4H12.45V46.2H12.75ZM21 46.05H12.6V46.35H21V46.05ZM20.85 43.4V46.2H21.15V43.4H20.85ZM42 32.05H36.4V32.35H42V32.05ZM42.15 35V32.2H41.85V35H42.15ZM36.4 35.15H42V34.85H36.4V35.15ZM36.25 32.2V35H36.55V32.2H36.25ZM36.4 37.95H42V37.65H36.4V37.95ZM36.55 40.6V37.8H36.25V40.6H36.55ZM42 40.45H36.4V40.75H42V40.45ZM41.85 37.8V40.6H42.15V37.8H41.85ZM42 43.25H36.4V43.55H42V43.25ZM42.15 46.2V43.4H41.85V46.2H42.15ZM36.4 46.35H42V46.05H36.4V46.35ZM36.25 43.4V46.2H36.55V43.4H36.25ZM50.4 32.35H54.6V32.05H50.4V32.35ZM50.55 35V32.2H50.25V35H50.55ZM54.6 34.85H50.4V35.15H54.6V34.85ZM54.45 32.2V35H54.75V32.2H54.45ZM54.6 37.65H50.4V37.95H54.6V37.65ZM54.75 40.6V37.8H54.45V40.6H54.75ZM50.4 40.75H54.6V40.45H50.4V40.75ZM50.25 37.8V40.6H50.55V37.8H50.25ZM50.4 43.55H54.6V43.25H50.4V43.55ZM50.55 46.2V43.4H50.25V46.2H50.55ZM54.6 46.05H50.4V46.35H54.6V46.05ZM54.45 43.4V46.2H54.75V43.4H54.45Z"
                  fill="white"
                  mask="url(#path-1-inside-1_8603_34903)"
                />
              </g>
              <path
                d="M63.6006 60.6386L70.7561 53.483L69.6345 52.3614L63.6006 58.3953L60.5672 55.362L59.4456 56.4836L63.6006 60.6386ZM65.1129 66.2222C63.7144 66.2222 62.4 65.9568 61.1694 65.4261C59.9389 64.8954 58.8685 64.1751 57.9583 63.2652C57.0481 62.3554 56.3274 61.2855 55.7965 60.0555C55.2655 58.8256 55 57.5114 55 56.1129C55 54.7144 55.2654 53.4 55.7961 52.1694C56.3269 50.9389 57.0472 49.8685 57.957 48.9583C58.8668 48.0481 59.9367 47.3274 61.1667 46.7965C62.3967 46.2655 63.7109 46 65.1093 46C66.5078 46 67.8223 46.2654 69.0528 46.7961C70.2833 47.3269 71.3537 48.0472 72.2639 48.957C73.1742 49.8668 73.8948 50.9367 74.4258 52.1667C74.9567 53.3967 75.2222 54.7109 75.2222 56.1093C75.2222 57.5078 74.9568 58.8223 74.4261 60.0528C73.8954 61.2833 73.1751 62.3537 72.2652 63.2639C71.3554 64.1742 70.2855 64.8948 69.0555 65.4258C67.8256 65.9567 66.5114 66.2222 65.1129 66.2222ZM65.1111 64.6258C67.4881 64.6258 69.5015 63.8009 71.1512 62.1512C72.8009 60.5015 73.6258 58.4881 73.6258 56.1111C73.6258 53.7341 72.8009 51.7207 71.1512 50.071C69.5015 48.4213 67.4881 47.5965 65.1111 47.5965C62.7341 47.5965 60.7207 48.4213 59.071 50.071C57.4213 51.7207 56.5965 53.7341 56.5965 56.1111C56.5965 58.4881 57.4213 60.5015 59.071 62.1512C60.7207 63.8009 62.7341 64.6258 65.1111 64.6258Z"
                fill="#35A543"
              />
            </svg>
          </div>
          <div class="swiftContent">
            <h3 class="medium font-16">Your Swift Quote is Ready!</h3>
            <p>
              Our quote engine brings you the best price. Download, review and
              confirm to accept.
            </p>

            <button
              id="modules_rfq_rfqquote_28"
              mat-button
              color="primary"
              type="button"
              class="btnCustom btn-outline-primary"
            >
              Download Quote
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
  <div class="rfqFooter">
    <button
      id="modules_rfq_rfqquote_29"
      mat-button
      class="drafts-button"
      (click)="closeRfqQuote()"
    >
      Cancel
    </button>
  </div>
</ng-container>

<!-- discontinued -->

<!-- sent to archives -->

<ng-container *ngIf="Sendarchive">
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <span class="rfqClose" (click)="closeUploadPo()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="spacer">
    <div class="po_return">
      <div class="return_box flex align-items-center">
        <span class="icon"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="67"
            height="75"
            viewBox="0 0 67 75"
            fill="none"
          >
            <g opacity="0.8">
              <path
                d="M57 12.904V67.318C57 67.7773 56.9541 68.2213 56.8622 68.6577C56.7703 69.0864 56.6401 69.5074 56.4716 69.9055C56.3032 70.3036 56.0964 70.6787 55.859 71.0308C55.6216 71.383 55.3459 71.7122 55.0473 72.0107C54.7486 72.3093 54.4193 72.5849 54.0671 72.8222C53.7148 73.0595 53.3396 73.2662 52.9414 73.4346C52.5432 73.603 52.1297 73.7332 51.6932 73.825C51.2643 73.9169 50.8125 73.9628 50.353 73.9628H7.85229C7.39282 73.9628 6.94867 73.9169 6.51218 73.825C6.08334 73.7332 5.66216 73.603 5.26395 73.4346C4.86575 73.2662 4.49052 73.0595 4.13826 72.8222C3.786 72.5849 3.45672 72.3093 3.15806 72.0107C2.85941 71.7122 2.58373 71.383 2.34634 71.0308C2.10895 70.6787 1.90218 70.3036 1.73371 69.9055C1.56524 69.5074 1.43506 69.094 1.34317 68.6577C1.25128 68.229 1.20532 67.7773 1.20532 67.318V7.64481C1.20532 7.18549 1.25128 6.74149 1.34317 6.30513C1.43506 5.87644 1.56524 5.45539 1.73371 5.05732C1.90218 4.65924 2.10895 4.28413 2.34634 3.93199C2.58373 3.57984 2.85941 3.25066 3.15806 2.95211C3.45672 2.65355 3.786 2.37796 4.13826 2.14064C4.49052 1.90333 4.86575 1.69663 5.26395 1.52822C5.66216 1.3598 6.07568 1.22966 6.51218 1.1378C6.94101 1.04593 7.39282 1 7.85229 1H45.0385L56.9923 12.8964L57 12.904Z"
                fill="white"
                stroke="#666666"
                stroke-width="1.92"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M57 12.9042H51.6855C51.2261 12.9042 50.7819 12.8582 50.3454 12.7664C49.9166 12.6745 49.4954 12.5444 49.0972 12.376C48.699 12.2075 48.3238 12.0008 47.9715 11.7635C47.6193 11.5262 47.29 11.2506 46.9913 10.9521C46.6927 10.6535 46.417 10.3243 46.1796 9.97219C45.9422 9.62004 45.7354 9.24493 45.567 8.84686C45.3985 8.44878 45.2683 8.03539 45.1764 7.59904C45.0845 7.17034 45.0386 6.71868 45.0386 6.25936V1.00781L56.9924 12.9042H57Z"
                fill="white"
                stroke="#666666"
                stroke-width="1.92"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.86011 14.0205H29.1105"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M7.86011 19.8848H50.3609"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M7.86011 25.749H50.3609"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M7.86011 31.6133H50.3609"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M7.86011 37.4854H50.3609"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M7.72656 43.1816H49.9082"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M7.72656 48.8833H49.9082"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
              <path
                d="M7.72656 54.582H49.9082"
                stroke="#666666"
                stroke-width="0.96"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
            </g>
            <circle cx="55.8095" cy="51.6657" r="10.8571" fill="white" />
            <path
              d="M55.8634 57.2546C56.1835 57.2546 56.4541 57.144 56.6752 56.923C56.8962 56.7019 57.0068 56.4313 57.0068 56.1112C57.0068 55.791 56.8962 55.5204 56.6752 55.2994C56.4541 55.0783 56.1835 54.9678 55.8634 54.9678C55.5432 54.9678 55.2726 55.0783 55.0516 55.2994C54.8305 55.5204 54.72 55.791 54.72 56.1112C54.72 56.4313 54.8305 56.7019 55.0516 56.923C55.2726 57.144 55.5432 57.2546 55.8634 57.2546ZM55.0401 53.7329H56.7323C56.7323 53.2298 56.7895 52.8334 56.9039 52.5438C57.0182 52.2541 57.3422 51.8578 57.8757 51.3547C58.2721 50.9583 58.5846 50.581 58.8133 50.2227C59.042 49.8644 59.1563 49.4338 59.1563 48.9307C59.1563 48.0769 58.8438 47.4214 58.2188 46.964C57.5937 46.5067 56.8543 46.278 56.0006 46.278C55.1316 46.278 54.4265 46.5067 53.8853 46.964C53.3441 47.4214 52.9668 47.9702 52.7533 48.6105L54.2626 49.2051C54.3388 48.9307 54.5104 48.6334 54.7771 48.3132C55.0439 47.9931 55.4517 47.833 56.0006 47.833C56.4884 47.833 56.8543 47.9664 57.0982 48.2332C57.3422 48.5 57.4641 48.7935 57.4641 49.1136C57.4641 49.4185 57.3726 49.7044 57.1897 49.9712C57.0068 50.2379 56.7781 50.4857 56.5037 50.7144C55.8329 51.3089 55.4213 51.7587 55.2688 52.0636C55.1164 52.3685 55.0401 52.9249 55.0401 53.7329ZM55.9091 60.9134C54.6438 60.9134 53.4546 60.6733 52.3417 60.1931C51.2288 59.7129 50.2607 59.0611 49.4375 58.2379C48.6143 57.4146 47.9625 56.4466 47.4823 55.3337C47.0021 54.2208 46.762 53.0316 46.762 51.7663C46.762 50.5009 47.0021 49.3118 47.4823 48.1989C47.9625 47.086 48.6143 46.1179 49.4375 45.2947C50.2607 44.4714 51.2288 43.8197 52.3417 43.3395C53.4546 42.8593 54.6438 42.6191 55.9091 42.6191C57.1745 42.6191 58.3636 42.8593 59.4765 43.3395C60.5894 43.8197 61.5575 44.4714 62.3807 45.2947C63.204 46.1179 63.8557 47.086 64.3359 48.1989C64.8161 49.3118 65.0562 50.5009 65.0562 51.7663C65.0562 53.0316 64.8161 54.2208 64.3359 55.3337C63.8557 56.4466 63.204 57.4146 62.3807 58.2379C61.5575 59.0611 60.5894 59.7129 59.4765 60.1931C58.3636 60.6733 57.1745 60.9134 55.9091 60.9134ZM55.9091 59.084C57.952 59.084 59.6823 58.3751 61.1001 56.9573C62.5179 55.5395 63.2268 53.8091 63.2268 51.7663C63.2268 49.7234 62.5179 47.9931 61.1001 46.5753C59.6823 45.1575 57.952 44.4486 55.9091 44.4486C53.8662 44.4486 52.1359 45.1575 50.7181 46.5753C49.3003 47.9931 48.5914 49.7234 48.5914 51.7663C48.5914 53.8091 49.3003 55.5395 50.7181 56.9573C52.1359 58.3751 53.8662 59.084 55.9091 59.084Z"
              fill="#E66A70"
            /></svg
        ></span>
        <h3>Are you sure, you want to Archive and Discontinue ?</h3>
      </div>
      <div class="returnForm">
        <h3 class="medium font-12">Help us understand better</h3>
        <form [formGroup]="ArchiveAndDiscontinueForm">
          <div class="formGroup" style="width: 50%">
            <label>Reason for not accepting the quote<sup>*</sup></label>
            <mat-form-field appearance="outline">
              <mat-select
                id="modules_rfq_rfqquote_30"
                placeholder="Select "
                (selectionChange)="
                  reasonForArchiveAndDiscontinuationReturn($event.value)
                "
                formControlName="reason"
              >
                <mat-option value="RFQ is not feasible"
                  >RFQ is not feasible</mat-option
                >
                <mat-option
                  value="Does not meet Motherson's Business Policies and Ethics"
                  >Does not meet Motherson's Business Policies and
                  Ethics</mat-option
                >
                <mat-option
                  value="Rapid Rating score is poor (High or very high risk)"
                  >Rapid Rating score is poor (High or very high
                  risk)</mat-option
                >
                <mat-option
                  value="Delivery Location is from a restricted country"
                  >Delivery Location is from a restricted country</mat-option
                >
                <mat-option value="others">Others</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="otherResonArchiveNdDiscontiRetchk" class="formGroup">
            <label class="flex">If others, specify <sup>*</sup></label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                formControlName="detailedReason"
                placeholder="Specify details
                          "
              ></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div class="rfqFooter">
        <button
          id="modules_rfq_rfqquote_31"
          mat-button
          class="drafts-button"
          (click)="Sendarchive = false"
        >
          Back
        </button>
        <button
          id="modules_rfq_rfqquote_32"
          mat-button
          color="primary"
          type="button"
          class="btnCustom btn-primary"
          (click)="submitArchiveAndDiscontinue()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!-- sent to archives -->
<!-- PO returned start-->
<ng-container *ngIf="rfqItem?.status == RFQStatus.PO_RETURNED && !Sendarchive">
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <div class="more">
        <button
          id="modules_rfq_rfqquote_33"
          #ddTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dd"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>

      <mat-menu #dd="matMenu" [overlapTrigger]="false">
        <div class="dropdown">
          <div class="archive_btn" (click)="Sendarchive = true">
            Archive and Discontinue
          </div>
        </div>
      </mat-menu>
      <span class="rfqClose" (click)="closeRfqQuote()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div>
        <!----new view po start--->
        <div class="po-sent">
          <div
            class="po-sent-inner first flex justify-content-between complete"
          >
            <div class="po-sent-first-upper">
              <span class="po-sent-first-upper-title"
                ><span class="check-icon">&#10003;</span> P.O. Sent</span
              >
            </div>
            <div class="po-file">
              <div
                *ngFor="let poAttachment of rfqItem?.attachments; let i = index"
              >
                <div
                  *ngIf="
                    poAttachment?.fileType === FileType.PO &&
                    poAttachment?.fileStatus === fileStatus.Live
                  "
                >
                  <div class="po-sent-file-detail">
                    <div class="info">
                      <div class="info-inner-upper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width=""
                          height=""
                          viewBox="0 0 41 54"
                          fill="none"
                        >
                          <g opacity="0.9">
                            <path
                              d="M1.5 52.5V3L3 1.5H28L38.5 12.5V52.5H1.5Z"
                              fill="#FDFDFD"
                            />
                            <path
                              d="M40.1704 11.5796L28.9204 0.32959C28.7094 0.118652 28.4238 0 28.1249 0H4.49993C2.01814 0 0 2.01814 0 4.50004V49.5001C0 51.9819 2.01814 54 4.50004 54H36.0001C38.4819 54 40.5 51.9819 40.5 49.5V12.375C40.5 12.0762 40.3813 11.7906 40.1704 11.5796ZM29.25 3.84086L36.6591 11.25H31.4999C30.2596 11.25 29.25 10.2404 29.25 9.00007V3.84086ZM38.25 49.5C38.25 50.7403 37.2404 51.7499 36.0001 51.7499H4.50004C3.25972 51.7499 2.25007 50.7403 2.25007 49.5V4.50004C2.25007 3.25972 3.25972 2.25007 4.50004 2.25007H27V9.00007C27 11.4819 29.0181 13.5 31.5 13.5H38.25V49.5Z"
                              fill="#999999"
                              fill-opacity="0.9"
                            />
                            <path
                              d="M25.7359 33.026C24.6944 32.2064 23.7046 31.3638 23.0454 30.7047C22.1885 29.8477 21.4249 29.0172 20.7614 28.2261C21.7963 25.028 22.2501 23.379 22.2501 22.5C22.2501 18.7658 20.9009 18 18.8751 18C17.3359 18 15.5001 18.7998 15.5001 22.6077C15.5001 24.2865 16.4197 26.3244 18.2423 28.6931C17.7962 30.0542 17.2722 31.6242 16.6833 33.3941C16.3998 34.2433 16.0923 35.0299 15.767 35.7572C15.5023 35.8748 15.2452 35.9946 14.9969 36.1187C14.1026 36.5659 13.2534 36.9679 12.4656 37.3415C8.87305 39.0422 6.5 40.1672 6.5 42.3886C6.5 44.0014 8.25236 45 9.875 45C11.9668 45 15.1253 42.2061 17.4325 37.4996C19.8275 36.5548 22.8048 35.8549 25.1548 35.4166C27.0378 36.8646 29.1176 38.25 30.125 38.25C32.9144 38.25 33.5 36.6372 33.5 35.2847C33.5 32.6249 30.4611 32.6249 29 32.6249C28.5462 32.625 27.329 32.7591 25.7359 33.026ZM9.875 42.75C9.23227 42.75 8.79721 42.4468 8.74996 42.3886C8.74996 41.5909 11.1285 40.4638 13.4291 39.374C13.5752 39.3048 13.7236 39.2355 13.8741 39.1641C12.1843 41.6141 10.5133 42.75 9.875 42.75ZM17.75 22.6077C17.75 20.2501 18.4818 20.2501 18.8751 20.2501C19.6705 20.2501 20.0001 20.2501 20.0001 22.5C20.0001 22.9746 19.6837 24.1612 19.1047 26.0135C18.2213 24.6534 17.75 23.4878 17.75 22.6077ZM18.6125 34.6993C18.6828 34.5037 18.7509 34.306 18.8169 34.106C19.2343 32.8536 19.6101 31.7286 19.9452 30.7156C20.4121 31.2298 20.9153 31.7561 21.4547 32.2954C21.6657 32.5064 22.1886 32.981 22.8852 33.5753C21.4985 33.8775 20.0231 34.2521 18.6125 34.6993ZM31.25 35.2849C31.25 35.7903 31.25 36 30.2063 36.0067C29.8998 35.9408 29.1912 35.5233 28.3166 34.9278C28.6341 34.8927 28.8681 34.8751 29 34.8751C30.6623 34.8751 31.1336 35.0376 31.25 35.2849Z"
                              fill="#999999"
                              fill-opacity="0.9"
                            />
                          </g>
                        </svg>
                      </div>
                      <div class="info-inner-lower">
                        <h4
                          class="name"
                          matTooltip="{{ poAttachment.fileName }}"
                          [matTooltipPosition]="'right'"
                        >
                          {{ poAttachment.fileName }}
                        </h4>
                      </div>
                      <div class="info-inner-lower">
                        <p matTooltip="{{ poAttachment.type }}" class="size">
                          {{ poAttachment.type }}
                        </p>
                      </div>
                      <div class="info-inner-lower">
                        <p
                          matTooltip="{{
                            poAttachment.createdOn | date : 'MMM d, y'
                          }}"
                          class="size"
                        >
                          {{ poAttachment.createdOn | date : "MMM d, y" }}
                        </p>
                      </div>
                      <div class="info-inner-lower">
                        <p matTooltip="" class="size">
                          {{ poAttachment.size }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="download-file"
                      (click)="
                        downloadFiles(poAttachment.id, poAttachment.fileName)
                      "
                    >
                      <mat-icon>save_alt</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="po-return-inner flex justify-content-between">
            <div class="po-return-first-upper">
              <div class="flex justify-content-between heading_top">
                <p class="title">
                  P.O. Returned <span class="check-icon">✓</span>
                </p>
                <button
                  id="modules_rfq_rfqquote_34"
                  class="po-sent-first-upload-new-po"
                  (click)="uploadNewPO()"
                  mat-button
                >
                  Upload New P.O.
                </button>
              </div>
              <p class="subtitle">
                Your P.O. has been returned. Kindly upload a new P.O.
              </p>
            </div>
            <div *ngIf="uploadAgainPO">
              <div
                class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
                appDnd
                #singleFileDropRef
                id="singleFileDropRef"
                (fileDropped)="onSingleFileDropped($event)"
              >
                <input
                  id="modules_rfq_rfqquote_35"
                  type="file"
                  #singleFileSelector
                  accept=".xls,.xlsx,.pdf"
                  (change)="fileBrowseHandlerSingle($event)"
                  style="display: none"
                />
                <h4 class="file-uploader-label">Upload P.O.</h4>
                <p class="file-uploader-size-label">(Max file size: 100MB)</p>
                <p class="file-uploader-size-label">
                  Raise your P.O within 7 days for swift processing
                </p>
                <p class="file-uploader-drag-drop-label">
                  Drag & Drop .xls, .xlsx, .pdf File Or
                </p>
                <!-- <p class="file-uploader-separator">Or</p> -->
                <p class="choose-file-button" (click)="chooseSingleFiles()">
                  Choose File
                </p>
              </div>

              <div class="files-list" *ngIf="SingleFile">
                <div class="single-file flex justify-content-between">
                  <div class="rfq-item rfq-icon">
                    <span class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <mask
                          id="mask0_5589_19343"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_5589_19343)">
                          <path
                            d="M6.875 14.7915H13.125V13.5416H6.875V14.7915ZM6.875 11.4582H13.125V10.2083H6.875V11.4582ZM5.25642 17.9165C4.83547 17.9165 4.47917 17.7707 4.1875 17.479C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58967C3.75 3.16873 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83547 2.08325 5.25642 2.08325H11.875L16.25 6.45821V16.4101C16.25 16.8311 16.1041 17.1874 15.8125 17.479C15.5208 17.7707 15.1645 17.9165 14.7435 17.9165H5.25642ZM11.25 7.08321V3.33323H5.25642C5.19231 3.33323 5.13353 3.35994 5.0801 3.41336C5.02669 3.46679 4.99998 3.52556 4.99998 3.58967V16.4101C4.99998 16.4742 5.02669 16.533 5.0801 16.5864C5.13353 16.6399 5.19231 16.6666 5.25642 16.6666H14.7435C14.8077 16.6666 14.8664 16.6399 14.9199 16.5864C14.9733 16.533 15 16.4742 15 16.4101V7.08321H11.25Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    </span>
                    <h4
                      class="name"
                      matTooltip="{{
                        getSingleFileName(
                          SingleFile?.name || SingleFile?.fileName || ''
                        )
                      }}"
                    >
                      {{
                        getSingleFileName(
                          SingleFile?.name || SingleFile?.fileName || ""
                        )
                      }}
                    </h4>
                  </div>

                  <div>
                    <p
                      class="type"
                      matTooltip="{{
                        getSingleFileExt(
                          SingleFile?.name || SingleFile?.fileName || ''
                        )
                      }}"
                    >
                      .{{
                        getSingleFileExt(
                          SingleFile?.name || SingleFile?.fileName || ""
                        )
                      }}
                    </p>
                  </div>
                  <div>
                    <p
                      class="type"
                      matTooltip="{{
                        SingleFile?.createdOn | date : 'MMM d, y'
                      }}"
                    >
                      {{ SingleFile?.createdOn | date : "MMM d, y" }}
                    </p>
                  </div>

                  <div>
                    <p class="size">{{ formatBytes(SingleFile?.size || 0) }}</p>
                  </div>

                  <div
                    class="delete-icon"
                    (click)="removeFile()"
                    aria-label="Delete File"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                    >
                      <path
                        d="M2.34845 14.0834C1.93131 14.0834 1.57502 13.9362 1.27959 13.6419C0.984152 13.3475 0.836431 12.9926 0.836431 12.577V2.00009H0V0.750106H3.76392V0.0129395H8.78251V0.750106H12.5464V2.00009H11.71V12.577C11.71 12.9979 11.5636 13.3542 11.2709 13.6459C10.9781 13.9376 10.6205 14.0834 10.198 14.0834H2.34845ZM10.4554 2.00009H2.09106V12.577C2.09106 12.6518 2.11519 12.7132 2.16345 12.7613C2.21171 12.8094 2.27338 12.8334 2.34845 12.8334H10.198C10.2623 12.8334 10.3213 12.8067 10.3749 12.7533C10.4286 12.6999 10.4554 12.6411 10.4554 12.577V2.00009ZM4.10173 11.1668H5.35636V3.66675H4.10173V11.1668ZM7.19007 11.1668H8.44469V3.66675H7.19007V11.1668Z"
                        fill="#666666"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="bottomButtons submit-po-buttom paginator-top">
                <button
                  id="modules_rfq_rfqquote_36"
                  mat-button
                  class="btnCustom btn-primary"
                  [disabled]="!SingleFile"
                  (click)="updatePOFile()"
                >
                  Submit P.O.
                </button>
              </div>
            </div>

            <div class="po-file">
              <div
                *ngFor="let poAttachment of rfqItem?.attachments; let i = index"
              >
                <ng-container *ngIf="poAttachment?.fileType === FileType.PO">
                  <div class="po-return-file-detail">
                    <div class="info">
                      <div class="info-inner-upper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="0"
                          height="0"
                          viewBox="0 0 41 54"
                          fill="none"
                        >
                          <g opacity="0.9">
                            <path
                              d="M1.5 52.5V3L3 1.5H28L38.5 12.5V52.5H1.5Z"
                              fill="#FDFDFD"
                            />
                            <path
                              d="M40.1704 11.5796L28.9204 0.32959C28.7094 0.118652 28.4238 0 28.1249 0H4.49993C2.01814 0 0 2.01814 0 4.50004V49.5001C0 51.9819 2.01814 54 4.50004 54H36.0001C38.4819 54 40.5 51.9819 40.5 49.5V12.375C40.5 12.0762 40.3813 11.7906 40.1704 11.5796ZM29.25 3.84086L36.6591 11.25H31.4999C30.2596 11.25 29.25 10.2404 29.25 9.00007V3.84086ZM38.25 49.5C38.25 50.7403 37.2404 51.7499 36.0001 51.7499H4.50004C3.25972 51.7499 2.25007 50.7403 2.25007 49.5V4.50004C2.25007 3.25972 3.25972 2.25007 4.50004 2.25007H27V9.00007C27 11.4819 29.0181 13.5 31.5 13.5H38.25V49.5Z"
                              fill="#999999"
                              fill-opacity="0.9"
                            />
                            <path
                              d="M25.7359 33.026C24.6944 32.2064 23.7046 31.3638 23.0454 30.7047C22.1885 29.8477 21.4249 29.0172 20.7614 28.2261C21.7963 25.028 22.2501 23.379 22.2501 22.5C22.2501 18.7658 20.9009 18 18.8751 18C17.3359 18 15.5001 18.7998 15.5001 22.6077C15.5001 24.2865 16.4197 26.3244 18.2423 28.6931C17.7962 30.0542 17.2722 31.6242 16.6833 33.3941C16.3998 34.2433 16.0923 35.0299 15.767 35.7572C15.5023 35.8748 15.2452 35.9946 14.9969 36.1187C14.1026 36.5659 13.2534 36.9679 12.4656 37.3415C8.87305 39.0422 6.5 40.1672 6.5 42.3886C6.5 44.0014 8.25236 45 9.875 45C11.9668 45 15.1253 42.2061 17.4325 37.4996C19.8275 36.5548 22.8048 35.8549 25.1548 35.4166C27.0378 36.8646 29.1176 38.25 30.125 38.25C32.9144 38.25 33.5 36.6372 33.5 35.2847C33.5 32.6249 30.4611 32.6249 29 32.6249C28.5462 32.625 27.329 32.7591 25.7359 33.026ZM9.875 42.75C9.23227 42.75 8.79721 42.4468 8.74996 42.3886C8.74996 41.5909 11.1285 40.4638 13.4291 39.374C13.5752 39.3048 13.7236 39.2355 13.8741 39.1641C12.1843 41.6141 10.5133 42.75 9.875 42.75ZM17.75 22.6077C17.75 20.2501 18.4818 20.2501 18.8751 20.2501C19.6705 20.2501 20.0001 20.2501 20.0001 22.5C20.0001 22.9746 19.6837 24.1612 19.1047 26.0135C18.2213 24.6534 17.75 23.4878 17.75 22.6077ZM18.6125 34.6993C18.6828 34.5037 18.7509 34.306 18.8169 34.106C19.2343 32.8536 19.6101 31.7286 19.9452 30.7156C20.4121 31.2298 20.9153 31.7561 21.4547 32.2954C21.6657 32.5064 22.1886 32.981 22.8852 33.5753C21.4985 33.8775 20.0231 34.2521 18.6125 34.6993ZM31.25 35.2849C31.25 35.7903 31.25 36 30.2063 36.0067C29.8998 35.9408 29.1912 35.5233 28.3166 34.9278C28.6341 34.8927 28.8681 34.8751 29 34.8751C30.6623 34.8751 31.1336 35.0376 31.25 35.2849Z"
                              fill="#999999"
                              fill-opacity="0.9"
                            />
                          </g>
                        </svg>
                      </div>
                      <div class="info-inner-lower">
                        <h4
                          class="name"
                          matTooltip="{{ poAttachment.fileName }}"
                          [matTooltipPosition]="'right'"
                        >
                          {{ poAttachment.fileName }}
                        </h4>
                      </div>
                      <div class="info-inner-lower">
                        <p matTooltip="{{ poAttachment.type }}" class="size">
                          {{ poAttachment.type }}
                        </p>
                      </div>
                      <div class="info-inner-lower">
                        <p
                          matTooltip="{{
                            poAttachment.createdOn | date : 'MMM d, y'
                          }}"
                          class="size"
                        >
                          {{ poAttachment.createdOn | date : "MMM d, y" }}
                        </p>
                      </div>
                      <div class="info-inner-lower">
                        <p matTooltip="" class="size">
                          {{ poAttachment.size }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="download-file"
                      (click)="
                        downloadFiles(poAttachment.id, poAttachment.fileName)
                      "
                    >
                      <mat-icon>save_alt</mat-icon>
                    </div>
                  </div>

                  <div
                    class="return-reason-info return_reason"
                    *ngIf="poAttachment.returnReason"
                  >
                    <div class="heading flex align-items-center">
                      <h3>Reason for return</h3>
                    </div>
                    <span *ngIf="poAttachment.returnOthers" class="info">
                      {{ poAttachment.returnOthers }}
                    </span>
                    <p class="return-reason-category">
                      {{ poAttachment.returnReason }}
                    </p>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
</ng-container>
<!-- PO returned end-->
<!-- PO accepted start -->
<ng-container *ngIf="rfqItem?.status === RFQStatus.PO_ACCEPTED && !Sendarchive">
  <div class="rfqHeader">
    <h3 matTooltip="{{ rfqItem?.projectName }}">{{ rfqItem.projectName }}</h3>
    <span class="info_bar">{{
      getRFQTemplateLabel(rfqItem?.rfqTemplate)
    }}</span>
    <span class="rfqStatus font-12 medium status" [class]="rfqItem.status">{{
      getStatusLabel(rfqItem.status)
    }}</span>
    <div class="rfqActions">
      <span class="rfqClose" (click)="closeUploadPo()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
  <div class="rfqBody">
    <div class="basicDetail">
      <div class="po-sent">
        <div
          class="po-accepted flex justify-content-between complete"
          [ngClass]="{ complete: true }"
        >
          <div class="po-sent-first-upper">
            <span><span class="check-icon">&#10003;</span> P.O. Sent</span>
          </div>
        </div>

        <div class="po-sent-inner">
          <div
            *ngFor="let poAttachment of rfqItem.attachments; let i = index"
            class="po-file"
          >
            <!-- Live PO Files -->
            <div
              *ngIf="
                poAttachment?.fileType === FileType.PO &&
                poAttachment?.fileStatus === fileStatus.Live
              "
            >
              <label>Latest P.O.</label>
              <div class="po-sent-file-detail">
                <div class="info">
                  <div class="info-inner-upper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width=""
                      height=""
                      viewBox="0 0 41 54"
                      fill="none"
                    >
                      <g opacity="0.9">
                        <path
                          d="M1.5 52.5V3L3 1.5H28L38.5 12.5V52.5H1.5Z"
                          fill="#FDFDFD"
                        />
                        <path
                          d="M40.1704 11.5796L28.9204 0.32959C28.7094 0.118652 28.4238 0 28.1249 0H4.49993C2.01814 0 0 2.01814 0 4.50004V49.5001C0 51.9819 2.01814 54 4.50004 54H36.0001C38.4819 54 40.5 51.9819 40.5 49.5V12.375C40.5 12.0762 40.3813 11.7906 40.1704 11.5796ZM29.25 3.84086L36.6591 11.25H31.4999C30.2596 11.25 29.25 10.2404 29.25 9.00007V3.84086ZM38.25 49.5C38.25 50.7403 37.2404 51.7499 36.0001 51.7499H4.50004C3.25972 51.7499 2.25007 50.7403 2.25007 49.5V4.50004C2.25007 3.25972 3.25972 2.25007 4.50004 2.25007H27V9.00007C27 11.4819 29.0181 13.5 31.5 13.5H38.25V49.5Z"
                          fill="#999999"
                          fill-opacity="0.9"
                        />
                        <path
                          d="M25.7359 33.026C24.6944 32.2064 23.7046 31.3638 23.0454 30.7047C22.1885 29.8477 21.4249 29.0172 20.7614 28.2261C21.7963 25.028 22.2501 23.379 22.2501 22.5C22.2501 18.7658 20.9009 18 18.8751 18C17.3359 18 15.5001 18.7998 15.5001 22.6077C15.5001 24.2865 16.4197 26.3244 18.2423 28.6931C17.7962 30.0542 17.2722 31.6242 16.6833 33.3941C16.3998 34.2433 16.0923 35.0299 15.767 35.7572C15.5023 35.8748 15.2452 35.9946 14.9969 36.1187C14.1026 36.5659 13.2534 36.9679 12.4656 37.3415C8.87305 39.0422 6.5 40.1672 6.5 42.3886C6.5 44.0014 8.25236 45 9.875 45C11.9668 45 15.1253 42.2061 17.4325 37.4996C19.8275 36.5548 22.8048 35.8549 25.1548 35.4166C27.0378 36.8646 29.1176 38.25 30.125 38.25C32.9144 38.25 33.5 36.6372 33.5 35.2847C33.5 32.6249 30.4611 32.6249 29 32.6249C28.5462 32.625 27.329 32.7591 25.7359 33.026ZM9.875 42.75C9.23227 42.75 8.79721 42.4468 8.74996 42.3886C8.74996 41.5909 11.1285 40.4638 13.4291 39.374C13.5752 39.3048 13.7236 39.2355 13.8741 39.1641C12.1843 41.6141 10.5133 42.75 9.875 42.75ZM17.75 22.6077C17.75 20.2501 18.4818 20.2501 18.8751 20.2501C19.6705 20.2501 20.0001 20.2501 20.0001 22.5C20.0001 22.9746 19.6837 24.1612 19.1047 26.0135C18.2213 24.6534 17.75 23.4878 17.75 22.6077ZM18.6125 34.6993C18.6828 34.5037 18.7509 34.306 18.8169 34.106C19.2343 32.8536 19.6101 31.7286 19.9452 30.7156C20.4121 31.2298 20.9153 31.7561 21.4547 32.2954C21.6657 32.5064 22.1886 32.981 22.8852 33.5753C21.4985 33.8775 20.0231 34.2521 18.6125 34.6993ZM31.25 35.2849C31.25 35.7903 31.25 36 30.2063 36.0067C29.8998 35.9408 29.1912 35.5233 28.3166 34.9278C28.6341 34.8927 28.8681 34.8751 29 34.8751C30.6623 34.8751 31.1336 35.0376 31.25 35.2849Z"
                          fill="#999999"
                          fill-opacity="0.9"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="info-inner-lower">
                    <h4
                      class="name"
                      matTooltip="{{ poAttachment.fileName }}"
                      [matTooltipPosition]="'right'"
                    >
                      {{ poAttachment.fileName }}
                    </h4>
                  </div>
                  <div class="info-inner-lower">
                    <p matTooltip="{{ poAttachment.type }}" class="size">
                      {{ poAttachment.type }}
                    </p>
                  </div>
                  <div class="info-inner-lower">
                    <p
                      matTooltip="{{
                        poAttachment.createdOn | date : 'MMM d, y'
                      }}"
                      class="size"
                    >
                      {{ poAttachment.createdOn | date : "MMM d, y" }}
                    </p>
                  </div>
                  <div class="info-inner-lower">
                    <p matTooltip="" class="size">{{ poAttachment.size }}</p>
                  </div>
                </div>
                <div
                  class="download-file"
                  (click)="
                    downloadFiles(poAttachment.id, poAttachment.fileName)
                  "
                >
                  <mat-icon>save_alt</mat-icon>
                </div>
              </div>
            </div>

            <!-- Archive PO Files -->
            <div
              *ngIf="
                poAttachment?.fileType === FileType.PO &&
                poAttachment?.fileStatus === fileStatus.Archive
              "
            >
              <label>Previous P.O.</label>
              <div class="po-sent-file-detail">
                <div class="info">
                  <div class="info-inner-upper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width=""
                      height=""
                      viewBox="0 0 41 54"
                      fill="none"
                    >
                      <g opacity="0.9">
                        <path
                          d="M1.5 52.5V3L3 1.5H28L38.5 12.5V52.5H1.5Z"
                          fill="#FDFDFD"
                        />
                        <path
                          d="M40.1704 11.5796L28.9204 0.32959C28.7094 0.118652 28.4238 0 28.1249 0H4.49993C2.01814 0 0 2.01814 0 4.50004V49.5001C0 51.9819 2.01814 54 4.50004 54H36.0001C38.4819 54 40.5 51.9819 40.5 49.5V12.375C40.5 12.0762 40.3813 11.7906 40.1704 11.5796ZM29.25 3.84086L36.6591 11.25H31.4999C30.2596 11.25 29.25 10.2404 29.25 9.00007V3.84086ZM38.25 49.5C38.25 50.7403 37.2404 51.7499 36.0001 51.7499H4.50004C3.25972 51.7499 2.25007 50.7403 2.25007 49.5V4.50004C2.25007 3.25972 3.25972 2.25007 4.50004 2.25007H27V9.00007C27 11.4819 29.0181 13.5 31.5 13.5H38.25V49.5Z"
                          fill="#999999"
                          fill-opacity="0.9"
                        />
                        <path
                          d="M25.7359 33.026C24.6944 32.2064 23.7046 31.3638 23.0454 30.7047C22.1885 29.8477 21.4249 29.0172 20.7614 28.2261C21.7963 25.028 22.2501 23.379 22.2501 22.5C22.2501 18.7658 20.9009 18 18.8751 18C17.3359 18 15.5001 18.7998 15.5001 22.6077C15.5001 24.2865 16.4197 26.3244 18.2423 28.6931C17.7962 30.0542 17.2722 31.6242 16.6833 33.3941C16.3998 34.2433 16.0923 35.0299 15.767 35.7572C15.5023 35.8748 15.2452 35.9946 14.9969 36.1187C14.1026 36.5659 13.2534 36.9679 12.4656 37.3415C8.87305 39.0422 6.5 40.1672 6.5 42.3886C6.5 44.0014 8.25236 45 9.875 45C11.9668 45 15.1253 42.2061 17.4325 37.4996C19.8275 36.5548 22.8048 35.8549 25.1548 35.4166C27.0378 36.8646 29.1176 38.25 30.125 38.25C32.9144 38.25 33.5 36.6372 33.5 35.2847C33.5 32.6249 30.4611 32.6249 29 32.6249C28.5462 32.625 27.329 32.7591 25.7359 33.026ZM9.875 42.75C9.23227 42.75 8.79721 42.4468 8.74996 42.3886C8.74996 41.5909 11.1285 40.4638 13.4291 39.374C13.5752 39.3048 13.7236 39.2355 13.8741 39.1641C12.1843 41.6141 10.5133 42.75 9.875 42.75ZM17.75 22.6077C17.75 20.2501 18.4818 20.2501 18.8751 20.2501C19.6705 20.2501 20.0001 20.2501 20.0001 22.5C20.0001 22.9746 19.6837 24.1612 19.1047 26.0135C18.2213 24.6534 17.75 23.4878 17.75 22.6077ZM18.6125 34.6993C18.6828 34.5037 18.7509 34.306 18.8169 34.106C19.2343 32.8536 19.6101 31.7286 19.9452 30.7156C20.4121 31.2298 20.9153 31.7561 21.4547 32.2954C21.6657 32.5064 22.1886 32.981 22.8852 33.5753C21.4985 33.8775 20.0231 34.2521 18.6125 34.6993ZM31.25 35.2849C31.25 35.7903 31.25 36 30.2063 36.0067C29.8998 35.9408 29.1912 35.5233 28.3166 34.9278C28.6341 34.8927 28.8681 34.8751 29 34.8751C30.6623 34.8751 31.1336 35.0376 31.25 35.2849Z"
                          fill="#999999"
                          fill-opacity="0.9"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="info-inner-lower">
                    <h4
                      class="name"
                      matTooltip="{{ poAttachment.fileName }}"
                      [matTooltipPosition]="'right'"
                    >
                      {{ poAttachment.fileName }}
                    </h4>
                  </div>
                  <div class="info-inner-lower">
                    <p matTooltip="{{ poAttachment.type }}" class="size">
                      {{ poAttachment.type }}
                    </p>
                  </div>
                  <div class="info-inner-lower">
                    <p
                      matTooltip="{{
                        poAttachment.createdOn | date : 'MMM d, y'
                      }}"
                      class="size"
                    >
                      {{ poAttachment.createdOn | date : "MMM d, y" }}
                    </p>
                  </div>
                  <div class="info-inner-lower">
                    <p matTooltip="" class="size">{{ poAttachment.size }}</p>
                  </div>
                </div>
                <div
                  class="download-file"
                  (click)="
                    downloadFiles(poAttachment.id, poAttachment.fileName)
                  "
                >
                  <mat-icon>save_alt</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="po-pending" [ngClass]="{ complete: true }">
          <span><span class="check-icon">&#10003;</span>P.O. Accepted</span>
        </div>
      </div>
    </div>
    <div *ngIf="rfqItem?.createdByShop">
      <lib-line-items
        [custRfqId]="custRfqId"
        [baseUrl]="baseUrl"
      ></lib-line-items>
    </div>
  </div>
</ng-container>
<!-- PO accepted end-->
